export default {
  "pages.layouts.userLayout.title":
    "Ant Design 是西湖区最具影响力的 Web 设计规范",
  "pages.dashboard.overview.title": "数据总览",
  "pages.dashboard.overview.betUserCount": "下注人数",
  "pages.dashboard.overview.betCount": "下注次数",
  "pages.dashboard.overview.betAmount": "下注金额",
  "pages.dashboard.overview.ggr": "GGR",
  "pages.dashboard.overview.avgBetCountPerUser": "人均下注次数",
  "pages.dashboard.overview.avgBetAmountPerUser": "平均下注金额(人)",
  "pages.dashboard.overview.today": "今日",
  "pages.dashboard.overview.yesterday": "昨日",
  "pages.dashboard.overview.total": "总计",
  "pages.dashboard.chart.twoDayAgo": "前日",
  "pages.dashboard.userData.title": "用户数据",
  "pages.dashboard.userData.tab.last7Days": "近7天",
  "pages.dashboard.userData.tab.last15Days": "近15天",
  "pages.dashboard.userData.tab.last30Days": "近30天",
  "pages.dashboard.userData.empty": "暂无用户数据",
  "pages.dashboard.top10.tab.today": "今天",
  "pages.dashboard.top10.tab.yesterday": "昨天",
  "pages.dashboard.top10.tab.twoDayAgo": "前天",
  "pages.dashboard.top10.metric.betAmount": "下注金额",
  "pages.dashboard.top10.metric.betCount": "下注次数",
  "pages.dashboard.top10.metric.betUserCount": "下注人数",
  "pages.dashboard.top10.metric.ggr": "GGR",
  "pages.dashboard.top10.empty": "暂无 Top10 数据",
  "pages.dashboard.top10.unknownMerchant": "商户{index}",
  "pages.dashboard.onlineStats.title": "在线统计",
  "pages.dashboard.onlineStats.tab.visitUsers": "访问用户",
  "pages.dashboard.onlineStats.tab.betUsers": "投注用户",
  "pages.dashboard.onlineStats.empty": "暂无趋势数据",
  "pages.dashboard.onlineStats.filter.game": "游戏筛选",
  "pages.dashboard.onlineStats.filter.merchant": "商户筛选",
  "pages.dashboard.betStats.title": "下注统计",
  "pages.dashboard.betStats.tab.betAmount": "下注金额",
  "pages.dashboard.betStats.tab.betCount": "下注次数",
  "pages.dashboard.betStats.empty": "暂无下注数据",
  "pages.dashboard.betUserRatio.title": "下注用户占比",
  "pages.dashboard.betUserRatio.tab.amount": "金额",
  "pages.dashboard.betUserRatio.tab.count": "用户数",
  "pages.dashboard.betUserRatio.empty": "暂无占比数据",
  "pages.dashboard.chart.newVisits": "新增访问",
  "pages.dashboard.chart.newBets": "新增下注",
  "pages.dashboard.chart.totalVisits": "累计访问",
  "pages.dashboard.chart.totalBets": "累计下注",
  "pages.dashboard.chart.newUser": "新用户",
  "pages.dashboard.chart.oldUser": "老用户",
  "pages.dashboard.time.minutesAgo": "{minutes} 分钟前",
  "pages.dashboard.time.hoursAgo": "{hours} 小时前",
  "pages.dashboard.time.daysAgo": "{days} 天前",
  "pages.dashboard.error.fetchFailed": "获取概况总览失败",
  "pages.dashboard.gameTop10": "游戏 Top10",
  "pages.dashboard.merchantTop10": "商户 Top10",
  "pages.dashboard.riskAlerts.title": "风控预警监控",
  "pages.dashboard.riskAlerts.extra": "最近告警",
  "pages.dashboard.riskAlerts.empty": "暂无预警数据",

  "pages.dashboard.announcement.title": "公告",
  "pages.dashboard.announcement.empty": "暂无公告",
  "pages.dashboard.announcement.detail.title": "公告详情",

  // 登录页
  "pages.login.accountLogin.tab": "账户密码登录",
  "pages.login.accountLogin.errorMessage": "错误的用户名和密码",
  "pages.login.failure": "登录失败，请重试！",
  "pages.login.success": "登录成功！",
  "pages.login.username.placeholder": "用户名",
  "pages.login.username.required": "请输入用户名!",
  "pages.login.password.placeholder": "密码",
  "pages.login.password.required": "请输入密码!",
  "pages.login.rememberMe": "记住账号密码",
  "pages.login.submit": "登录",
  "pages.login.submit.google": "验证并登录",
  "pages.login.google.title": "Google 验证码",
  "pages.login.google.placeholder": "Google 验证码",
  "pages.login.google.required": "请输入 Google 验证码!",
  "pages.login.google.tip.input": "请输入 Google 验证码",
  "pages.login.google.tip.bind": "请绑定 Google 验证码",
  "pages.login.google.alert.input":
    "账户校验通过，请输入 Google 验证码完成登录",
  "pages.login.google.alert.bind":
    "账户校验通过，请先扫描下方二维码绑定 Google 验证码",
  "pages.login.google.scan": "请使用 Google Authenticator 扫描",
  "pages.login.google.back": "返回账户登录",
  "pages.login.error.exception": "登录异常，请稍后重试",
  "pages.login.error.verify": "验证失败，请重新输入",
  "pages.login.error.operation": "操作失败，请重试！",
  "pages.login.error.tokenNotFound": "未找到登录 token",
  "pages.login.redirecting": "将于 {countdown} 秒后跳转到首页",
  "pages.login.loading": "正在登录...",
  "pages.login.title": "登录页 - Croco Manage",
  "pages.login.subTitle": "游戏管理系统",
  "pages.login.subTitle.platform": "平台",
  "pages.login.subTitle.merchant": "商户",
  "pages.login.loginWith": "其他登录方式 :",
  "pages.login.registerAccount": "注册账户",

  // 商户管理 - 商户申请
  "pages.merchant.apply.list.title": "商户申请",
  "pages.merchant.apply.filter.applyTime": "申请时间",
  "pages.merchant.apply.filter.all": "全部",
  "pages.merchant.apply.filter.keywords": "商户",
  "pages.merchant.apply.filter.keywords.placeholder": "输入商户名称或ID",
  "pages.merchant.apply.filter.walletMode.placeholder": "选择钱包类型",
  "pages.merchant.apply.filter.reviewStatus": "审核状态",
  "pages.merchant.apply.filter.reviewStatus.placeholder": "选择审核状态",
  "pages.merchant.apply.status.pendingSubmit": "待提交",
  "pages.merchant.apply.status.reviewing": "审核中",
  "pages.merchant.apply.status.approved": "已通过",
  "pages.merchant.apply.status.rejected": "已拒绝",
  "pages.merchant.apply.statusValue.1": "待提交",
  "pages.merchant.apply.statusValue.2": "审核中",
  "pages.merchant.apply.statusValue.3": "已通过",
  "pages.merchant.apply.statusValue.4": "已拒绝",
  "pages.merchant.apply.column.id": "ID",
  "pages.merchant.apply.column.operatorName": "商户/代理名称",
  "pages.merchant.apply.column.appid": "APPID",
  "pages.merchant.apply.column.agentLevel": "代理等级",
  "pages.merchant.apply.column.parentOperatorName": "上级运营商",
  "pages.merchant.apply.column.applyAdminName": "申请人",
  "pages.merchant.apply.column.applyAdminUserName": "申请人账号",
  "pages.merchant.apply.column.contactInformation": "联系方式",
  "pages.merchant.apply.column.reviewStatus": "审核状态",
  "pages.merchant.apply.column.handlerName": "处理人",
  "pages.merchant.apply.column.reviewComments": "审核意见",
  "pages.merchant.apply.column.applyTime": "申请时间",
  "pages.merchant.apply.column.processingTime": "处理时间",
  "pages.merchant.apply.column.operation": "操作",
  "pages.merchant.apply.action.detail": "查看详情",
  "pages.merchant.apply.action.approve": "通过",
  "pages.merchant.apply.action.reject": "拒绝",
  "pages.merchant.apply.detail.title": "商户入驻申请",
  "pages.merchant.apply.detail.title.agent": "代理入驻申请",
  "pages.merchant.apply.detail.section.content": "提交内容",
  "pages.merchant.apply.detail.field.orderNo": "单号",
  "pages.merchant.apply.detail.field.applicant": "申请人",
  "pages.merchant.apply.detail.field.applicantName": "申请人姓名",
  "pages.merchant.apply.detail.field.applicantAffiliation": "申请人归属",
  "pages.merchant.apply.detail.field.createdAt": "提交时间",
  "pages.merchant.apply.detail.field.merchantName": "商户名称",
  "pages.merchant.apply.detail.field.loginPassword": "登录密码",
  "pages.merchant.apply.detail.field.remark": "备注",
  "pages.merchant.apply.detail.field.contactEmail": "联系邮箱",
  "pages.merchant.apply.detail.field.fee": "费率",
  "pages.merchant.apply.detail.field.parent": "直属上级",
  "pages.merchant.apply.detail.field.manager": "负责人",
  "pages.merchant.apply.detail.field.walletMode": "钱包类型",
  "pages.merchant.apply.detail.field.status": "状态",
  "pages.merchant.apply.detail.field.loginAccount": "登录账号",
  "pages.merchant.apply.detail.field.ipWhitelist": "IP白名单",
  "pages.merchant.apply.detail.field.openGames": "开通游戏",
  "pages.merchant.apply.action.approve.title": "确认通过申请",
  "pages.merchant.apply.action.reject.title": "确认拒绝申请",
  "pages.merchant.apply.action.approve.description":
    "您正在处理单号 {id} 的商户入驻申请",
  "pages.merchant.apply.action.reject.description":
    "您正在处理单号 {id} 的商户入驻申请",
  "pages.merchant.apply.action.approve.placeholder": "请填写通过原因，选填",
  "pages.merchant.apply.action.reject.placeholder": "请填写拒绝原因，选填",
  "pages.merchant.apply.message.approveMissingId": "缺少申请单ID，无法提交通过",
  "pages.merchant.apply.message.rejectMissingId": "缺少申请单ID，无法提交拒绝",
  "pages.merchant.apply.message.approveSuccess": "审核通过成功",
  "pages.merchant.apply.message.approveFailed": "审核通过失败",
  "pages.merchant.apply.message.rejectSuccess": "拒绝成功",
  "pages.merchant.apply.message.rejectFailed": "拒绝失败",
  "pages.merchant.review.column.operatorName": "商户/代理名称",
  "pages.merchant.review.list.title": "商户发布审核",
  "pages.merchant.review.detail.title": "商户待发布详情",
  "pages.merchant.review.detail.title.agent": "代理待发布详情",
  "pages.merchant.review.status.pendingRelease": "待发布",
  "pages.merchant.review.action.edit": "编辑",
  "pages.merchant.review.action.publish": "发布",
  "pages.merchant.review.drawer.title.merchant": "编辑商户草稿",
  "pages.merchant.review.drawer.title.agent": "编辑代理草稿",
  "pages.merchant.review.confirm.publish.title": "确认提交发布审核？",
  "pages.merchant.review.confirm.publish.content":
    "提交审核后，该配置草稿进入“审核中”状态，由平台人员进行审核。在此期间您将无法再次修改该配置。",
  "pages.merchant.review.message.publishMissingId": "缺少申请单ID，无法发布",
  "pages.merchant.review.message.publishSuccess": "发布成功",
  "pages.merchant.review.message.publishFailed": "发布失败",

  // 手动结算
  "pages.merchant.settle.list.title": "手动结单",
  "pages.merchant.settle.filter.merchant": "商户",
  "pages.merchant.settle.filter.game": "游戏",
  "pages.merchant.settle.filter.status": "状态",
  "pages.merchant.settle.filter.orderId": "订单ID",
  "pages.merchant.settle.filter.orderId.placeholder": "输入下注ID",
  "pages.merchant.settle.filter.dateRange": "时间范围",
  "pages.merchant.settle.column.parentId": "下注ID",
  "pages.merchant.settle.column.merchantName": "商户名称",
  "pages.merchant.settle.column.roleId": "用户ID",
  "pages.merchant.settle.column.gameName": "游戏名称",
  "pages.merchant.settle.column.currency": "币种",
  "pages.merchant.settle.column.betAmount": "下注金额",
  "pages.merchant.settle.column.scoreAmount": "返奖金额",
  "pages.merchant.settle.column.remark": "备注",
  "pages.merchant.settle.column.status": "状态",
  "pages.merchant.settle.column.adminId": "操作人",
  "pages.merchant.settle.column.createdAt": "操作时间",
  "pages.merchant.settle.column.settleTime": "结单时间",
  "pages.merchant.settle.status.reviewing": "审核中",
  "pages.merchant.settle.status.published": "已发布",
  "pages.merchant.settle.status.rejected": "已拒绝",
  "pages.merchant.settle.status.pendingExecute": "未执行",
  "pages.merchant.settle.status.executed": "已执行",
  "pages.merchant.settle.action.detail": "详情",
  "pages.merchant.settle.action.manualSettle": "手动结单",
  "pages.merchant.settle.action.retry": "重新结单",
  "pages.merchant.settle.column.action": "操作",
  "pages.merchant.settle.retry.success": "重试成功",
  "pages.merchant.settle.retry.confirm.title": "确认重新结单",
  "pages.merchant.settle.retry.confirm.content":
    "手动结单未成功，请点击「重新结单」按钮，重新执行结单操作。此次操作无需审核",
  "pages.merchant.settle.retry.confirm.operator": "操作人：",
  "pages.merchant.settle.modal.title": "手动结单",
  "pages.merchant.settle.modal.parentId": "订单ID",
  "pages.merchant.settle.modal.parentId.placeholder": "请输入下注ID",
  "pages.merchant.settle.modal.parentId.required": "请输入订单ID",
  "pages.merchant.settle.modal.remark": "备注",
  "pages.merchant.settle.modal.remark.placeholder": "请输入备注信息",
  "pages.merchant.settle.modal.missingTicket": "缺少谷歌验证票据",
  "pages.merchant.settle.modal.success.review": "确认结单成功",
  "pages.merchant.settle.modal.success.submit": "提交手动结单审核成功",
  "pages.merchant.settle.detail.title": "订单详情",
  "pages.merchant.settle.detail.receiptId": "收据ID",
  "pages.merchant.settle.detail.betLevel": "下注级别",
  "pages.merchant.settle.detail.orderStatus": "订单状态",
  "pages.merchant.settle.detail.orderStatus.0": "进行中",
  "pages.merchant.settle.detail.orderStatus.1": "已完成",
  "pages.merchant.settle.detail.surplusCoin": "剩余金币",
  "pages.merchant.settle.detail.exchangeRate": "汇率",
  "pages.merchant.settle.detail.currencyMult": "货币倍数",
  "pages.merchant.settle.detail.roundEnd": "回合结束",
  "pages.merchant.settle.detail.configVersion": "配置版本",
  "pages.merchant.settle.detail.countryCode": "国家代码",
  "pages.merchant.settle.detail.region": "地区",
  "pages.merchant.settle.detail.ip": "IP",
  "pages.merchant.settle.detail.createDatetime": "创建时间",
  "pages.merchant.settle.detail.buyBonusType": "游戏模式",

  // 商户管理 - 成员列表
  "pages.merchant.members.id": "商户ID",
  "pages.merchant.members.appid": "AppID",
  "pages.merchant.members.name": "商户名称",
  "pages.merchant.members.manager": "负责人",
  "pages.merchant.members.contact": "联系方式",
  "pages.merchant.members.level": "层级",
  "pages.merchant.members.level.tooltip":
    "一级代理：树下可添加二级代理或直属商户，无法开通游戏\n二级代理：树下可添加商户，无法开通游戏\n商户：层级最低，可开通游戏",
  "pages.merchant.members.level.1": "一级代理",
  "pages.merchant.members.level.2": "二级代理",
  "pages.merchant.members.level.normal": "普通商户",
  "pages.merchant.members.walletMode": "钱包类型",
  "pages.merchant.members.walletMode.single": "单钱包模式",
  "pages.merchant.members.walletMode.transfer": "转账模式",
  "pages.merchant.members.currencyRatio": "货币比例",
  "pages.merchant.members.currencyRatio.tooltip":
    "以实时汇率为基准，满足各商户货币实际价值，默认为1:1。\n以USD为例，设置某商户货币比例为1：100，及货币价值为1USD/100，即0.01USD",
  "pages.merchant.members.currencyRatioModal.title": "货币比例",
  "pages.merchant.members.currencyRatioModal.subtitle":
    "正在为商户 {name} 配置货币比例",
  "pages.merchant.members.currencyRatioModal.form.label": "*设置比例",
  "pages.merchant.members.currencyRatioModal.showModifiedOnly": "只显示修改",
  "pages.merchant.members.currencyRatioModal.resetAll": "重置所有为1:1",
  "pages.merchant.members.currencyRatioModal.noModified": "暂无修改",
  "pages.merchant.members.currencyRatioModal.tip":
    "以实时汇率为基准，满足各商户货币实际价值，默认为1:1。(货币比例只能填整数)\n以USD为例，设置某商户货币比例为1:100，及货币价值为1USD/100，即0.01USD",
  "pages.merchant.members.currencyRatioModal.success": "货币比例设置成功",
  "pages.merchant.members.currencyRatioModal.loadFailed": "货币比例加载失败",
  "pages.merchant.members.currencyRatioModal.apply.title": "应用其他商户",
  "pages.merchant.members.currencyRatioModal.apply.selectedCount":
    "已选（{selected}/{total}）商户",
  "pages.merchant.members.currencyRatioModal.apply.selectAll": "全部选择",
  "pages.merchant.members.currencyRatioModal.apply.cancelAll": "全部取消",
  "pages.merchant.members.currencyRatioModal.apply.desc":
    "应用至同代理下其他商户",
  "pages.merchant.members.currencyRatioModal.apply.empty":
    "当前用户下暂无可应用的其他商户",
  "pages.merchant.members.currencyRatioModal.apply.tip":
    "*选中的商户将被该货币比例配置覆盖",
  "pages.merchant.members.fee": "分成比例",
  "pages.merchant.members.fee.tooltip":
    "分成比例:商户可获得的分成。\n下级分成比例跟随上级，若一级代理为90%，其树下所有二级代理、商户均为90%",
  "pages.merchant.members.childrenCount": "下级数量",
  "pages.merchant.members.childrenCount.tooltip":
    "下级数量计算方式\n一级代理：计算二级代理+商户的总和\n二级代理：仅计算商户数",
  "pages.merchant.members.createdAt": "创建时间",
  "pages.merchant.members.status": "状态",
  "pages.merchant.members.option": "操作",
  "pages.merchant.members.search.placeholder": "请输入ID或名称",
  "pages.merchant.members.search.title": "搜索商户",
  "pages.merchant.members.list.title": "商户与代理列表",
  "pages.merchant.members.list.stats":
    "（一级代理: {agent1Count}  二级代理: {agent2Count}  商户: {merchantCount}）",
  "pages.merchant.members.list.selected": "已选 {count} 项",
  "pages.merchant.members.action.batchEnable": "批量启用",
  "pages.merchant.members.action.batchDisable": "批量禁用",
  "pages.merchant.members.action.cancelSelection": "取消选择",
  "pages.merchant.members.action.addAgent": "添加代理",
  "pages.merchant.members.action.addMerchant": "添加商户",
  "pages.merchant.members.action.batchAdd": "批量添加",
  "pages.merchant.members.action.export": "导出商户",
  "pages.merchant.members.hallSwitch": "大厅开启状态",
  "pages.merchant.members.hallSwitch.enabled": "已开启",
  "pages.merchant.members.hallSwitch.disabled": "未开启",
  "pages.merchant.members.action.hallConfig": "大厅配置",
  "pages.merchant.members.hallConfig.title": "大厅配置",
  "pages.merchant.members.hallConfig.save": "保存并发布",
  "pages.merchant.members.hallConfig.loadFailed": "大厅配置加载失败，请重试",
  "pages.merchant.members.hallConfig.saveSuccess": "大厅配置保存成功",
  "pages.merchant.members.hallConfig.reviewPending":
    "已有配置待提交，无法进行修改操作",
  "pages.merchant.members.hallConfig.section.switch": "开启游戏与模块",
  "pages.merchant.members.hallConfig.section.activity": "Event配置",
  "pages.merchant.members.hallConfig.section.game": "Games配置",
  "pages.merchant.members.hallConfig.switch.hall": "大厅总开关",
  "pages.merchant.members.hallConfig.switch.hallHint":
    "关闭后，玩家在游玩该商户游戏时将不会呼出大厅UI",
  "pages.merchant.members.hallConfig.switch.activity": "Event模块",
  "pages.merchant.members.hallConfig.switch.activityHint":
    "展示正在开启的活动游戏、倒计时及特权角标",
  "pages.merchant.members.hallConfig.switch.game": "Games模块",
  "pages.merchant.members.hallConfig.switch.gameHint":
    "展示商户已开通的全部游戏，可快速跳转",
  "pages.merchant.members.hallConfig.activity.column.type": "活动类型",
  "pages.merchant.members.hallConfig.activity.column.gameName": "游戏名称",
  "pages.merchant.members.hallConfig.activity.column.name": "活动名称",
  "pages.merchant.members.hallConfig.activity.column.time": "活动时间",
  "pages.merchant.members.hallConfig.activity.column.badge": "活动角标",
  "pages.merchant.members.hallConfig.game.column.name": "游戏",
  "pages.merchant.members.hallConfig.game.column.badge": "游戏角标",
  "pages.merchant.members.hallConfig.column.weight": "权重",
  "pages.merchant.members.hallConfig.column.visible": "是否可见",
  "pages.merchant.members.hallConfig.badge.placeholder": "请选择角标",
  "pages.merchant.members.hallConfig.activityType.cumulative": "累计",
  "pages.merchant.members.hallConfig.activityType.sevenDay": "7日",
  "pages.merchant.members.hallConfig.activityType.surprise": "惊喜",
  "pages.merchant.members.hallConfig.empty": "暂无配置数据",
  "pages.merchant.members.edit.title.edit": "编辑商户",
  "pages.merchant.members.edit.title.add": "添加商户",
  "pages.merchant.members.edit.form.merchantName": "商户名称",
  "pages.merchant.members.edit.form.merchantName.required": "请输入商户名称",
  "pages.merchant.members.edit.form.manager": "负责人",
  "pages.merchant.members.edit.form.manager.required": "请输入负责人",
  "pages.merchant.members.edit.form.email": "联系邮箱",
  "pages.merchant.members.edit.form.email.required": "请输入联系邮箱",
  "pages.merchant.members.edit.form.email.invalid": "请输入正确的邮箱格式",
  "pages.merchant.members.edit.form.username": "登录账号",
  "pages.merchant.members.edit.form.username.required": "请输入登录账号",
  "pages.merchant.members.edit.form.password": "登录密码",
  "pages.merchant.members.edit.form.password.required": "请输入登录密码",
  "pages.merchant.members.edit.form.parent": "上级",
  "pages.merchant.members.edit.form.parent.placeholder": "请选择(单选)",
  "pages.merchant.members.edit.form.walletType": "钱包类型",
  "pages.merchant.members.edit.form.walletType.required": "请选择钱包类型",
  "pages.merchant.members.edit.form.walletType.transfer": "转账模式",
  "pages.merchant.members.edit.form.walletType.single": "单钱包模式",
  "pages.merchant.members.edit.form.incomeShare": "收入分成(%)",
  "pages.merchant.members.edit.form.feeRate": "费率(%)",
  "pages.merchant.members.edit.form.serverAddress": "服务器地址",
  "pages.merchant.members.edit.form.serverAddress.required": "请输入服务器地址",
  "pages.merchant.members.edit.form.serverAddress.placeholder":
    "请输入IP地址或域名",
  "pages.merchant.members.edit.form.serverAddress.invalid":
    "请输入正确的IP地址或域名格式",
  "pages.merchant.members.edit.form.serverRegion": "服务器地区",
  "pages.merchant.members.edit.form.serverRegion.placeholder":
    "请选择服务器地区",
  "pages.merchant.members.edit.form.serverRegion.required": "请选择服务器地区",
  "pages.merchant.members.edit.form.ipWhitelist": "IP白名单",
  "pages.merchant.members.edit.form.ipWhitelist.placeholder": "请输入IP地址",
  "pages.merchant.members.edit.form.ip.required": "请输入IP地址",
  "pages.merchant.members.edit.form.ip.invalid": "请输入正确的IP格式",
  "pages.merchant.members.edit.form.remark": "备注",
  "pages.merchant.members.edit.form.groupDailySwitch": "群日报",
  "pages.merchant.members.edit.form.groupDailySwitch.tip":
    "开启后，在群内发送该渠道下游戏的风控记录",
  "pages.merchant.members.edit.form.groupDailySwitch.enabled": "开启",
  "pages.merchant.members.edit.form.groupDailySwitch.disabled": "关闭",
  "pages.merchant.members.edit.form.forceSettlement": "自动结单",
  "pages.merchant.members.edit.form.forceSettlement.open": "开启",
  "pages.merchant.members.edit.form.forceSettlement.close": "关闭",
  "pages.merchant.members.edit.form.status": "状态",
  "pages.merchant.members.edit.form.status.required": "请选择状态",
  "pages.merchant.members.edit.form.status.normal": "正常",
  "pages.merchant.members.edit.form.status.frozen": "被冻结",
  "pages.merchant.members.edit.form.placeholder": "请输入",
  "pages.merchant.members.edit.message.updateSuccess": "更新成功",
  "pages.merchant.members.edit.message.addSuccess":
    "保存成功，可前往入驻申请提交发布。待平台审核成功后即创建成功",
  "pages.merchant.members.edit.action.saveDraft": "保存草稿",
  "pages.merchant.members.edit.message.operationSuccess": "操作成功",
  "pages.merchant.members.apply.action.saveAndPublish": "保存并发布",
  "pages.merchant.members.apply.message.submitSuccess":
    "发布成功，可前往入驻申请查看审核状态",
  "pages.merchant.members.edit.message.hierarchyChanged":
    "修改成功，已添加至“{name}”树下",
  "pages.merchant.members.create.step.basic": "基础信息",
  "pages.merchant.members.create.step.games": "开通游戏",
  "pages.merchant.members.create.error.missingAppid":
    "新增商户成功，但未获取到商户 appid，无法继续开通游戏",
  "pages.merchant.members.gameConfig.title": "开通游戏 - {merchantName}",
  "pages.merchant.members.gameConfig.selectedCount": "已选 {count} 项",
  "pages.merchant.members.gameConfig.batchEnable": "批量开启",
  "pages.merchant.members.gameConfig.batchDisable": "批量关闭",
  "pages.merchant.members.gameConfig.confirm.titleAll": "确认关闭所有游戏？",
  "pages.merchant.members.gameConfig.confirm.title": "确认关闭游戏？",
  "pages.merchant.members.gameConfig.confirm.contentAll":
    "关闭游戏后，该商户将无法获得所有游戏资源，导致前端用户无法正常下注。请谨慎操作！",
  "pages.merchant.members.gameConfig.confirm.content":
    "关闭游戏后，该商户将无法获得该游戏资源，导致前端用户无法正常下注。请谨慎操作！",
  "pages.merchant.members.gameConfig.success": "游戏配置更新成功",
  "pages.merchant.members.gameConfig.saveConfirm.title": "确认保存",
  "pages.merchant.members.gameConfig.saveConfirm.content":
    "确定要保存当前的游戏配置吗？",
  "pages.merchant.members.gameConfig.searchHint":
    '列表中的开关修改后，需点击右上角 "确定" 按钮方可生效。',
  "pages.merchant.members.gameConfig.loadFailed": "游戏列表加载失败，请重试",
  "pages.merchant.members.gameConfig.risk.entry": "风控阈值",
  "pages.merchant.members.gameConfig.risk.emptySetting": "设置风控阈值",
  "pages.merchant.members.gameConfig.risk.tooltip":
    "单笔最大金额 / 最大随机次数 / 新手奖池单笔风控金额",
  "pages.merchant.members.gameConfig.risk.title": "风控阈值",
  "pages.merchant.members.gameConfig.risk.success": "风控阈值更新成功",
  "pages.merchant.members.gameConfig.risk.confirm.title": "确认保存",
  "pages.merchant.members.gameConfig.risk.confirm.content":
    "风控阈值修改保存后立即生效。确认保存当前配置？",
  "pages.merchant.members.gameConfig.risk.loadFailed":
    "风控阈值加载失败，请重试",
  "pages.merchant.members.gameConfig.risk.partialSuccess":
    "当前商户已保存，以下商户同步失败：{merchants}",
  "pages.merchant.members.gameConfig.risk.currentMerchant": "当前商户",
  "pages.merchant.members.gameConfig.risk.currentGame": "当前游戏",
  "pages.merchant.members.gameConfig.risk.currentAgent": "所属代理",
  "pages.merchant.members.gameConfig.risk.group.global": "全局风控阈值",
  "pages.merchant.members.gameConfig.risk.group.global.desc":
    "配置游戏通用风控阈值，保存后立即对当前商户生效。",
  "pages.merchant.members.gameConfig.risk.group.special": "特殊风控阈值",
  "pages.merchant.members.gameConfig.risk.group.special.desc":
    "用于覆盖特殊场景下的风控限制，未填写则沿用全局配置。",
  "pages.merchant.members.gameConfig.risk.special.deadGameRiskThreshold":
    "小游戏3模式风控",
  "pages.merchant.members.gameConfig.risk.special.deadGameReSpinTimes":
    "随机次数",
  "pages.merchant.members.gameConfig.risk.special.maxWinThreshold":
    "MaxWin风控",
  "pages.merchant.members.gameConfig.risk.special.reSpinTimes": "随机次数",
  "pages.merchant.members.gameConfig.risk.special.flyThreshold": "飞行模式风控",
  "pages.merchant.members.gameConfig.risk.special.game1Threshold":
    "小游戏1风控",
  "pages.merchant.members.gameConfig.risk.group.jackpot":
    "新手奖池单笔风控金额",
  "pages.merchant.members.gameConfig.risk.group.jackpot.desc":
    "用于控制新手奖池相关的风险阈值，支持独立配置。",
  "pages.merchant.members.gameConfig.risk.field.singleMaxAmount":
    "单笔最大金额",
  "pages.merchant.members.gameConfig.risk.field.singleMaxAmount.desc":
    "限制单次下注可触发的最大金额。",
  "pages.merchant.members.gameConfig.risk.field.maxRandomTimes": "最大随机次数",
  "pages.merchant.members.gameConfig.risk.field.maxRandomTimes.desc":
    "限制一次流程中允许的最大随机次数（建议值:20,建议最大不超过50）。",
  "pages.merchant.members.gameConfig.risk.field.moreInfo": "特殊风控阈值",
  "pages.merchant.members.gameConfig.risk.field.newPlayerThreshold":
    "新手奖池单笔风控金额",
  "pages.merchant.members.gameConfig.risk.unit.amount": "金额",
  "pages.merchant.members.gameConfig.risk.unit.times": "次",
  "pages.merchant.members.gameConfig.risk.apply.title":
    "应用至同代理下其他商户",
  "pages.merchant.members.gameConfig.risk.apply.desc":
    "勾选后，保存时会将当前风控阈值同步应用到所选商户，未勾选商户不受影响。",
  "pages.merchant.members.gameConfig.risk.apply.keepGameConfig":
    "批量同步仅更新风控阈值，不会覆盖各商户原有的开通游戏配置。",
  "pages.merchant.members.gameConfig.risk.apply.selectedCount":
    "已选（{selected}/{total}）商户",
  "pages.merchant.members.gameConfig.risk.apply.selectAll": "全部选择",
  "pages.merchant.members.gameConfig.risk.apply.cancelAll": "全部取消",
  "pages.merchant.members.gameConfig.risk.apply.empty":
    "当前用户下暂无可应用的其他商户",
  "pages.merchant.members.gameConfig.newPlayer.entry": "新手奖池配置",
  "pages.merchant.members.gameConfig.newPlayer.emptySetting": "设置新手奖池",
  "pages.merchant.members.gameConfig.newPlayer.tooltip":
    "剩余奖池金额 / 初始奖池金额",
  "pages.merchant.members.gameConfig.newPlayer.title": "新手奖池配置",
  "pages.merchant.members.gameConfig.newPlayer.loadFailed":
    "新手奖池配置加载失败，请重试",
  "pages.merchant.members.gameConfig.newPlayer.success": "新手奖池配置保存成功",
  "pages.merchant.members.gameConfig.newPlayer.submitFailed":
    "新手奖池配置提交失败，请重试",
  "pages.merchant.members.gameConfig.newPlayer.confirm.title": "确认提交",
  "pages.merchant.members.gameConfig.newPlayer.confirm.content":
    "新手奖池配置需要审核人审核通过后，修改内容才能正式生效。确认提交本次申请？",
  "pages.merchant.members.gameConfig.newPlayer.currentMerchant": "当前商户",
  "pages.merchant.members.gameConfig.newPlayer.currentGame": "当前游戏",
  "pages.merchant.members.gameConfig.newPlayer.currentAgent": "所属代理",
  "pages.merchant.members.gameConfig.newPlayer.copy.action": "复制上一次配置",
  "pages.merchant.members.gameConfig.newPlayer.copy.empty":
    "暂无可复制的上一份配置",
  "pages.merchant.members.gameConfig.newPlayer.copy.success":
    "已复制上一次配置",
  "pages.merchant.members.gameConfig.newPlayer.copy.confirm.title":
    "确认覆盖当前配置",
  "pages.merchant.members.gameConfig.newPlayer.copy.confirm.content":
    "当前表单已有内容，确认后将使用上一次保存的配置覆盖当前输入。",
  "pages.merchant.members.gameConfig.newPlayer.group.core": "奖池基础设置",
  "pages.merchant.members.gameConfig.newPlayer.group.nextDayJackpot":
    "次日奖池金额",
  "pages.merchant.members.gameConfig.newPlayer.group.trigger": "触发概率与维持",
  "pages.merchant.members.gameConfig.newPlayer.group.exit": "强制退出条件",
  "pages.merchant.members.gameConfig.newPlayer.group.risk": "风控配置",
  "pages.merchant.members.gameConfig.newPlayer.apply.title": "应用其他商户",
  "pages.merchant.members.gameConfig.newPlayer.apply.desc":
    "应用至同代理下其他商户",
  "pages.merchant.members.gameConfig.newPlayer.apply.selectedCount":
    "已选（{selected}/{total}）商户",
  "pages.merchant.members.gameConfig.newPlayer.apply.selectAll": "全部选择",
  "pages.merchant.members.gameConfig.newPlayer.apply.cancelAll": "全部取消",
  "pages.merchant.members.gameConfig.newPlayer.apply.empty":
    "当前用户下暂无可应用的其他商户",
  "pages.merchant.members.gameConfig.newPlayer.field.cron.placeholder":
    "请输入发放时间配置",
  "pages.merchant.members.gameConfig.newPlayer.field.jackpot": "初始奖池金额",
  "pages.merchant.members.gameConfig.newPlayer.field.jackpot.desc":
    "新手奖池的初始金额。",
  "pages.merchant.members.gameConfig.newPlayer.field.firstCron":
    "第一次发放时间",
  "pages.merchant.members.gameConfig.newPlayer.field.firstCron.desc":
    "配置第一次发放时间。",
  "pages.merchant.members.gameConfig.newPlayer.field.secondCron":
    "第二次发放时间",
  "pages.merchant.members.gameConfig.newPlayer.field.secondCron.desc":
    "配置第二次发放时间。",
  "pages.merchant.members.gameConfig.newPlayer.schedule.mode.daily": "每日",
  "pages.merchant.members.gameConfig.newPlayer.schedule.mode.weekly": "每周",
  "pages.merchant.members.gameConfig.newPlayer.schedule.mode.monthly": "每月",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.1": "周一",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.2": "周二",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.3": "周三",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.4": "周四",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.5": "周五",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.6": "周六",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.7": "周日",
  "pages.merchant.members.gameConfig.newPlayer.schedule.monthDay": "{day}日",
  "pages.merchant.members.gameConfig.newPlayer.field.subRtp": "次日奖池触发RTP",
  "pages.merchant.members.gameConfig.newPlayer.field.subRtp.desc":
    "（次日奖池触发RTP - 昨天实际RTP）乘以昨天总下注金额，用于判断次日奖池触发条件。",
  "pages.merchant.members.gameConfig.newPlayer.field.minSubScore":
    "次日奖池触发阈值",
  "pages.merchant.members.gameConfig.newPlayer.field.minSubScore.desc":
    "当计算结果大于等于该阈值时，使用高奖池金额；否则使用低奖池金额。",
  "pages.merchant.members.gameConfig.newPlayer.field.gtSetJackpotScore":
    "高奖池金额",
  "pages.merchant.members.gameConfig.newPlayer.field.gtSetJackpotScore.desc":
    "满足触发条件后使用。",
  "pages.merchant.members.gameConfig.newPlayer.field.gtSetJackpotScore.extra":
    "满足触发条件使用",
  "pages.merchant.members.gameConfig.newPlayer.field.ltSetJackpotScore":
    "低奖池金额",
  "pages.merchant.members.gameConfig.newPlayer.field.ltSetJackpotScore.desc":
    "未满足触发条件时使用。",
  "pages.merchant.members.gameConfig.newPlayer.field.ltSetJackpotScore.extra":
    "不满足触发条件使用",
  "pages.merchant.members.gameConfig.newPlayer.field.trigJackpotPercent":
    "触发概率",
  "pages.merchant.members.gameConfig.newPlayer.field.trigJackpotPercent.desc":
    "新账号获得新手状态的概率。",
  "pages.merchant.members.gameConfig.newPlayer.field.trigHighRtpPercent":
    "维持概率",
  "pages.merchant.members.gameConfig.newPlayer.field.trigHighRtpPercent.desc":
    "新手状态每次spin命中新手RTP后概率",
  "pages.merchant.members.gameConfig.newPlayer.field.maxSpin": "累计Spin",
  "pages.merchant.members.gameConfig.newPlayer.field.maxSpin.desc":
    "新手状态退出的 Spin 次数。",
  "pages.merchant.members.gameConfig.newPlayer.field.maxWin": "累计赢钱",
  "pages.merchant.members.gameConfig.newPlayer.field.maxWin.desc":
    "新手状态退出的累计赢钱金额。",
  "pages.merchant.members.gameConfig.newPlayer.field.singleScore":
    "单笔风控金额",
  "pages.merchant.members.gameConfig.newPlayer.field.singleScore.desc":
    "新手玩家命中 RTP 的风控金额。",
  "pages.merchant.members.gameConfig.newPlayer.effectiveData": "生效数据",
  "pages.merchant.members.gameConfig.rtp.entry": "RTP调权",
  "pages.merchant.members.gameConfig.rtp.emptySetting": "设置RTP调权",
  "pages.merchant.members.gameConfig.rtp.title": "调整RTP权重",
  "pages.merchant.members.gameConfig.rtp.loadFailed": "RTP配置加载失败",
  "pages.merchant.members.gameConfig.rtp.success": "RTP调权申请已提交",
  "pages.merchant.members.gameConfig.rtp.currentMerchant": "商户: ",
  "pages.merchant.members.gameConfig.rtp.currentGame": "游戏: ",
  "pages.merchant.members.gameConfig.rtp.approved": "你提交的RTP调权方案已通过",
  "pages.merchant.members.gameConfig.rtp.rejected":
    "你提交的RTP调权方案被拒绝，请查看审核意见后重新提交",
  "pages.merchant.members.gameConfig.rtp.reviewComments":
    "审核意见: {comments}",
  "pages.merchant.members.gameConfig.rtp.weight.title": "分配RTP比例",
  "pages.merchant.members.gameConfig.rtp.weight.assigned": "已分配 {value}",
  "pages.merchant.members.gameConfig.rtp.weight.tip":
    "设置各 weight 档位对应的 RTP 比例",
  "pages.merchant.members.gameConfig.rtp.tier.high": "高档",
  "pages.merchant.members.gameConfig.rtp.tier.medium": "中档",
  "pages.merchant.members.gameConfig.rtp.tier.low": "低档",
  "pages.merchant.members.gameConfig.rtp.weight.invalid":
    "RTP 比例合计必须等于100%，等于100%才可以保存并提交",
  "pages.merchant.members.gameConfig.rtp.empty": "暂无可调权的RTP模板",
  "pages.merchant.members.gameConfig.rtp.placeholder": "请选择RTP模板",
  "pages.merchant.members.gameConfig.rtp.noWeight.label": "RTP配置文件",
  "pages.merchant.members.gameConfig.rtp.overall.title": "最终游戏综合RTP",
  "pages.merchant.members.gameConfig.rtp.overall.tip":
    "综合RTP按每条档位的 (权重/总权重) * RTP 计算",
  "pages.merchant.members.gameConfig.rtp.overall.desc":
    "将每条档位的权重除以总权重后再乘以对应RTP，三项相加汇总",
  "pages.merchant.members.gameConfig.rtp.version": "版本号",
  "pages.merchant.members.gameConfig.rtp.apply.title": "应用其他商户",
  "pages.merchant.members.gameConfig.rtp.apply.selectedCount":
    "已选（{selected}/{total}）商户",
  "pages.merchant.members.gameConfig.rtp.apply.selectAll": "全部选择",
  "pages.merchant.members.gameConfig.rtp.apply.cancelAll": "全部取消",
  "pages.merchant.members.gameConfig.rtp.apply.desc": "应用至同代理下其他商户",
  "pages.merchant.members.gameConfig.rtp.apply.empty":
    "当前用户下暂无可应用的其他商户",
  "pages.merchant.members.gameConfig.rtp.apply.tip":
    "*选中的商户将被该调权配置覆盖",
  "pages.merchant.members.gameConfig.rtp.confirm.title": "调整RTP权重",
  "pages.merchant.members.gameConfig.rtp.confirm.content":
    "调整RTP权重需要审核人审核通过后，修改内容才能正式生效。确认提交本次申请？",
  "pages.merchant.members.gameConfig.rtp.submit": "保存并发布",
  "pages.merchant.members.gameConfig.rtp.submit.pending": "审核中",
  "pages.merchant.members.gameConfig.betLevel.entry": "更换档位",
  "pages.merchant.members.gameConfig.betLevel.modalTitle": "更换档位",
  "pages.merchant.members.gameConfig.betLevel.subTitle":
    "当前正在为游戏 {gameName} 选择新档位",
  "pages.merchant.members.gameConfig.betLevel.selectTemplate":
    "请选择要应用到该游戏的档位模板：",
  "pages.merchant.members.gameConfig.betLevel.previewCurrency":
    "数值预览币种：",
  "pages.merchant.members.gameConfig.betLevel.levelName": "档位名称",
  "pages.merchant.members.gameConfig.betLevel.levelDistribution":
    "{currency} 档位值分布",
  "pages.merchant.members.gameConfig.betLevel.column.select": "选择",
  "pages.merchant.members.gameConfig.betLevel.loadFailed":
    "档位列表加载失败，请重试",
  "pages.merchant.members.gameConfig.betLevel.success": "档位更换申请已提交",
  "pages.merchant.members.gameConfig.betLevel.warning":
    "提示：更换档位后，该游戏将**同时应用**该档位下配置的 USD、HKD、JPY 等所有受支持币种的数值规则。可能影响线上收益，请谨慎操作。",
  "pages.merchant.members.gameConfig.betLevel.currentGame": "当前游戏",
  "pages.merchant.members.gameConfig.betLevel.currentLevel": "当前档位",
  "pages.merchant.members.gameConfig.betLevel.currentLevel.empty": "设置档位",
  "pages.merchant.members.gameConfig.betLevel.currency": "币种切换",
  "pages.merchant.members.gameConfig.betLevel.empty": "暂无可更换的启用档位",
  "pages.merchant.members.gameConfig.betLevel.distribution":
    "{currency} 档位分布",
  "pages.merchant.members.gameConfig.betLevel.distribution.empty":
    "当前币种暂无档位分布",
  "pages.merchant.members.gameConfig.betLevel.distribution.summaryEmpty":
    "设置档位",
  "pages.merchant.members.gameConfig.betLevel.distribution.tooltipTitle":
    "全部币种档位分布",
  "pages.merchant.members.gameConfig.betLevel.distribution.tooltipDescription":
    "悬浮区域展示当前档位下全部已配置币种的档位值分布，默认档位标识保持不变。",
  "pages.merchant.members.gameConfig.betLevel.currentTag": "当前档位",
  "pages.merchant.members.gameConfig.betLevel.defaultTag": "默认档位",
  "pages.merchant.members.gameConfig.betLevel.defaultSuffix": "默认",
  "pages.merchant.members.gameConfig.betLevel.target.required":
    "请选择目标档位",
  "pages.merchant.members.gameConfig.betLevel.confirm.action": "确认更换",
  "pages.merchant.members.gameConfig.betLevel.confirm.pending": "审核中",
  "pages.merchant.members.gameConfig.betLevel.confirm.title": "确认更换档位",
  "pages.merchant.members.gameConfig.betLevel.confirm.content":
    "确认将游戏“{gameName}”切换为档位“{targetLevelName}”？该操作可能影响线上收益。",
  "pages.merchant.members.gameConfig.betLevel.emptyValue": "-",
  "pages.merchant.members.gameConfig.betLevel.pendingDraft":
    "待变更档位：{name}",
  "pages.merchant.members.gameConfig.betLevel.rejectedDraft":
    "已驳回草稿：{name}",
  "pages.merchant.members.gameConfig.betLevel.status.pending": "审核中",
  "pages.merchant.members.gameConfig.betLevel.status.rejected": "已驳回",
  "pages.merchant.members.gameConfig.column.gameId": "游戏ID",
  "pages.merchant.members.gameConfig.column.name": "名称",
  "pages.merchant.members.gameConfig.column.type": "类型",
  "pages.merchant.members.gameConfig.column.language": "支持语言",
  "pages.merchant.members.gameConfig.column.currency": "支持币种",
  "pages.merchant.members.gameConfig.column.betLevel": "当前档位",
  "pages.merchant.members.gameConfig.column.betLevelDistribution":
    "档位值分布（多币种）",
  "pages.merchant.members.gameConfig.column.action": "开启/关闭",
  "pages.merchant.members.gameConfig.column.action.tooltip":
    "修改开关后请点击【确定】保存设置。",
  "pages.merchant.members.gameConfig.column.operation": "操作",
  "pages.merchant.members.agent.title.edit": "编辑代理",
  "pages.merchant.members.agent.title.add": "添加代理",
  "pages.merchant.members.agent.form.level": "层级",
  "pages.merchant.members.agent.form.level.required": "请选择层级",
  "pages.merchant.members.agent.form.level.1": "一级代理",
  "pages.merchant.members.agent.form.level.2": "二级代理",
  "pages.merchant.members.agent.form.parent.platform": "平台",
  "pages.merchant.members.agent.form.agentName": "代理名称",
  "pages.merchant.members.agent.form.agentName.required": "请输入代理名称",
  "pages.merchant.members.agent.form.fee": "费率(%)",
  "pages.merchant.members.agent.form.fee.required": "请输入费率",
  "pages.merchant.members.resetPassword.title": "重置密码",
  "pages.merchant.members.resetPassword.form.newPassword": "新密码",
  "pages.merchant.members.resetPassword.form.newPassword.placeholder":
    "请输入新密码",
  "pages.merchant.members.resetPassword.form.newPassword.required":
    "请输入新密码",
  "pages.merchant.members.resetPassword.form.newPassword.min":
    "密码长度至少为6位",
  "pages.merchant.members.resetPassword.form.confirmPassword": "确认新密码",
  "pages.merchant.members.resetPassword.form.confirmPassword.placeholder":
    "请再次输入新密码",
  "pages.merchant.members.resetPassword.form.confirmPassword.required":
    "请确认新密码",
  "pages.merchant.members.resetPassword.form.confirmPassword.mismatch":
    "两次输入的密码不一致",
  "pages.merchant.members.resetPassword.success": "密码重置成功",
  "pages.merchant.members.resetPublicKey.title": "重置公钥",
  "pages.merchant.members.resetPublicKey.form.publicKey": "公钥",
  "pages.merchant.members.resetPublicKey.form.publicKey.placeholder":
    "请输入公钥",
  "pages.merchant.members.resetPublicKey.form.publicKey.required": "请输入公钥",
  "pages.merchant.members.resetPublicKey.success": "公钥重置成功",
  "pages.merchant.members.delete.title": "确认删除商户?",
  "pages.merchant.members.delete.confirmText": "确定删除",
  "pages.merchant.members.delete.reason.required": "请输入删除原因",
  "pages.merchant.members.delete.reason.placeholder":
    "请输入删除原因，说明删除原因",
  "pages.merchant.members.delete.reason.label": "删除原因",
  "pages.merchant.members.delete.warning":
    "您正在尝试删除商户“{name}”。删除操作不可撤销，且会导致该商户及其下属所有数据无法访问。请务必确认操作！",
  "pages.merchant.members.delete.success": "删除成功",
  "pages.merchant.members.unknownMerchant": "未知商户",
  "pages.merchant.members.batchAdd.title": "批量导入商户",
  "pages.merchant.members.batchAdd.step1.title": "下载模板",
  "pages.merchant.members.batchAdd.step1.desc":
    "请按照模板填写内容，若字段不符合规则，会导致上传失败",
  "pages.merchant.members.batchAdd.step1.button": "下载批量模板",
  "pages.merchant.members.batchAdd.step2.title": "上传商户资料",
  "pages.merchant.members.batchAdd.step2.file.placeholder": "请添加文件",
  "pages.merchant.members.batchAdd.step2.upload.button": "上传文件",
  "pages.merchant.members.batchAdd.step2.upload.error.format":
    "仅支持 .xlsx .xls 格式",
  "pages.merchant.members.batchAdd.step2.hint": "仅支持.xlsx .xls格式",
  "pages.merchant.members.batchAdd.uploading": "正在批量上传...",
  "pages.merchant.members.batchAdd.success": "导入成功",
  "pages.merchant.members.batchAdd.error.fileRequired": "请选择文件",
  "pages.merchant.members.batchAdd.error.uploadFailed":
    "导入失败，请检查格式是否正确",
  "pages.merchant.members.batchAdd.templateName": "商户批量导入模板.xlsx",
  "pages.merchant.members.bindOperator.title": "绑定商户 - {name}",
  "pages.merchant.members.bindOperator.selectedCount": "已选 {count} 项",
  "pages.merchant.members.bindOperator.placeholder": "请输入ID或名称",
  "pages.merchant.members.bindOperator.success": "绑定成功",
  "pages.merchant.members.bindOperator.error.atLeastOne": "请至少选择一个商户",
  "pages.merchant.members.bindOperator.empty": "暂无已选商户",
  "pages.merchant.members.unbindParent.title": "确认解除上级?",
  "pages.merchant.members.unbindParent.reason.required": "请填写解除原因",
  "pages.merchant.members.unbindParent.reason.placeholder": "请填写原因，必填",
  "pages.merchant.members.unbindParent.reason.label": "解除原因",
  "pages.merchant.members.unbindParent.warning":
    "解除关系后，上级“{parentName}”将无法获得下级“{name}”收益产生的佣金。解除关系前产生的佣金仍需计算。请谨慎操作！",
  "pages.merchant.members.unbindParent.success": "解除成功",
  "pages.merchant.members.action.batchStatus.noneSelected":
    "请先选择要操作的项",
  "pages.merchant.members.action.enable": "启用",
  "pages.merchant.members.action.disable": "禁用",
  "pages.merchant.members.action.batchStatus.confirm.title":
    "确认{type}{statusText}",
  "pages.merchant.members.action.batchStatus.confirm.content":
    "确定要{statusText}[{names}]吗？",
  "pages.merchant.members.action.batchStatus.loading":
    "正在{type}{statusText}...",
  "pages.merchant.members.action.batchStatus.success": "{type}{statusText}成功",
  "pages.merchant.members.action.batchStatus.error": "{statusText}失败",
  "pages.merchant.members.action.batch": "批量",
  "pages.merchant.members.export.filename": "商户-",
  "pages.merchant.members.export.success": "导出成功",
  "pages.merchant.members.export.error": "导出失败",
  "pages.merchant.members.export.error.retry": "导出失败，请稍后重试",
  "pages.merchant.members.detail.title.agent": "代理详情",
  "pages.merchant.members.detail.title.merchant": "商户详情",
  "pages.merchant.members.detail.tab.basic": "基础信息",
  "pages.merchant.members.detail.tab.games": "游戏列表",
  "pages.merchant.members.detail.column.appId": "appId",
  "pages.merchant.members.detail.column.loginAccount": "登录账号",
  "pages.merchant.members.detail.column.loginPassword": "登录密码",
  "pages.merchant.members.detail.column.parent.none": "无",
  "pages.merchant.members.detail.column.fee": "费率",
  "pages.merchant.members.detail.column.incomeShare": "收入分成",
  "pages.merchant.members.detail.column.serverAddress": "服务地址",
  "pages.merchant.members.detail.column.ipWhitelist": "IP白名单",
  "pages.merchant.members.detail.column.publicKey": "商户公钥",
  "pages.merchant.members.detail.column.googleSecret": "谷歌秘钥",
  "pages.merchant.members.detail.column.createdAt": "创建时间",
  "pages.merchant.members.detail.column.bindTime": "绑定时间",
  "pages.merchant.members.detail.column.loginTime": "最近登录",
  "pages.merchant.members.detail.column.loginIp": "登录IP",
  "pages.merchant.members.detail.column.status.open": "开启",
  "pages.merchant.members.detail.column.status.close": "关闭",
  "pages.merchant.members.error.missingTicket": "缺少验证票据，请重新验证",
  "pages.merchant.members.action.login": "登录",
  "pages.merchant.members.action.edit": "编辑",
  "pages.merchant.members.action.detail": "详情",
  "pages.merchant.members.action.more": "更多",
  "pages.merchant.members.action.currencyRatio": "货币比例",
  "pages.merchant.members.action.resetKey": "重置公钥",
  "pages.merchant.members.action.resetPwd": "重置密码",
  "pages.merchant.members.action.resetGoogle": "重置谷歌验证",
  "pages.merchant.members.action.resetGoogle.confirm": "确认重置谷歌验证",
  "pages.merchant.members.action.resetGoogle.content":
    "重置后，商户登录后台需要重新绑定谷歌验证",
  "pages.merchant.members.action.resetGoogle.success": "谷歌验证重置成功",
  "pages.merchant.members.action.openGame": "开通游戏",
  "pages.merchant.members.action.bindMerchant": "绑定商户",
  "pages.merchant.members.action.unbindPID": "解除上级",
  "pages.merchant.members.action.delete": "删除",
  "pages.merchant.members.login.loading": "正在准备登录环境...",

  // 商户管理 - 用户管理
  "pages.merchant.users.list.title": "用户管理",
  "pages.merchant.users.column.registerTime": "注册时间",
  "pages.merchant.users.column.selectMerchant": "选择商户",
  "pages.merchant.users.column.currency": "币种",
  "pages.merchant.users.placeholder.currency": "请选择币种",
  "pages.merchant.users.column.roleId": "用户ID",
  "pages.merchant.users.column.agent": "代理",
  "pages.merchant.users.tag.whiteUser": "白名单用户",
  "pages.merchant.users.placeholder.roleId": "请输入ID",
  "pages.merchant.users.column.ip": "IP",
  "pages.merchant.users.placeholder.ip": "请输入IP",
  "pages.merchant.users.column.betCount": "下注次数",
  "pages.merchant.users.column.betAmount": "累计下注金额",
  "pages.merchant.users.column.freespinAmount": "活动彩金",
  "pages.merchant.users.column.balance": "账户余额",
  "pages.merchant.users.column.profit": "盈亏金额（平台侧）",
  "pages.merchant.users.column.scoreAmount": "返奖金额",
  "pages.merchant.users.column.registerIp": "注册IP",
  "pages.merchant.users.column.lastLoginTime": "最近登录时间",
  "pages.merchant.users.action.loginLogs": "登录日志",
  "pages.merchant.users.action.loginLogsDetail": "登录日志详情",
  "pages.merchant.users.column.loginTime": "登录时间",

  // 商户管理 - 账单管理
  "pages.merchant.bill.title": "账单管理",
  "pages.merchant.bill.summary.title": "数据总览",
  "pages.merchant.bill.summary.totalBetAmount": "总投注金额",
  "pages.merchant.bill.summary.totalScoreAmount": "总返奖金额",
  "pages.merchant.bill.summary.totalGGR": "总GGR",
  "pages.merchant.bill.summary.merchantIncome": "商户净收",
  "pages.merchant.bill.summary.rtp": "RTP",
  "pages.merchant.bill.summary.betCount": "总投注次数",
  "pages.merchant.bill.summary.averageBetAmount": "平均下注",
  "pages.merchant.bill.column.agentLevel": "代理等级筛选",
  "pages.merchant.bill.summary.tooltip":
    "总下注金额：在当前筛选条件下，所有用户的累计下注金额\n\n总返奖金额：在当前筛选条件下，所有用户的累计返奖金额\n\n总GGR：在当前筛选条件下，平台毛收入。（总下注金额-总返奖金额）\n\nRTP：在当前筛选条件下，累加的玩家回报率。\nRTP = 总返奖金额 / 总下注金额",
  "pages.merchant.bill.tab.daily": "日账单",
  "pages.merchant.bill.tab.monthly": "月账单",
  "pages.merchant.bill.action.export": "导出",
  "pages.merchant.bill.action.exportBill": "导出账单",
  "pages.merchant.bill.export.filename": "账单报表_",
  "pages.merchant.bill.jackpot.title": "彩金明细",
  "pages.merchant.bill.jackpot.close": "我知道了",
  "pages.merchant.bill.column.platformIncome": "平台应收",
  "pages.merchant.bill.column.platformIncome.tooltip":
    "平台应收=（投注金额-返奖金额）*费率",
  "pages.merchant.bill.column.freespinAmount": "彩金",
  "pages.merchant.bill.column.freespinAmount.tooltip":
    "彩金=平台freespin+累计freespin",
  "pages.merchant.bill.column.dateRange": "选择时间",
  "pages.merchant.bill.column.currencyRatio": "货币比例",

  // 游戏管理
  "pages.games.list.title": "游戏管理",
  "pages.games.list.selected": "已选 {count} 项",
  "pages.games.action.batchEnable": "启用",
  "pages.games.action.batchDisable": "停用",
  "pages.games.action.add": "新增游戏",
  "pages.games.action.edit": "编辑",
  "pages.games.action.detail": "查看详情",
  "pages.games.action.openMerchant": "开通商户",
  "pages.games.action.gameType": "游戏类型",
  "pages.games.action.gameTag": "游戏标签",
  "pages.games.column.createdAt": "上线时间",
  "pages.games.column.gameType": "游戏类型",
  "pages.games.column.gameTags": "游戏标签",
  "pages.games.column.status": "状态",
  "pages.games.column.keywords": "搜索游戏",
  "pages.games.column.keywords.placeholder": "游戏ID/游戏名称",
  "pages.games.column.gameNumber": "游戏ID",
  "pages.games.column.name": "游戏名称",
  "pages.games.column.icon": "图标",
  "pages.games.column.onlineTime": "上线时间",
  "pages.games.column.rtp": "RTP",
  "pages.games.column.maxWin": "Max win",
  "pages.games.column.volatile": "波动性",
  "pages.games.column.payline": "线数",
  "pages.games.column.action": "操作",
  "pages.games.status.normal": "正常",
  "pages.games.status.disabled": "禁用",
  "pages.games.batch.confirm.title": "确认批量{status}",
  "pages.games.batch.confirm.content":
    "确定要{status}选中的 {count} 个游戏吗？",
  "pages.games.batch.success": "批量{status}成功",
  "pages.games.single.success": "{status}成功",
  "pages.games.single.enable": "启用",
  "pages.games.single.disable": "停用",
  "pages.games.warning.selectAtLeastOne": "请先选择要操作的游戏",
  "pages.games.edit.title.add": "新增游戏",
  "pages.games.edit.title.edit": "编辑游戏",
  "pages.games.edit.title.detail": "游戏详情",
  "pages.games.edit.section.basic": "*基础信息",
  "pages.games.edit.section.params": "游戏参数",
  "pages.games.edit.form.gameNumber": "游戏ID",
  "pages.games.edit.form.gameNumber.placeholder": "请输入游戏ID",
  "pages.games.edit.form.gameNumber.required": "请输入游戏ID",
  "pages.games.edit.form.gameType": "游戏类型",
  "pages.games.edit.form.gameType.placeholder": "请选择",
  "pages.games.edit.form.gameType.required": "请选择游戏类型",
  "pages.games.edit.form.tagIds": "游戏标签",
  "pages.games.edit.form.tagIds.placeholder": "请选择游戏标签",
  "pages.games.edit.form.status": "状态",
  "pages.games.edit.form.icon": "游戏icon",
  "pages.games.edit.form.icon.required": "请上传游戏icon",
  "pages.games.edit.form.icon.tip": "建议尺寸：488*488px",
  "pages.games.edit.form.cover": "游戏封面",
  "pages.games.edit.form.cover.required": "请上传游戏封面",
  "pages.games.edit.form.cover.tip": "建议尺寸：480*640px",
  "pages.games.edit.form.horizontalVideoUrl": "游戏介绍视频（横屏）",
  "pages.games.edit.form.horizontalVideoUrl.tip": "请上传横屏游戏介绍视频",
  "pages.games.edit.form.verticalVideoUrl": "游戏介绍视频（竖屏）",
  "pages.games.edit.form.verticalVideoUrl.tip": "请上传竖屏游戏介绍视频",
  "pages.games.edit.form.onlineTime": "上线时间",
  "pages.games.edit.form.onlineTime.placeholder": "请选择...",
  "pages.games.edit.form.rtp": "RTP",
  "pages.games.edit.form.rtp.required": "请输入RTP",
  "pages.games.edit.form.volatile": "波动性",
  "pages.games.edit.form.volatile.placeholder": "请选择",
  "pages.games.edit.form.volatile.low": "低",
  "pages.games.edit.form.volatile.medium": "中",
  "pages.games.edit.form.volatile.high": "高",
  "pages.games.edit.form.freespin": "freespin",
  "pages.games.edit.form.rtpAdjust": "RTP调权",
  "pages.games.edit.form.buyBonusCount": "Buybonus数量",
  "pages.games.edit.form.buyBonusCount.error": "只能输入1-7的数字",
  "pages.games.edit.form.reelConfig": "卷轴配置",
  "pages.games.edit.form.reelConfig.placeholder": "例如: 3*3",
  "pages.games.edit.form.reelConfig.error.pattern": "只能输入数字和*",
  "pages.games.edit.form.payline": "赔付线",
  "pages.games.edit.form.betRange": "投注区间",
  "pages.games.edit.form.betRange.error.max": "投注区间范围为 0-1000",
  "pages.games.edit.form.winRate": "中奖率",
  "pages.games.edit.form.winRate.required": "请输入中奖率",
  "pages.games.edit.form.winRate.error.max": "中奖率不能超过100",
  "pages.games.edit.message.addSuccess": "新增成功",
  "pages.games.edit.message.editSuccess": "编辑成功",
  "pages.games.edit.message.uploadIncomplete": "请等待图片上传完成",
  "pages.games.edit.message.incompleteLangs": "请输入完整的语言名称",
  "pages.games.openMerchant.title": "开通商户 - {gameName}",
  "pages.games.openMerchant.gameInfo": "游戏信息",
  "pages.games.openMerchant.batchAction": "批量操作",
  "pages.games.openMerchant.batchEnable": "批量开通",
  "pages.games.openMerchant.batchDisable": "批量关闭",
  "pages.games.openMerchant.search.placeholder": "商户ID/商户名称",
  "pages.games.openMerchant.column.merchantId": "商户ID",
  "pages.games.openMerchant.column.merchantName": "商户名称",
  "pages.games.openMerchant.column.parent": "直属上级",
  "pages.games.openMerchant.column.status": "开通状态",
  "pages.games.openMerchant.message.saveSuccess": "保存成功",
  "pages.games.openMerchant.message.noChanges": "没有修改，无需保存",
  "pages.games.type.title": "游戏类型管理",
  "pages.games.type.column.id": "类型ID",
  "pages.games.type.column.name": "类型名称",
  "pages.games.type.column.sort": "排序",
  "pages.games.type.column.action": "操作",
  "pages.games.type.action.add": "新增类型",
  "pages.games.type.action.edit": "编辑",
  "pages.games.type.action.delete": "删除",
  "pages.games.type.delete.confirm": "确定删除该类型吗？",
  "pages.games.type.form.name": "类型名称",
  "pages.games.type.form.name.required": "请输入类型名称",
  "pages.games.type.form.sort": "排序",
  "pages.games.type.form.sort.required": "请输入排序",
  "pages.games.type.message.finishEditing": "请先完成当前编辑",
  "pages.games.type.message.inputName": "请输入类型名称",
  "pages.games.type.delete.title": "确认删除类型",
  "pages.games.type.delete.content":
    "删除后，已添加该类型的游戏，将自动清除类型。请谨慎操作",
  "pages.games.type.drawer.title": "游戏类型",
  "pages.games.tag.column.name": "标签名称",
  "pages.games.tag.column.sort": "排序",
  "pages.games.tag.column.action": "操作",
  "pages.games.tag.label": "游戏标签",
  "pages.games.tag.placeholder": "请选择游戏标签",
  "pages.games.tag.action.add": "新增标签",
  "pages.games.tag.action.edit": "编辑",
  "pages.games.tag.action.delete": "删除",
  "pages.games.tag.message.finishEditing": "请先完成当前编辑",
  "pages.games.tag.message.inputName": "请输入标签名称",
  "pages.games.tag.delete.title": "确认删除标签",
  "pages.games.tag.delete.content":
    "删除后，已配置该标签的关联数据将被移除，请谨慎操作",
  "pages.games.tag.drawer.title": "游戏标签",
  "pages.games.language.column.language": "语言",
  "pages.games.language.column.code": "语言编码",
  "pages.games.language.column.name": "名称",
  "pages.games.language.label": "语言名称",
  "pages.games.language.placeholder": "请输入名称",
  "pages.games.openMerchant.selectedCount": "已选 {count} 项",
  "pages.games.openMerchant.merchantLabel": "商户",
  "pages.games.openMerchant.message.selectMerchant": "请先选择商户",
  "pages.games.openMerchant.filter.opened": "已开通",
  "pages.games.openMerchant.filter.notOpened": "未开通",
  "pages.games.edit.form.rtp.placeholder": "请输入 RTP",
  "pages.games.edit.form.payline.placeholder": "请输入线数",
  "pages.games.edit.form.winRate.placeholder": "请输入中奖率",
  "pages.game_static.title": "游戏资源",
  "pages.game_static.column.name": "名称",
  "pages.game_static.column.key": "路径 Key",
  "pages.game_static.column.action": "操作",
  "pages.game_static.action.download": "下载",
  "pages.game_static.action.preview": "预览",
  "pages.game_static.action.previewLoading": "正在加载...",
  "pages.game_static.action.expandAll": "全部展开",
  "pages.game_static.action.collapseAll": "全部收起",
  "pages.game_static.type.folder": "文件夹",
  "pages.game_static.type.file": "文件",
  "pages.game_static.message.fetchFailed": "获取静态资源列表失败",
  "pages.game_static.message.downloadFailed": "下载失败",
  "pages.game_static.message.previewFailed": "预览失败",
  "pages.game_static.modal.downloadingFolder": "文件夹下载中",
  "pages.game_static.progress.download": "文件下载进度",
  "pages.game_static.progress.zip": "压缩进度",
  "pages.game_static.progress.overall": "总体进度",
  "pages.game_static.progress.of": "共",
  "pages.game_static.progress.elapsed": "耗时",
  "pages.game_static.downloadCenter.title": "下载列表",
  "pages.game_static.downloadCenter.clear": "清理已完成",
  "pages.game_static.downloadCenter.empty": "暂无下载任务",
  "pages.game_static.downloadCenter.expand": "展开文件进度",
  "pages.game_static.downloadCenter.collapse": "收起文件进度",
  "pages.game_static.downloadCenter.zippingProgress": "压缩进度",
  "pages.game_static.downloadCenter.status.downloading": "下载中",
  "pages.game_static.downloadCenter.status.zipping": "压缩中",
  "pages.game_static.downloadCenter.status.done": "已完成",
  "pages.game_static.downloadCenter.status.failed": "失败",
  "pages.game_static.downloadCenter.action.retry": "重新下载",
  "pages.game_static.downloadCenter.refreshWarning":
    "提示：刷新界面会导致下载失败，且不会保留下载记录。",
  "pages.game_static.downloadCenter.notify.success": "下载 {name} 成功",

  // 开发配置
  "pages.develop.card.integration": "集成说明",
  "pages.develop.integration.desc":
    "要对接 croco gaming 集成系统，请使用以下链接参考文档，并遵循所需步骤。",
  "pages.develop.integration.doc": "集成文档:",
  "pages.develop.integration.docTrans": "集成文档（转账模式）:",
  "pages.develop.integration.api": "正式API URL:",
  "pages.develop.integration.download": "游戏素材下载:",
  "pages.develop.card.notice": "重要提示",
  "pages.develop.notice.primary":
    "请在此处完成RSA公钥和RSA私钥，请用这两组信息生成签名。生成新的密钥将使你前一组密钥无法使用。",
  "pages.develop.notice.secondary": "我们将会为运营商保密，请放心使用。",
  "pages.develop.card.keyConfig": "密钥配置",
  "pages.develop.form.appId.label": "APP ID (运营商唯一标识)",
  "pages.develop.form.appId.placeholder": "请输入 APP ID",
  "pages.develop.form.platformPublicKey.label": "Croco Gaming 平台公钥",
  "pages.develop.form.platformPublicKey.placeholder":
    "请输入 Croco Gaming 平台公钥",
  "pages.develop.form.rsaPublicKey.label": "RSA 公钥",
  "pages.develop.form.rsaPublicKey.placeholder": "请输入 RSA 公钥",
  "pages.develop.form.rsaPrivateKey.label": "RSA 私钥",
  "pages.develop.form.rsaPrivateKey.placeholder": "请输入 RSA 私钥",
  "pages.develop.card.signTest": "签名测试",
  "pages.develop.form.signSource.label": "待签名数据",
  "pages.develop.form.signSource.placeholder": "请输入待签名数据",
  "pages.develop.form.signResult.label": "加密后数据",
  "pages.develop.form.signResult.placeholder": "签名结果将显示在这里",
  "pages.develop.action.sign": "签名",
  "pages.develop.message.noContent": "暂无可复制内容",
  "pages.develop.message.copyFailed": "复制失败",
  "pages.develop.message.signSourceRequired": "请输入待签名数据",
  "pages.develop.message.signSuccess": "签名成功",
  "pages.develop.message.signFailed": "签名失败",
  "pages.develop.message.initFailed": "初始化配置读取失败，已使用默认展示内容",
  "pages.develop.message.resetSuccess": "重置成功",
  "pages.develop.message.resetFailed": "重置失败",
  "pages.reviewCenter.my.placeholder": "我的审核列表功能即将开放",

  // 报表管理
  "pages.report.flow.list.title": "流水记录",
  "pages.report.flow.column.createdAt": "创建时间",
  "pages.report.flow.preset.all": "全部",
  "pages.report.flow.preset.today": "今日",
  "pages.report.flow.preset.last7Days": "近7天",
  "pages.report.flow.preset.last30Days": "近30天",
  "pages.report.flow.column.transferReference": "流水ID",
  "pages.report.flow.placeholder.transferReference": "请输入流水ID",
  "pages.report.flow.column.type": "变动类型",
  "pages.report.flow.type.deposit": "存入",
  "pages.report.flow.type.withdraw": "取出",
  "pages.report.flow.type.withdrawAll": "全部取出",
  "pages.report.flow.column.amount": "金额",
  "pages.report.flow.column.balanceBefore": "变更前余额",
  "pages.report.flow.column.balanceAfter": "变更后余额",
  "pages.report.flow.column.updatedAt": "更新时间",
  "pages.report.flow.message.exporting": "导出中...",
  "pages.report.flow.export.filename": "流水导出_",
  "pages.report.flow.message.exportSuccess": "导出成功",
  "pages.report.flow.message.exportFailed": "导出失败",
  "pages.report.flow.summary.title": "数据总览",
  "pages.report.flow.summary.tooltip.totalCount":
    "流水总数：在当前筛选条件下，所有资金变动记录的总条数",
  "pages.report.flow.summary.tooltip.incomeAmount":
    "入账金额：所有「资金增加」的总金额，如「存入」",
  "pages.report.flow.summary.tooltip.outcomeAmount":
    "出账金额：所有「资金减少」的总金额，如「取出」「全部取出」",
  "pages.report.flow.summary.totalCount": "流水总数",
  "pages.report.flow.summary.incomeAmount": "入账金额",
  "pages.report.flow.summary.outcomeAmount": "出账金额",
  "pages.report.flow.action.export": "导出",

  // 报表管理 - 投注记录
  "pages.report.betRecord.filter.title": "筛选条件",
  "pages.report.betRecord.filter.timeRange": "时间范围",
  "pages.report.betRecord.filter.betId": "下注ID",
  "pages.report.betRecord.filter.userId": "用户ID",
  "pages.report.betRecord.filter.ip": "IP",
  "pages.report.betRecord.filter.game": "游戏",
  "pages.report.betRecord.filter.gameId": "游戏ID",
  "pages.report.betRecord.filter.currency": "币种",
  "pages.report.betRecord.filter.merchant": "商户",
  "pages.report.betRecord.filter.betAmountMin": "下注额最小值",
  "pages.report.betRecord.filter.betAmountMax": "下注额最大值",
  "pages.report.betRecord.filter.buybounsType": "游戏模式",
  "pages.report.betRecord.filter.freespinType": "FreeSpin类型",
  "pages.report.betRecord.filter.freespinType.merchant": "累计",
  "pages.report.betRecord.filter.freespinType.platform": "平台",
  "pages.report.betRecord.filter.freespinType.sevenDay": "七日FreeSpin",
  "pages.report.betRecord.overview.title": "数据总览",
  "pages.report.betRecord.overview.description":
    "实时数据，可能与其他报表数据产生偏差",
  "pages.report.betRecord.overview.totalBetAmount": "总下注金额",
  "pages.report.betRecord.overview.totalScoreAmount": "总返奖金额",
  "pages.report.betRecord.overview.totalScoreAmount.tooltip": "不包含彩金",
  "pages.report.betRecord.overview.totalWinAmount": "总盈亏（平台侧）",
  "pages.report.betRecord.overview.platformFreespinAmount": "平台Freespin金额",
  "pages.report.betRecord.overview.merchantFreespinAmount": "累计FreeSpin金额",
  "pages.report.betRecord.overview.tooltip.totalBetAmount":
    "总下注金额：在当前筛选条件下，所有用户的累计下注金额",
  "pages.report.betRecord.overview.tooltip.totalScoreAmount":
    "总返奖金额：在当前筛选条件下，所有用户的累计返奖金额。（注：总返奖金额不含活动彩金）",
  "pages.report.betRecord.overview.tooltip.totalWinAmount":
    "总盈亏（平台侧）：在当前筛选条件下，平台侧的累计盈亏金额。",
  "pages.report.betRecord.overview.tooltip.totalWinAmountFormula":
    "总盈亏=总下注金额-【总返奖金额+累计FreeSpin】",
  "pages.report.betRecord.overview.tooltip.platformFreespinAmount":
    "平台Freespin金额：在当前筛选条件下，平台侧提供Freespin，所有用户的累计Freespin金额",
  "pages.report.betRecord.overview.tooltip.merchantFreespinAmount":
    "累计FreeSpin金额：在当前筛选条件下，商户侧提供Freespin，所有用户的累计Freespin金额",
  "pages.report.betRecord.table.title": "投注记录列表",
  "pages.report.betRecord.column.betId": "下注ID",
  "pages.report.betRecord.column.merchantName": "商户名称",
  "pages.report.betRecord.column.merchantId": "商户ID",
  "pages.report.betRecord.column.parentOperator": "直属上级",
  "pages.report.betRecord.column.operatorPath": "归属路径",
  "pages.report.betRecord.column.userId": "用户ID",
  "pages.report.betRecord.column.gameId": "游戏ID",
  "pages.report.betRecord.column.gameName": "游戏名称",
  "pages.report.betRecord.column.currency": "币种",
  "pages.report.betRecord.column.game": "游戏",
  "pages.report.betRecord.column.merchant": "商户",
  "pages.report.betRecord.column.betAmount": "下注金额",
  "pages.report.betRecord.column.scoreAmount": "返奖金额",
  "pages.report.betRecord.column.scoreAmountUser": "返奖金额(用户侧)",
  "pages.report.betRecord.column.winAmount": "盈亏金额",
  "pages.report.betRecord.column.winAmountUser": "盈亏(平台侧)",
  "pages.report.betRecord.column.surplusCoin": "钱包余额",
  "pages.report.betRecord.column.freespinType": "Freespin类型",
  "pages.report.betRecord.column.freespin": "Freespin金额",
  "pages.report.betRecord.column.gameMode": "游戏模式",
  "pages.report.betRecord.column.cascadeType": "级联类型",
  "pages.report.betRecord.column.platformFreespinAmount": "平台Freespin",
  "pages.report.betRecord.column.merchantFreespinAmount": "累计Freespin",
  "pages.report.betRecord.column.ip": "IP",
  "pages.report.betRecord.column.createdAt": "下注时间",
  "pages.report.betRecord.column.settlementTime": "结算时间",
  "pages.report.betRecord.column.replay": "回放",
  "pages.report.betRecord.column.action": "操作",
  "pages.report.betRecord.type.merchantFreespin": "累计",
  "pages.report.betRecord.type.platformFreespin": "平台",
  "pages.report.betRecord.type.sevenDayFreespin": "七日FreeSpin",
  "pages.report.betRecord.action.export": "导出",
  "pages.report.betRecord.action.replay": "回放",
  "pages.report.betRecord.cascadeType.none": "-",
  "pages.report.betRecord.cascadeType.normalOrder": "订单级联",
  "pages.report.betRecord.cascadeType.miniGame": "小游戏",
  "pages.report.betRecord.action.viewDetail": "查看",
  "pages.report.betRecord.sortTip":
    "*涉及到金额相关的排序，均换算成美元后再进行排序(默认显示近半年)",
  "pages.report.betRecord.export.filename": "投注记录_",
  "pages.report.betRecord.message.exporting": "正在导出...",
  "pages.report.betRecord.message.exportSuccess": "导出成功",
  "pages.report.betRecord.message.exportFailed": "导出失败",

  // 报表管理 - 代理商报表
  "pages.report.agent.tab.custom": "自定义",
  "pages.report.agent.tab.game": "按游戏",
  "pages.report.agent.tab.merchant": "按商户",
  "pages.report.agent.filter.merchant": "商户选择",
  "pages.report.agent.filter.game": "游戏选择",
  "pages.report.agent.filter.currency": "币种选择",
  "pages.report.agent.kpi.title": "数据总览",
  "pages.report.agent.kpi.description": "数据15mins刷新一次",
  "pages.report.agent.kpi.tooltip":
    "总下注金额：在当前筛选条件下，所有用户在所选时间范围内的累计下注金额\n\n总返奖金额：在当前筛选条件下，所有用户获得的返奖总金额（不含活动彩金）\n\n活动彩金：在当前筛选条件下，所有用户获得的Freespin金额。平台Freespin+累计Freespin\n\n总GGR：在当前筛选条件下，总游戏收入\n（总下注金额-总返奖金额）\n\n总亏损：在当前筛选条件下，平台整体亏损金额\n\n整体亏损率：在当前筛选条件下，平台整体亏损率\n\n总RTP：在当前筛选条件下，用户回报率。\nRTP = 总返奖金额 / 总下注金额\n\n总下注次数：在当前筛选条件下，所有下注行为的总次数。无需去重\n\n总下注人数：在当前筛选条件下，至少发生过一次下注行为的去重用户数。必须去重\n\n游戏数量：已启用的游戏数量\n\n商户数量：已创建的商户数量",
  "pages.report.agent.kpi.betAmount": "总下注金额",
  "pages.report.agent.kpi.scoreAmount": "总返奖金额",
  "pages.report.agent.kpi.freespinAmount": "活动彩金",
  "pages.report.agent.kpi.ggr": "总GGR",
  "pages.report.agent.kpi.lossAmount": "总亏损",
  "pages.report.agent.kpi.lossOrderCount": "亏损订单数",
  "pages.report.agent.kpi.lossRate": "整体亏损率",
  "pages.report.agent.kpi.profitRate": "整体盈利率",
  "pages.report.agent.kpi.rtp": "总RTP",
  "pages.report.agent.kpi.betCount": "总下注次数",
  "pages.report.agent.kpi.betUserCount": "总下注人数",
  "pages.report.agent.kpi.gameCount": "游戏数量",
  "pages.report.agent.kpi.merchantCount": "商户数量",
  "pages.report.agent.kpi.negativeGGRMerchantCount": "负GGR商户数",
  "pages.report.agent.kpi.prevPeriod": "上一周期",
  "pages.report.agent.kpi.yesterday": "昨日",
  "pages.report.agent.kpi.beforeYesterday": "前日",
  "pages.report.agent.kpi.ratio": "环比",
  "pages.report.agent.analysis.top10.game": "游戏 Top 10",
  "pages.report.agent.analysis.top10.merchant": "商户 Top 10",
  "pages.report.agent.analysis.pie.title": "数据分布",
  "pages.report.agent.analysis.pie.betAmount": "下注金额",
  "pages.report.agent.analysis.pie.betCount": "下注次数",
  "pages.report.agent.analysis.pie.ggr": "GGR",
  "pages.report.agent.analysis.pie.lossAmount": "亏损",
  "pages.report.agent.detail.period.daily": "每日",
  "pages.report.agent.detail.period.weekly": "每周",
  "pages.report.agent.detail.period.monthly": "每月",
  "pages.report.agent.detail.level.1": "一级代理统计",
  "pages.report.agent.detail.level.2": "二级代理统计",
  "pages.report.agent.detail.level.3": "商户明细数据",
  "pages.report.agent.detail.column.date": "日期",
  "pages.report.agent.detail.column.profit": "盈亏(平台侧)",
  "pages.report.agent.detail.column.merchantFreespin": "累计FreeSpin",
  "pages.report.agent.detail.column.platformFreespin": "平台FreeSpin",
  "pages.report.agent.detail.column.avgBetAmount": "次均投注金额",
  "pages.report.agent.detail.column.avgUserBetCount": "人均投注次数",
  "pages.report.agent.detail.column.avgUserBetAmount": "人均投注金额",
  "pages.report.agent.detail.column.parentName": "直属上级",
  "pages.report.agent.detail.column.parentPath": "归属路径",
  "pages.report.agent.detail.column.activityAmount": "活动彩金",
  "pages.report.agent.detail.column.merchantId": "商户ID",
  "pages.report.agent.detail.column.gameId": "游戏ID",
  "pages.report.agent.detail.column.statGame": "统计游戏",
  "pages.report.agent.detail.column.statMerchant": "统计商户",
  "pages.report.agent.detail.column.lossAmount": "亏损金额",
  "pages.report.agent.detail.column.lossRate": "亏损率",

  // 系统管理 - 日志
  "pages.system.logs.list.title": "操作日志",
  "pages.system.logs.detail.title": "详情",
  "pages.system.logs.field.id": "日志 ID",
  "pages.system.logs.field.adminId": "管理员ID",
  "pages.system.logs.field.adminName": "管理员姓名",
  "pages.system.logs.field.operatedId": "被操作者ID",
  "pages.system.logs.field.operatedObject": "被操作者",
  "pages.system.logs.field.operatedKeywords": "被操作者",
  "pages.system.logs.field.adminKeywords": "管理员",
  "pages.system.logs.field.admin.placeholder": "请输入姓名或 ID",
  "pages.system.logs.field.subjectType": "主体类型",
  "pages.system.logs.field.module": "模块",
  "pages.system.logs.field.action": "操作",
  "pages.system.logs.field.ip": "IP",
  "pages.system.logs.field.createdAt": "操作时间",
  "pages.system.logs.field.before": "操作前",
  "pages.system.logs.field.after": "变更后",
  "pages.system.logs.action.viewDetail": "查看详情",
  "pages.system.logs.subjectType.platform": "平台",
  "pages.system.logs.subjectType.agent1": "一级代理",
  "pages.system.logs.subjectType.agent2": "二级代理",
  "pages.system.logs.subjectType.merchant": "商户",
  "pages.system.logs.module.role": "角色管理",
  "pages.system.logs.module.admin": "管理员列表",
  "pages.system.logs.module.merchant": "商户管理",
  "pages.system.logs.json.changed": "(已变更)",
  "pages.system.logs.json.missing": "(缺失)",
  "pages.system.logs.json.was": "(原值: {value})",
  "pages.system.logs.json.removed": "(已移除)",
  "pages.system.logs.json.added": "(新增)",
  "pages.system.logs.message.fetchError": "获取日志失败",

  // 系统管理 - 权限管理
  "pages.system.auth.title": "权限管理",
  "pages.system.auth.column.name": "菜单名称",
  "pages.system.auth.column.nameEn": "菜单英文名称",
  "pages.system.auth.column.address": "菜单地址",
  "pages.system.auth.column.icon": "菜单图标",
  "pages.system.auth.column.createdAt": "创建时间",
  "pages.system.auth.column.type": "菜单类型",
  "pages.system.auth.column.type.page": "页面",
  "pages.system.auth.column.type.button": "按钮",
  "pages.system.auth.column.visible": "适用主体",
  "pages.system.auth.column.visible.platform": "平台",
  "pages.system.auth.column.visible.agent1": "一级代理",
  "pages.system.auth.column.visible.agent2": "二级代理",
  "pages.system.auth.column.visible.merchant": "商户",
  "pages.system.auth.column.sort": "排序 (越大越靠前)",
  "pages.system.auth.column.action": "操作",
  "pages.system.auth.action.addChild": "添加子菜单",
  "pages.system.auth.action.addRoot": "添加根菜单",
  "pages.system.auth.action.edit": "编辑",
  "pages.system.auth.action.delete": "删除",
  "pages.system.auth.delete.confirm.title": "提示",
  "pages.system.auth.delete.confirm.content": "确认删除该菜单吗？",
  "pages.system.auth.delete.success": "删除成功",
  "pages.system.auth.delete.failure": "删除失败",
  "pages.system.auth.rootMenu": "根菜单",
  "pages.system.auth.form.parent": "上级节点",
  "pages.system.auth.form.parent.required": "请选择上级节点",
  "pages.system.auth.form.name": "菜单名称",
  "pages.system.auth.form.name.required": "请输入菜单名称",
  "pages.system.auth.form.nameEn": "菜单英文名称",
  "pages.system.auth.form.nameEn.required": "请输入菜单英文名称",
  "pages.system.auth.form.address": "菜单地址",
  "pages.system.auth.form.address.required": "请输入菜单地址",
  "pages.system.auth.form.icon": "图标",
  "pages.system.auth.form.icon.placeholder": "请选择图标",
  "pages.system.auth.form.type": "菜单类型",
  "pages.system.auth.form.type.required": "请选择菜单类型",
  "pages.system.auth.form.visible": "适用主体",
  "pages.system.auth.form.visible.required": "请选择适用主体",
  "pages.system.auth.form.sort": "排序",
  "pages.system.auth.form.sort.required": "请输入排序",
  "pages.system.auth.form.sort.error.max": "排序不能超过1000",
  "pages.system.auth.edit.title": "编辑菜单",
  "pages.system.auth.add.title": "添加菜单",
  "pages.system.auth.message.updateSuccess": "更新成功",
  "pages.system.auth.message.addSuccess": "添加成功",
  "pages.system.auth.message.error": "操作失败",

  "pages.searchTable.createForm.newRule": "新建规则",
  "pages.searchTable.updateForm.ruleConfig": "规则配置",
  "pages.searchTable.updateForm.basicConfig": "基本信息",
  "pages.searchTable.updateForm.ruleName.nameLabel": "规则名称",
  "pages.searchTable.updateForm.ruleName.nameRules": "请输入规则名称！",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "规则描述",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "请输入至少五个字符",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "请输入至少五个字符的规则描述！",
  "pages.searchTable.updateForm.ruleProps.title": "配置属性",
  "pages.searchTable.updateForm.object": "监控对象",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "规则模板",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "规则类型",
  "pages.searchTable.updateForm.schedulingPeriod.title": "设定调度周期",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "开始时间",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "请选择开始时间！",
  "pages.searchTable.titleDesc": "描述",
  "pages.searchTable.ruleName": "规则名称为必填项",
  "pages.searchTable.titleCallNo": "服务调用次数",
  "pages.searchTable.titleStatus": "状态",
  "pages.searchTable.nameStatus.default": "默认",
  "pages.searchTable.nameStatus.running": "运行中",
  "pages.searchTable.nameStatus.online": "已上线",
  "pages.searchTable.nameStatus.abnormal": "异常",
  "pages.searchTable.titleUpdatedAt": "上次调度时间",
  "pages.searchTable.exception": "请输入异常原因！",
  "pages.searchTable.titleOption": "操作",
  "pages.searchTable.config": "配置",
  "pages.searchTable.subscribeAlert": "订阅警报",
  "pages.searchTable.title": "查询表格",
  "pages.searchTable.new": "新建",
  "pages.searchTable.chosen": "已选择",
  "pages.searchTable.item": "项",
  "pages.searchTable.totalServiceCalls": "服务调用次数总计",
  "pages.searchTable.tenThousand": "万",
  "pages.searchTable.batchDeletion": "批量删除",
  "pages.searchTable.batchApproval": "批量审批",

  // 系统管理 - 角色管理
  "pages.system.role.list.title": "角色管理",
  "pages.system.role.action.add": "添加角色",
  "pages.system.role.action.edit": "编辑",
  "pages.system.role.action.delete": "删除",
  "pages.system.role.modal.title.add": "添加角色",
  "pages.system.role.modal.title.edit": "编辑角色",
  "pages.system.role.form.name": "角色名称",
  "pages.system.role.form.name.required": "请输入角色名称",
  "pages.system.role.form.status": "状态",
  "pages.system.role.form.status.open": "开启",
  "pages.system.role.form.status.close": "停用",
  "pages.system.role.form.menu": "菜单权限",
  "pages.system.role.column.name": "名称",
  "pages.system.role.column.searchName": "搜索角色",
  "pages.system.role.column.searchPlaceholder": "名称/ID",
  "pages.system.role.column.updatedAt": "更新时间",
  "pages.system.role.column.status": "开启/停用",
  "pages.system.role.message.fetchMenuFailed": "获取权限菜单失败",
  "pages.system.role.message.deleteConfirm.title": "确认删除角色",
  "pages.system.role.message.deleteConfirm.content":
    "删除后数据无法恢复，已配置该角色的管理员账号，对应的角色功能将不可见，请谨慎操作！",
  "pages.system.role.message.deleteSuccess": "删除成功",
  "pages.system.role.message.deleteFailed": "删除失败",
  "pages.system.role.message.statusUpdateSuccess": "状态更新成功",
  "pages.system.role.message.statusUpdateFailed": "状态更新失败",
  "pages.system.role.message.stopConfirm.title": "确认停用角色",
  "pages.system.role.message.stopConfirm.content":
    "停用后，已配置该角色的管理员账号，对应的角色功能将不可见，请谨慎操作！",
  "pages.system.role.message.addSuccess": "添加成功",
  "pages.system.role.message.updateSuccess": "更新成功",
  "pages.system.role.message.operationFailed": "操作失败",
  "pages.system.role.tree.unnamed": "未命名",

  // 系统管理 - 管理员管理
  "pages.system.manager.title": "管理员管理",
  "pages.system.manager.list.title": "管理员列表",
  "pages.system.manager.action.add": "添加管理员",
  "pages.system.manager.action.edit": "编辑",
  "pages.system.manager.action.delete": "删除",
  "pages.system.manager.action.password": "修改密码",
  "pages.system.manager.column.id": "ID",
  "pages.system.manager.column.username": "账号",
  "pages.system.manager.column.nickname": "姓名",
  "pages.system.manager.column.contact": "联系方式",
  "pages.system.manager.column.role": "角色",
  "pages.system.manager.column.createdAt": "创建时间",
  "pages.system.manager.column.loginTime": "最后登录时间",
  "pages.system.manager.column.loginIp": "最后登录 IP",
  "pages.system.manager.column.status": "启用/停用",
  "pages.system.manager.column.action": "操作",
  "pages.system.manager.search.placeholder": "请输入姓名或 ID",
  "pages.system.manager.search.title": "搜索管理员",
  "pages.system.manager.role.unknown": "未知角色({id})",
  "pages.system.manager.status.enable": "启用",
  "pages.system.manager.status.disable": "停用",
  "pages.system.manager.delete.confirm.title": "确认删除管理员",
  "pages.system.manager.delete.confirm.content":
    "删除后数据无法恢复，请谨慎操作！",
  "pages.system.manager.status.confirm.title": "停用管理员",
  "pages.system.manager.status.confirm.content":
    "停用后，该管理员将无法登录系统，请谨慎操作！",
  "pages.system.manager.message.fetchRolesFailed": "获取角色列表失败",
  "pages.system.manager.message.updateStatusSuccess": "状态更新成功",
  "pages.system.manager.message.updateStatusFailed": "状态更新失败",
  "pages.system.manager.message.deleteSuccess": "删除成功",
  "pages.system.manager.message.deleteFailed": "删除失败",
  "pages.system.manager.form.username": "登录账号",
  "pages.system.manager.form.username.required": "请输入登录账号",
  "pages.system.manager.form.password": "登录密码",
  "pages.system.manager.form.password.required": "请输入登录密码",
  "pages.system.manager.form.password.min": "密码长度不能少于6位",
  "pages.system.manager.form.nickname": "管理员姓名",
  "pages.system.manager.form.nickname.required": "请输入管理员姓名",
  "pages.system.manager.form.contact": "联系方式",
  "pages.system.manager.form.contact.required": "请输入联系方式",
  "pages.system.manager.form.role": "所属角色",
  "pages.system.manager.form.role.required": "请选择所属角色",
  "pages.system.manager.form.remark": "备注",
  "pages.system.manager.form.remark.placeholder": "请输入备注",
  "pages.system.manager.form.oldPassword": "旧密码",
  "pages.system.manager.form.oldPassword.required": "请输入旧密码",
  "pages.system.manager.form.newPassword": "新密码",
  "pages.system.manager.form.newPassword.required": "请输入新密码",
  "pages.system.manager.form.newPassword.min": "密码最少6位",
  "pages.system.manager.form.newPassword.noSpace": "密码不能包含空格",
  "pages.system.manager.form.confirmPassword": "确认密码",
  "pages.system.manager.form.confirmPassword.required": "请再次输入密码",
  "pages.system.manager.form.confirmPassword.mismatch": "两次输入的密码不一致",
  "pages.system.manager.message.createSuccess": "添加成功",
  "pages.system.manager.message.updateSuccess": "更新成功",
  "pages.system.manager.message.passwordSuccess": "密码修改成功",
  "pages.system.manager.edit.title": "编辑管理员",
  "pages.system.manager.add.title": "添加管理员",
  "pages.system.manager.password.title": "修改密码",

  // 系统管理 - 公告管理
  "pages.system.notice.list.title": "公告管理",
  "pages.system.notice.column.id": "ID",
  "pages.system.notice.column.type": "公告类型",
  "pages.system.notice.column.title": "标题",
  "pages.system.notice.column.titleEn": "英文标题",
  "pages.system.notice.column.content": "内容",
  "pages.system.notice.column.contentEn": "英文内容",
  "pages.system.notice.column.createdAt": "发布时间",
  "pages.system.notice.column.action": "操作",
  "pages.system.notice.action.add": "新增公告",
  "pages.system.notice.action.detail": "详情",
  "pages.system.notice.action.edit": "编辑",
  "pages.system.notice.action.delete": "删除",
  "pages.system.notice.type.versionUpdate": "版本更新",
  "pages.system.notice.type.systemNotice": "系统公告",
  "pages.system.notice.drawer.add.title": "新增公告",
  "pages.system.notice.drawer.edit.title": "编辑公告",
  "pages.system.notice.drawer.detail.title": "公告详情",
  "pages.system.notice.form.type.required": "请选择公告类型",
  "pages.system.notice.form.title.placeholder": "请输入公告标题",
  "pages.system.notice.form.title.required": "请输入公告标题",
  "pages.system.notice.form.titleEn.placeholder": "请输入英文公告标题",
  "pages.system.notice.form.content.placeholder": "请输入公告内容",
  "pages.system.notice.form.content.required": "请输入公告内容",
  "pages.system.notice.form.contentEn.placeholder": "请输入英文公告内容",
  "pages.system.notice.message.createSuccess": "新增成功",
  "pages.system.notice.message.updateSuccess": "更新成功",
  "pages.system.notice.message.deleteSuccess": "删除成功",
  "pages.system.notice.message.deleteFailed": "删除失败",
  "pages.system.notice.message.operationFailed": "操作失败",
  "pages.system.notice.delete.confirm.title": "确认删除",
  "pages.system.notice.delete.confirm.content":
    "确认删除该公告吗？删除后数据无法恢复，请谨慎操作！",
  "pages.system.notice.column.visibleLevels": "可见层级",
  "pages.system.notice.visibleLevels.platform": "平台",
  "pages.system.notice.visibleLevels.agent1": "一级代理",
  "pages.system.notice.visibleLevels.agent2": "二级代理",
  "pages.system.notice.visibleLevels.merchant": "商户",
  "pages.system.notice.form.visibleLevels.required": "请选择可见层级",

  // 留存分析
  "pages.user_analysis.retention.tab.game": "按游戏",
  "pages.user_analysis.retention.tab.merchant": "按商户",
  "pages.user_analysis.retention.filter.merchant": "商户选择",
  "pages.user_analysis.retention.filter.game": "游戏选择",
  "pages.user_analysis.retention.stat.title": "数据总览",
  "pages.user_analysis.retention.stat.totalUsers": "总用户数",
  "pages.user_analysis.retention.stat.newUsers": "新增用户数",
  "pages.user_analysis.retention.stat.d1Retention": "D1留存率",
  "pages.user_analysis.retention.stat.d7Retention": "D7留存率",
  "pages.user_analysis.retention.stat.churnRate": "用户流失率",
  "pages.user_analysis.retention.stat.dau": "日活跃用户数(DAU)",
  "pages.user_analysis.retention.stat.wau": "周活跃用户数(WAU)",
  "pages.user_analysis.retention.stat.mau": "月活跃用户数(MAU)",
  "pages.user_analysis.retention.stat.avgOnlineTime": "平均游戏在线时长",
  "pages.user_analysis.retention.stat.avgBetCount": "人均游戏次数",
  "pages.user_analysis.retention.stat.today": "今日",
  "pages.user_analysis.retention.stat.tooltip.totalUsers":
    "总用户数：在当前筛选条件下，累计登录的用户数(去重)",
  "pages.user_analysis.retention.stat.tooltip.newUsers":
    "新增用户数：在当前筛选条件下，新增注册的用户数(去重)",
  "pages.user_analysis.retention.stat.tooltip.d1Retention":
    "D1留存率：在当前筛选条件下，用户在D0（T0）产生过下注行为，D1（T+1）也再次产生下注行为",
  "pages.user_analysis.retention.stat.tooltip.d7Retention":
    "D7留存率：在当前筛选条件下，用户在D0（T0）产生过下注行为，D7（T+7）也再次产生下注行为",
  "pages.user_analysis.retention.stat.tooltip.churnRate":
    "用户流失率：在当前筛选条件下，在D0（T0)活跃过的用户，在D1（T+1）不再活跃",
  "pages.user_analysis.retention.stat.tooltip.dau":
    "DAU：在当前筛选条件下，一天内至少发生过一次活跃行为的去重用户",
  "pages.user_analysis.retention.stat.tooltip.wau":
    "WAU：在当前筛选条件下，一周内至少发生过一次活跃行为的去重用户",
  "pages.user_analysis.retention.stat.tooltip.mau":
    "MAU：在当前筛选条件下，一月内至少发生过一次活跃行为的去重用户",
  "pages.user_analysis.retention.stat.tooltip.avgOnlineTime":
    "平均在线时长：在当前筛选条件下，累计用户的平均在线时长",
  "pages.user_analysis.retention.stat.tooltip.avgBetCount":
    "人均游戏次数：在当前筛选条件下，累计用户的平均游戏次数（1Spin=1次）",
  "pages.user_analysis.retention.online.title": "在线行为分析",
  "pages.user_analysis.retention.online.yAxis": "人均在线时长 (min)",
  "pages.user_analysis.retention.online.tooltip": "人均在线时长",
  "pages.user_analysis.retention.country.title": "国家登录率 TOP10",
  "pages.user_analysis.retention.country.yAxis": "登录玩家数",
  "pages.user_analysis.retention.trend.title": "活跃趋势分析",
  "pages.user_analysis.retention.trend.yAxis.avgBet": "人均游戏次数 (次)",
  "pages.user_analysis.retention.trend.yAxis.onlineTime": "平均在线时长 (min)",
  "pages.user_analysis.retention.loss.title": "流失率分析",
  "pages.user_analysis.retention.loss.yAxis": "流失率 (%)",
  "pages.user_analysis.retention.loss.top10.title": "高流失{type} TOP10",
  "pages.user_analysis.retention.loss.tab.game": "游戏",
  "pages.user_analysis.retention.loss.tab.merchant": "商户",
  "pages.user_analysis.retention.loss.tab.country": "国家",
  "pages.user_analysis.retention.table.overview.title": "用户留存总览",
  "pages.user_analysis.retention.table.activeLoss.title": "活跃/流失明细",
  "pages.user_analysis.retention.table.column.name": "名称",
  "pages.user_analysis.retention.table.column.id": "ID",
  "pages.user_analysis.retention.table.column.totalActive": "累计下注人数",
  "pages.user_analysis.retention.table.column.firstLogin": "新增注册人数",
  "pages.user_analysis.retention.table.column.firstActive": "新增下注人数",
  "pages.user_analysis.retention.table.column.totalBetNum": "累计下注次数",
  "pages.user_analysis.retention.table.column.retention": "D{day} 留存",
  "pages.user_analysis.retention.table.column.date": "日期",
  "pages.user_analysis.retention.table.column.regActiveFirstLoginRate":
    "新增转化率",
  "pages.user_analysis.retention.table.column.regActiveFirstLoginRate.tooltip":
    "当天注册且在15天内下注人数/当天注册人数",
  "pages.user_analysis.retention.table.column.dau": "DAU",
  "pages.user_analysis.retention.table.column.wau": "WAU",
  "pages.user_analysis.retention.table.column.mau": "MAU",
  "pages.user_analysis.retention.table.column.loginD1": "D1访问留存",
  "pages.user_analysis.retention.table.column.activeD": "D{day}下注留存",
  "pages.user_analysis.retention.chart.noData": "暂无数据",
  "pages.user_analysis.retention.chart.tooltip.all":
    "全部：当前时间范围为全部，默认展示近30天数据",
  "pages.user_analysis.retention.chart.tooltip.today":
    "今日：当前时间范围为全部，展示今日数据",
  "pages.user_analysis.country_area.stat.title": "数据总览",
  "pages.user_analysis.country_area.stat.totalCountry": "总国家数",
  "pages.user_analysis.country_area.stat.totalLogin": "总用户数",
  "pages.user_analysis.country_area.stat.totalBet": "总投注金额",
  "pages.user_analysis.country_area.stat.totalScore": "总返奖金额",
  "pages.user_analysis.country_area.stat.totalGgr": "GGR",
  "pages.user_analysis.country_area.stat.tooltip.totalCountry":
    "总国家数：在当前筛选条件下，有数据的国家数量",
  "pages.user_analysis.country_area.stat.tooltip.totalLogin":
    "总用户数：在当前筛选条件下，累计用户数",
  "pages.user_analysis.country_area.stat.tooltip.totalBet":
    "总投注金额：累计投注金额，单位 USD",
  "pages.user_analysis.country_area.stat.tooltip.totalScore":
    "总返奖金额：累计返奖金额，单位 USD",
  "pages.user_analysis.country_area.stat.tooltip.totalGgr":
    "GGR：总投注 - 总返奖，单位 USD",
  "pages.user_analysis.country_area.distribution.topCountry": "TOP国家",
  "pages.user_analysis.country_area.distribution.country": "国家",
  "pages.user_analysis.retention.chart.tooltip.yesterday":
    "昨日：当前时间范围为全部，展示昨日数据",
  "pages.user_analysis.retention.chart.tooltip.last7":
    "近7天：当前时间范围为全部，展示近7天数据",
  "pages.user_analysis.retention.chart.tooltip.last15":
    "近15天：当前时间范围为全部，展示近15天数据",
  "pages.user_analysis.retention.chart.tooltip.last30":
    "近30天：当前时间范围为全部，展示近30天数据",

  // 行为分析
  "pages.user_analysis.action.filter.merchant": "商户选择",
  "pages.user_analysis.action.filter.game": "游戏选择",
  "pages.user_analysis.action.overview.title": "数据总览",
  "pages.user_analysis.action.overview.step2Rate": "首帧成功率",
  "pages.user_analysis.action.overview.step4Rate": "可操作成功率",
  "pages.user_analysis.action.overview.step5Rate": "首转转化率",
  "pages.user_analysis.action.overview.step6Rate": "前3转转化率",
  "pages.user_analysis.action.overview.step7Rate": "前10转转化率",
  "pages.user_analysis.action.funnel.title": "核心漏斗与分析",
  "pages.user_analysis.action.funnel.dataLegend":
    "数据含义：当前值/初始值百分比|当前值/上一步值|当前值",
  "pages.user_analysis.action.funnel.topGames.title": "游戏TOP5",
  "pages.user_analysis.action.funnel.stage.enterGame": "进入游戏",
  "pages.user_analysis.action.funnel.stage.enterRoom": "进入房间",
  "pages.user_analysis.action.funnel.stage.startBet": "发起下注",
  "pages.user_analysis.action.funnel.stage.validBet": "有效下注",
  "pages.user_analysis.action.funnel.stage.paySuccess": "支付成功",
  "pages.user_analysis.action.funnel.stage.step1": "进入人数",
  "pages.user_analysis.action.funnel.stage.step2": "首次加载",
  "pages.user_analysis.action.funnel.stage.step3": "首帧",
  "pages.user_analysis.action.funnel.stage.step4": "可操作",
  "pages.user_analysis.action.funnel.stage.step41": "游戏介绍",
  "pages.user_analysis.action.funnel.stage.step42": "查看规则",
  "pages.user_analysis.action.funnel.stage.step5": "完成首转",
  "pages.user_analysis.action.funnel.stage.step6": "完成3转",
  "pages.user_analysis.action.funnel.stage.step7": "完成10转",
  "pages.user_analysis.action.funnel.stage.step8": "首次Feature",
  "pages.user_analysis.action.funnel.stage.step1.tooltip":
    "在商户端点击开始游戏（获取游戏URL）",
  "pages.user_analysis.action.funnel.stage.step2.tooltip":
    "第一个进度条加载完毕",
  "pages.user_analysis.action.funnel.stage.step3.tooltip": "start按钮出现",
  "pages.user_analysis.action.funnel.stage.step4.tooltip": "点击start按钮",
  "pages.user_analysis.action.funnel.stage.step41.tooltip":
    "用户点击Click to continue",
  "pages.user_analysis.action.funnel.stage.step42.tooltip":
    "用户查看Paytable规则",
  "pages.user_analysis.action.funnel.stage.step5.tooltip": "点击spin按钮",
  "pages.user_analysis.action.funnel.stage.step6.tooltip": "spin3次成功",
  "pages.user_analysis.action.funnel.stage.step7.tooltip": "spin10次成功",
  "pages.user_analysis.action.funnel.stage.step8.tooltip": "触发其他玩法",
  "pages.user_analysis.action.funnel.metric.enterCount": "进入人数",
  "pages.user_analysis.action.funnel.metric.successCount": "成功人数",
  "pages.user_analysis.action.funnel.metric.successRate": "成功率",
  "pages.user_analysis.action.funnel.metric.lossCount": "流失人数",
  "pages.user_analysis.action.funnel.metric.lossRate": "流失率",
  "pages.user_analysis.action.detail.label.enter": "进入",
  "pages.user_analysis.action.detail.label.success": "成功",
  "pages.user_analysis.action.detail.label.loss": "流失",
  "pages.user_analysis.action.funnel.metric.wow": "今日/环比",
  "pages.user_analysis.action.mainTable.loadFailed": "加载按游戏主列表失败",
  "pages.user_analysis.action.funnel.chart.labelText":
    "{stepName}:{value}({rate}|{preRate})",
  "pages.user_analysis.action.table.tooltip.attributionByEntryDate":
    "按进入日归因：列表中的日期=玩家首次进入游戏的日期。他们后续的完成首转、触发 Feature 等所有操作，都会记入这一天。\n受筛选期限制：数据只统计到您筛选的结束日期。比如筛选“13-15日”，则不统计 13 日进入的玩家在 16 日发生的操作。",
  "pages.user_analysis.action.table.title": "主列表区",
  "pages.user_analysis.action.table.column.gameName": "游戏名称",
  "pages.user_analysis.action.table.column.launchTime": "上线时间",
  "pages.user_analysis.action.table.column.totalUserCount": "新增注册人数",
  "pages.user_analysis.action.table.column.totalUserCount.tooltip":
    "在指定游戏，指定日期的新增注册人数",
  "pages.user_analysis.action.table.column.activeUserCount": "累计下注人数",
  "pages.user_analysis.action.table.column.activeUserCount.tooltip":
    "在指定游戏，指定日期的下注人数，同一日同一个玩家下注多次需要去重，只计算为1个下注人数，不同日同一个玩家无需去重",
  "pages.user_analysis.action.table.column.enterCount": "进入人数",
  "pages.user_analysis.action.table.column.successRate": "成功率",
  "pages.user_analysis.action.table.column.step1.tooltip":
    "在商户端点击开始游戏（获取游戏URL）",
  "pages.user_analysis.action.table.column.step2.tooltip":
    "第一个进度条加载完毕。左侧为转化率，右侧为实际人数。除157、158、160、668以外，其他游戏数据均为补入",
  "pages.user_analysis.action.table.column.step3.tooltip":
    "两个进度条加载完毕，进入start。左侧为转化率，右侧为实际人数。除157、158、160、668以外，其他游戏数据均为补入",
  "pages.user_analysis.action.table.column.step4.tooltip":
    "用户可进行任意交互操作。左侧为转化率，右侧为实际人数。除157、158、160、668以外，其他游戏数据均为补入",
  "pages.user_analysis.action.table.column.step41.tooltip":
    "用户点击Click to continue",
  "pages.user_analysis.action.table.column.step42.tooltip": "用户查看规则",
  "pages.user_analysis.action.table.column.step5.tooltip":
    "spin1次成功。左侧为转化率，右侧为实际人数",
  "pages.user_analysis.action.table.column.step6.tooltip":
    "spin3次成功。左侧为转化率，右侧为实际人数",
  "pages.user_analysis.action.table.column.step7.tooltip":
    "spin10次成功。左侧为转化率，右侧为实际人数",
  "pages.user_analysis.action.table.column.step8.tooltip":
    "触发其他玩法。左侧为转化率，右侧为实际人数",
  "pages.user_analysis.action.section.pending":
    "当前为页面骨架，已准备 {count} 个筛选参数，待接入真实接口数据",
  "pages.user_analysis.action.section.staticApi":
    "数据来源 /api/v1/sys/getUserTrackStatic",
  "pages.user_analysis.action.section.listApi":
    "数据来源 /api/v1/sys/getUserTrackStaticList",
  "pages.user_analysis.action.section.scope":
    "当前阶段仅保留筛选区、总览区、漏斗区、主列表区；右侧模块与一场列表不纳入实现范围",

  // 国家地区分析
  "pages.user_analysis.country_area.top10.title": "国家 Top10 分布",
  "pages.user_analysis.country_area.metric.login": "登录人数",
  "pages.user_analysis.country_area.metric.active": "活跃人数",
  "pages.user_analysis.country_area.metric.bet": "下注金额",
  "pages.user_analysis.country_area.metric.ggr": "GGR",

  // 国家分析表格
  "pages.user_analysis.country_area.table.column.country": "国家",
  "pages.user_analysis.country_area.table.column.gameCount": "统计游戏",
  "pages.user_analysis.country_area.table.column.merchantCount": "统计商户",
  "pages.user_analysis.country_area.table.column.userCount": "新增注册人数",
  "pages.user_analysis.country_area.table.column.betCount": "累计下注次数",
  "pages.user_analysis.country_area.table.column.betUserCount": "累计下注人数",
  "pages.user_analysis.country_area.table.column.betAmount": "投注金额",
  "pages.user_analysis.country_area.table.column.winAmount": "返奖金额",
  "pages.user_analysis.country_area.table.column.merchantFs": "商户Freespin",
  "pages.user_analysis.country_area.table.column.platFs": "平台Freespin",
  "pages.user_analysis.country_area.table.column.ggr": "GGR",
  "pages.user_analysis.country_area.table.column.rtp": "RTP",
  "pages.user_analysis.country_area.table.column.avgBetCount": "人均投注次数",
  "pages.user_analysis.country_area.table.column.avgBetAmount": "人均投注金额",
  "pages.user_analysis.country_area.table.column.avgBetPerBet": "次均投注金额",
  "pages.user_analysis.country_area.table.tooltip.avgBetCount":
    "人均投注次数：投注次数/用户数",
  "pages.user_analysis.country_area.table.tooltip.avgBetAmount":
    "人均投注金额：投注金额/用户数",
  "pages.user_analysis.country_area.table.tooltip.avgBetPerBet":
    "次均投注金额：投注金额/投注次",
  "pages.user_analysis.country_area.table.title": "详细数据表格",

  // 购买奖金统计
  "pages.statics.buybonus.stat.title": "数据总览",
  "pages.statics.buybonus.stat.description": "数据15mins刷新一次",
  "pages.statics.buybonus.stat.tooltip.totalBetUserCount":
    " 总下注人数：统计时间内下注的去重用户总数",
  "pages.statics.buybonus.stat.tooltip.totalBuyUserCount":
    "总购买人数：在当前筛选条件下，累计购买Buybonus的用户数(去重)",
  "pages.statics.buybonus.stat.tooltip.totalBuyBetCount":
    "总购买次数：在当前筛选条件下，累计购买Buybonus的总次数(无需去重)",
  "pages.statics.buybonus.stat.tooltip.totalBuyBetAmount":
    "总购买金额：在当前筛选条件下，累计购买Buybonus的总金额",
  "pages.statics.buybonus.stat.tooltip.totalBuyScoreAmount":
    "总返还金额：在当前筛选条件下，通过购买Buybonus后的累计返还金额",
  "pages.statics.buybonus.stat.tooltip.totalProfitAmount":
    "总利润金额：在当前筛选条件下，通过购买Buybonus后，平台获得的利润金额(总购买金额-总返还金额）",
  "pages.statics.buybonus.stat.tooltip.rtp":
    "RTP：在当前筛选条件下，累计购买Buybonus的用户回报率\n（总返奖金额/总购买金额）",
  "pages.statics.buybonus.stat.tooltip.penetration":
    "渗透率 = (购买值 / 总值) * 100%",

  "pages.statics.buybonus.column.game": "游戏",
  "pages.statics.buybonus.column.userCount": "购买人数",
  "pages.statics.buybonus.column.betCount": "购买次数",
  "pages.statics.buybonus.column.betAmount": "购买金额",
  "pages.statics.buybonus.column.scoreAmount": "返还金额",
  "pages.statics.buybonus.column.scoreAmount.tooltip": "不包含彩金",
  "pages.statics.buybonus.column.profitAmount": "利润金额",
  "pages.statics.buybonus.column.rtp": "RTP",
  "pages.statics.buybonus.column.buyBonusCount": "档位数",
  "pages.statics.buybonus.column.buyBonusCount.tooltip":
    "当前游戏可购买的BuyBonus档位数",
  "pages.statics.buybonus.column.coreBuyBonusType": "核心档位",
  "pages.statics.buybonus.column.coreBuyBonusType.tooltip":
    "筛选条件下，购买次数最多的挡位",
  "pages.statics.buybonus.table.title": "购买奖金统计",

  "pages.statics.buybonus.detail.column.date": "日期",
  "pages.statics.buybonus.detail.column.type": "购买档位",
  "pages.statics.buybonus.detail.typeValue": "档位 {type}",
  "pages.statics.buybonus.detail.tab.daily": "按日期",
  "pages.statics.buybonus.detail.tab.type": "按档位",
  "pages.statics.buybonus.detail.slot.line1":
    "人数:{userCount} 次数:{betCount}",
  "pages.statics.buybonus.detail.slot.s0": "S0（基础游戏）",
  "pages.statics.buybonus.detail.slot.line2":
    "购买金额:{betAmount} 返奖金额:{scoreAmount} RTP:{rtp}",
  "pages.statics.buybonus.stat.penetration": "渗透率",

  // 大厅统计
  "pages.statics.hall.filter.game": "游戏",
  "pages.statics.hall.summary.hallExposure": "大厅入口曝光量",
  "pages.statics.hall.summary.hallExposure.tooltip":
    "玩家进入游戏时，游戏主界面中大厅入口按钮的曝光次数。每个玩家每次进入新的游戏，计1次。",
  "pages.statics.hall.summary.hallWakeup": "大厅唤醒次数",
  "pages.statics.hall.summary.hallWakeup.tooltip":
    "玩家每次点击大厅按钮并展开大厅弹窗的次数。",
  "pages.statics.hall.summary.activityClick": "活动模块点击量",
  "pages.statics.hall.summary.activityClick.tooltip":
    "玩家每次点击活动模块的次数，点击一次计1次。",
  "pages.statics.hall.summary.gameClick": "游戏模块点击量",
  "pages.statics.hall.summary.gameClick.tooltip":
    "玩家每次点击游戏模块的次数，点击一次计1次。",
  "pages.statics.hall.trend.title": "大厅活跃数据",
  "pages.statics.hall.trend.hallExposure": "大厅曝光",
  "pages.statics.hall.trend.hallWakeup": "大厅唤醒次数",
  "pages.statics.hall.trend.activityExposure": "活动曝光(PV)",
  "pages.statics.hall.trend.gameExposure": "游戏曝光(PV)",
  "pages.statics.hall.distribution.title": "活动流量分布",
  "pages.statics.hall.distribution.total": "累计freespin",
  "pages.statics.hall.distribution.merchant": "商户freespin",
  "pages.statics.hall.distribution.sevenDay": "七日freespin",
  "pages.statics.hall.distribution.surprise": "惊喜宝投活动",
  "pages.statics.hall.tab.activity": "按活动",
  "pages.statics.hall.tab.game": "按游戏",
  "pages.statics.hall.tab.merchant": "按商户",
  "pages.statics.hall.column.activity": "活动名称",
  "pages.statics.hall.column.game": "游戏名称",
  "pages.statics.hall.column.merchant": "所属商户",
  "pages.statics.hall.column.activityType": "活动类型",
  "pages.statics.hall.column.exposurePv": "曝光量(PV)",
  "pages.statics.hall.column.exposureUv": "曝光量(UV)",
  "pages.statics.hall.column.click": "点击量",
  "pages.statics.hall.column.jump": "跳转量",
  "pages.statics.hall.column.clickRate": "点击率",
  "pages.statics.hall.column.clickRate.tooltip": "点击量/曝光量(PV)。",
  "pages.statics.hall.column.activityExposurePv.tooltip":
    "该活动卡片在大厅面板中被成功渲染并展现给玩家的总浏览次数。",
  "pages.statics.hall.column.activityExposureUv.tooltip":
    "该活动卡片在大厅面板中被成功渲染并展现给玩家的总浏览人数。",
  "pages.statics.hall.column.activityClick.tooltip":
    "玩家在大厅内点击活动的总次数。",
  "pages.statics.hall.column.activityJump.tooltip":
    "玩家在大厅内点击游戏并成功跳转的次数。",
  "pages.statics.hall.column.gameExposurePv.tooltip":
    "该游戏卡片在大厅面板中被成功渲染并展现给玩家的总浏览次数。",
  "pages.statics.hall.column.gameExposureUv.tooltip":
    "该游戏卡片在大厅面板中被成功渲染并展现给玩家的总浏览人数。",
  "pages.statics.hall.column.gameClick.tooltip":
    "玩家在大厅内点击游戏的总次数。",
  "pages.statics.hall.column.gameJump.tooltip":
    "玩家在大厅内点击游戏并成功跳转的次数。",
  "pages.statics.hall.column.merchantExposurePv.tooltip":
    "大厅悬浮球在游戏中被成功渲染并展现给玩家的总浏览次数。",
  "pages.statics.hall.column.merchantHallWakeup.tooltip":
    "玩家每次点击大厅按钮，展开大厅弹窗的次数。",
  "pages.statics.hall.column.merchantHallWakeupRate.tooltip":
    "商户下，游玩任意游戏的玩家主动点击悬浮球呼出大厅面板的比例。（大厅展开点击量/大厅悬浮球曝光量(PV)）*100%。",
  "pages.statics.hall.column.merchantActivityClick.tooltip":
    "玩家在大厅内点击活动的总次数。",
  "pages.statics.hall.column.merchantActivityJump.tooltip":
    "玩家在大厅内点击活动并成功跳转的次数。",
  "pages.statics.hall.column.merchantGameClick.tooltip":
    "玩家在大厅内点击游戏的总次数。",
  "pages.statics.hall.column.merchantGameJump.tooltip":
    "玩家在大厅内点击游戏，成功拉起并加载目标游戏的总次数。",
  "pages.statics.hall.column.walletType": "钱包类型",
  "pages.statics.hall.column.hallSwitch": "大厅开关状态",
  "pages.statics.hall.column.hallWakeup": "大厅唤醒次数",
  "pages.statics.hall.column.hallWakeupRate": "大厅唤醒率",
  "pages.statics.hall.column.activityClick": "活动点击量",
  "pages.statics.hall.column.activityJump": "活动跳转量",
  "pages.statics.hall.column.gameClick": "游戏点击量",
  "pages.statics.hall.column.gameJump": "游戏跳转量",
  "pages.statics.hall.activity.total": "累计freespin",
  "pages.statics.hall.activity.sevenDay": "七日freespin",
  "pages.statics.hall.activity.surprise": "惊喜宝投活动",
  "pages.statics.hall.enabled": "已开启",
  "pages.statics.hall.disabled": "未开启",
  "pages.statics.hall.message.fetchFailed": "大厅统计数据加载失败",

  // 通用
  "pages.common.copySuccess": "复制成功",
  "pages.common.action": "操作",
  "pages.common.all": "全部",
  "pages.common.today": "今日",
  "pages.common.last7days": "近7天",
  "pages.common.last30days": "近30天",
  "pages.common.ok": "确定",
  "pages.common.cancel": "取消",
  "pages.common.close": "关闭",
  "pages.common.save": "保存",
  "pages.common.next": "下一步",
  "pages.common.previous": "上一步",
  "pages.common.search": "搜索",
  "pages.common.reset": "重置",
  "pages.common.pagination.showTotal":
    "第 {range0}-{range1} 条/总共 {total} 条",
  "pages.common.placeholder": "请输入",
  "pages.common.select.placeholder": "请选择",
  "pages.common.placeholder.select": "请选择",
  "pages.common.date.start": "开始日期",
  "pages.common.date.end": "结束日期",
  "pages.common.date.preset.today": "今日",
  "pages.common.date.preset.yesterday": "昨日",
  "pages.common.date.preset.last7Days": "近7天",
  "pages.common.date.preset.last15Days": "近15天",
  "pages.common.date.preset.last30Days": "近30天",
  "pages.common.date.preset.all": "全部",
  "pages.common.date.preset.thisMonth": "本月",
  "pages.common.date.preset.lastMonth": "上月",
  "pages.common.saveSuccess": "保存成功",
  "pages.common.publishSuccess": "发布成功",
  "pages.common.deleteSuccess": "删除成功",
  "pages.common.exportFailed": "导出失败",
  "pages.common.error.decimal2": "最多允许两位小数",
  "pages.common.createdAt": "创建时间",
  "pages.common.time.local": "当地时间",
  "pages.common.time.beijing": "北京时间",
  "pages.common.id": "ID",
  "pages.common.error.noChinese": "不允许输入中文",
  "pages.common.platform": "平台",
  "pages.common.agent.level.1": "一级代理",
  "pages.common.agent.level.2": "二级代理",
  "pages.common.agent.placeholder": "请选择代理",
  "pages.common.merchant.label": "商户",
  "pages.common.merchant.select": "选择商户",
  "pages.common.merchant.placeholder": "请选择商户",
  "pages.common.unknown": "未知",
  "pages.common.upload": "上传",
  "pages.common.upload.error": "上传失败",
  "pages.common.reason.upgrade": "代理级别-升级",
  "pages.common.reason.downgrade": "代理级别-降级",
  "pages.common.reason.upgrade.tip": "升级后，树下代理也会跟随升级，请谨慎操作",
  "pages.common.reason.downgrade.tip":
    "降级后，该代理树下无法绑定二级代理，请谨慎操作",
  "pages.common.reason.required": "请填写原因",
  "pages.common.reason.placeholder": "请填写原因，必填",
  "pages.common.totalRecords": "共 {total} 条记录",
  "pages.common.empty": "暂无数据",

  "pages.common.custom": "自定义",
  "pages.common.unit.min": "min",
  "pages.common.label.online": "上线",
  // 网络与请求错误
  "pages.common.error.network": "网络连接异常，请检查网络",
  "pages.common.error.timeout": "请求超时，请检查网络连接",
  "pages.common.error.400": "请求错误，请检查参数",
  "pages.common.error.401": "未授权，请重新登录",
  "pages.common.error.403": "拒绝访问",
  "pages.common.error.404": "请求错误,未找到该资源",
  "pages.common.error.405": "请求方法未允许",
  "pages.common.error.408": "请求超时",
  "pages.common.error.500": "服务器端出错",
  "pages.common.error.501": "网络未实现",
  "pages.common.error.502": "网络错误",
  "pages.common.error.503": "服务不可用",
  "pages.common.error.504": "网络超时",
  "pages.common.error.505": "http版本不支持该请求",
  "pages.common.error.default": "请求异常，请重试",
  "pages.common.error.failed": "请求失败",
  "pages.common.error.response": "响应错误: {status}",

  // 组件 - Google 验证
  "component.google.title": "Google 验证",
  "component.google.prompt": "请输入 Google 验证码以进行后续操作",
  "component.google.placeholder": "请输入 Google 验证码",
  "component.google.required": "验证码不能为空",
  "component.google.formatError": "请输入6位验证码",
  "component.google.verifyFailed": "验证失败",
  "component.google.noTicket": "验证失败，未获取到票据",
  "component.google.tip": "为了您的账号安全，请进行 Google 二步验证",
  "component.google.cancel": "取消",
  "component.google.ok": "确定",
  "component.google.error": "验证失败",

  // 欢迎页
  "pages.welcome.title": "欢迎使用 Ant Design Pro",
  "pages.welcome.description":
    "Ant Design Pro 是一个整合了 umi，Ant Design 和 ProComponents 的脚手架方案。致力于在设计规范和基础组件的基础上，继续向上构建，提炼出典型模板/业务组件/配套设计资源，进一步提升企业级中后台产品设计研发过程中的『用户』和『设计者』的体验。",
  "pages.welcome.link.more": "了解更多",
  "pages.welcome.infoCard.umi.title": "了解 umi",
  "pages.welcome.infoCard.umi.desc":
    "umi 是一个可扩展的企业级前端应用框架,umi 以路由为基础的，同时支持配置式路由和约定式路由，保证路由的功能完备，并以此进行功能扩展。",
  "pages.welcome.infoCard.antd.title": "了解 ant design",
  "pages.welcome.infoCard.antd.desc":
    "antd 是基于 Ant Design 设计体系 of React UI 组件库，主要用于研发企业级中后台产品。",
  "pages.welcome.infoCard.pro.title": "了解 Pro Components",
  "pages.welcome.infoCard.pro.desc":
    "ProComponents 是一个基于 Ant Design 做了更高抽象的模板组件，以 一个组件就是一个页面为开发理念，为中后台开发带来更好的体验。",
  "pages.welcome.link": "欢迎",
  "pages.welcome.alertMessage": "更快更强的重型组件，已经发布。",

  // 其他
  "pages.404.subTitle": "抱歉，您访问的页面不存在。",
  "pages.404.buttonText": "返回首页",
  "pages.admin.subPage.title": " 这个页面只有管理员能看",
  "pages.admin.subPage.alertMessage":
    "umi ui 现在已发布，欢迎使用 npm run ui 启动体验。",

  // 数据分析
  "pages.statics.data.stat.title": "数据总览",
  "pages.statics.data.stat.description": "数据15mins刷新一次",

  "pages.statics.data.stat.tooltip.totalBetUserCount":
    "总下注人数：在当前筛选条件下，至少发生过一次下注行为的去重用户数。必须去重",
  "pages.statics.data.stat.tooltip.totalBetCount":
    "总下注次数：在当前筛选条件下，所有下注行为的总次数。无需去重",
  "pages.statics.data.stat.tooltip.totalBetAmount":
    "总下注金额：在当前筛选条件下，所有用户在所选时间范围内的累计下注金额",
  "pages.statics.data.stat.tooltip.avgUserBetAmount":
    "平均下注金额(用户)：总下注金额 / 总下注用户数",
  "pages.statics.data.stat.tooltip.avgCountBetAmount":
    "平均下注金额：在当前筛选条件下，每次的平均下注金额（总下注金额/总下注次数）",
  "pages.statics.data.stat.tooltip.totalScoreAmount":
    "总返奖金额：在当前筛选条件下，所有用户获得的返奖总金额（不含活动彩金）",
  "pages.statics.data.stat.tooltip.userWinAmount":
    "总盈亏（平台侧）：在当前筛选条件下，平台侧的累计盈亏金额。总盈亏=总下注金额-【总返奖金额+累计FreeSpin】",
  "pages.statics.data.stat.tooltip.rtp": "总RTP：总返奖金额 / 总下注金额",
  "pages.statics.data.stat.tooltip.newUserCount":
    "累计新增玩家：在当前筛选条件下，累积的注册用户",
  "pages.statics.data.stat.tooltip.totalPlatformFsAmount":
    "累计Freespin金额：在当前筛选条件下，游戏厂商侧提供Freespin，所有用户的累计Freespin金额",
  "pages.statics.data.stat.tooltip.totalMerchantFsAmount":
    "平台Freespin金额：在当前筛选条件下，商户平台侧提供Freespin，所有用户的累计Freespin金额",
  "pages.statics.data.table.title": "数据列表",
  "pages.statics.data.table.tooltip.rtpAmount": "RTP(金额)：返奖金额/下注金额",
  "pages.statics.data.table.tooltip.rtpCount":
    "RTP(次数)：默认每次投注金额为1美元，返奖金额/（下注次数*1美元）",
  "pages.statics.data.table.tooltip.baseGameRtp":
    "仅统计游戏基础模式的RTP，不包含其他活动产生的返奖金额",
  "pages.statics.data.table.tooltip.hundredAvgRtp":
    "百次以上平均RTP：Spin100次以上，平均的RTP。（RTP1+RTP2+...RTPn）/n",
  "pages.statics.data.table.tooltip.hundredMaxRtp":
    "百次以上最高RTP：Spin100次以上，最高的RTP",
  "pages.statics.data.table.tooltip.hundredMinRtp":
    "百次以上最低RTP：Spin100次以上，最低的RTP",
  "pages.statics.data.table.tooltip.quickSpinCount":
    "快速Spin触发次数：Spin过程中，点击加速按钮，就触发1次",
  "pages.statics.data.table.tooltip.superSpinCount":
    "超级加速spin次数：Spin过程中，点击超级加速按钮，就触发1次",
  "pages.statics.data.column.game": "游戏",
  "pages.statics.data.column.totalBetUserCount": "总下注人数",
  "pages.statics.data.column.totalBetCount": "总下注次数",
  "pages.statics.data.column.totalBetAmount": "总下注金额",
  "pages.statics.data.column.avgCountBetAmount": "平均下注金额",
  "pages.statics.data.column.totalScoreAmount": "总返奖金额",
  "pages.statics.data.column.totalScoreAmount.tooltip": "不包含彩金",
  "pages.statics.data.column.userWinAmount": "总盈亏（平台侧）",
  "pages.statics.data.column.rtp": "总RTP",
  "pages.statics.data.column.totalPlatformFsAmount": "平台Freespin金额",
  "pages.statics.data.column.totalMerchantFsAmount": "累计Freespin金额",
  "pages.statics.data.column.betUserCount": "下注人数",
  "pages.statics.data.column.betCount": "下注次数",
  "pages.statics.data.column.betAmount": "下注金额",
  "pages.statics.data.column.avgBetCount": "平均下注次数",
  "pages.statics.data.column.avgBetAmountByCount": "平均下注金额(次)",
  "pages.statics.data.column.avgBetAmountByUser": "平均下注金额(人)",
  "pages.statics.data.column.scoreAmount": "返奖金额",
  "pages.statics.data.column.totalWinAmount": "总盈亏（平台侧）",
  "pages.statics.data.column.totalWinAmount.tooltip":
    "总盈亏（平台侧）：在当前筛选条件下，平台侧的累计盈亏金额。总盈亏=总下注金额-【总返奖金额+累计FreeSpin】",
  "pages.statics.data.column.rtpBase": "RTP(基础)",
  "pages.statics.data.column.rtpAmount": "RTP(金额)",
  "pages.statics.data.column.rtpCount": "RTP(次数)",
  "pages.statics.data.column.baseGameRtp": "基础游戏RTP",
  "pages.statics.data.column.hundredAvgRtp": "百分次以上平均RTP",
  "pages.statics.data.column.hundredMaxRtp": "百分次以上最高RTP",
  "pages.statics.data.column.hundredMinRtp": "百分次以上最低RTP",
  "pages.statics.data.column.quickSpinCount": "快速Spin触发次数",
  "pages.statics.data.column.superSpinCount": "超级加速spin次数",
  "pages.statics.data.column.newUserCount": "新增玩家",
  "pages.statics.data.column.prizeMultiple": "大奖倍数",
  "pages.statics.data.column.newPlayerJackpot": "新手奖池",
  "pages.statics.data.column.newPlayerJackpot.tooltip":
    "当日消耗奖池金额/当日触发的奖池金额",
  // 游戏分析
  "pages.statics.games.segment.core": "核心数据",
  "pages.statics.games.segment.payment": "一、付费与收益",
  "pages.statics.games.segment.progress": "二、进度条分布",
  "pages.statics.games.segment.special": "三、特殊机制触发",
  "pages.statics.games.segment.maxwin": "四、Maxwin分析",
  "pages.statics.games.table.title": "游戏分析数据",
  "pages.statics.games.column.date": "日期",
  "pages.statics.games.column.operatorName": "商户名称",
  "pages.statics.games.column.operatorToken": "商户AppID",
  "pages.statics.games.column.operation": "操作",
  "pages.statics.games.action.viewDetail": "查看详情",
  "pages.statics.games.drawer.title": "{name} 游戏追踪详情",
  "pages.statics.games.pagination.total": "共 {total} 条",

  "pages.statics.data.column.merchantFreeSpinAmount": "累计Freespin",
  "pages.statics.data.column.platformFreeSpinAmount": "平台Freespin",

  // 数据分析活动标签
  "pages.statics.data.tag.sevenFreeSpin": "七日",
  "pages.statics.data.tag.freeSpin": "累计",
  "pages.statics.data.tag.activityId": "ID",
  "pages.statics.data.tag.activityName": "名称",
  "pages.statics.data.tag.activityTime": "时间",

  "pages.common.label.id": "ID",
  "pages.common.date.preset.previousCycle": "上一周期",
  "pages.common.ratio.wow": "环比",
  "pages.common.percentage": "占比",

  // 通用操作
  "pages.common.edit": "编辑",

  // 货币配置
  "pages.config.currency.code": "货币代码",
  "pages.config.currency.code.placeholder": "请输入货币代码",
  "pages.config.currency.name": "货币简称",
  "pages.config.currency.symbol": "货币符号",
  "pages.config.currency.currencyMult": "货币乘数",
  "pages.config.currency.currencyMult.required": "请输入货币乘数",
  "pages.config.currency.currencyMult.extra":
    "在汇率基础上对金额进行放大或缩小的系数，用于调节玩家收益或平台收益",
  "pages.config.currency.currencyMult.tooltip":
    "在汇率基础上对金额进行放大或缩小的系数，用于调节玩家收益或平台收益",
  "pages.config.currency.fixedExchangeRate": "固定汇率",
  "pages.config.currency.fixedExchangeRate.required": "请输入固定汇率",
  "pages.config.currency.fixedExchangeRate.extra":
    "平台设定的固定美元换算比例，不随市场变化，用于稳定结算",
  "pages.config.currency.fixedExchangeRate.tooltip":
    "平台设定的固定美元换算比例，不随市场变化，用于稳定结算",
  "pages.config.currency.realExchangeRate": "实时汇率",
  "pages.config.currency.realExchangeRate.tooltip":
    "按当前市场美元汇率自动换算的比例，会随市场波动变化",
  "pages.config.currency.status": "状态",
  "pages.config.currency.createdAt": "创建时间",
  "pages.config.currency.lastUpdatedAt": "实时汇率上次更新时间",
  "pages.config.currency.refresh.button": "刷新汇率",
  "pages.config.currency.refresh.tooltip": "点击可刷新实时汇率",
  "pages.config.currency.refresh.success": "汇率刷新成功",
  "pages.config.currency.refresh.failed": "汇率刷新失败",
  "pages.config.currency.edit.title": "编辑货币",
  "pages.config.currency.edit.message.success": "更新成功",
  "pages.config.currency.edit.message.failed": "更新失败",
  "pages.config.currency.edit.message.noId": "货币ID不存在",
  "pages.config.currency.status.success": "状态更新成功",
  "pages.config.currency.status.failed": "状态更新失败",
  "pages.config.currency.status.noId": "货币ID不存在",

  // RTP 配置
  "pages.config.rtp.filter.createdAt": "创建时间",
  "pages.config.rtp.filter.keywords": "ID/名称",
  "pages.config.rtp.filter.keywords.placeholder": "请输入ID/游戏名称/方案名称",
  "pages.config.rtp.filter.approvalStatus": "审核状态",
  "pages.config.rtp.approvalStatus.pendingPublish": "待发布",
  "pages.config.rtp.approvalStatus.underReview": "审核中",
  "pages.config.rtp.approvalStatus.published": "已发布",
  "pages.config.rtp.approvalStatus.rejected": "已拒绝",
  "pages.config.rtp.column.id": "ID",
  "pages.config.rtp.column.game": "应用游戏",
  "pages.config.rtp.column.name": "方案",
  "pages.config.rtp.column.configName": "当前yaml",
  "pages.config.rtp.column.rtp": "综合RTP",
  "pages.config.rtp.column.rtp.tooltip":
    "综合RTP来源为派单验证结果中的Total RTP",
  "pages.config.rtp.column.approvalStatus": "审核状态",
  "pages.config.rtp.column.status": "启用/停用",
  "pages.config.rtp.column.configVersion": "当前生效版本",
  "pages.config.rtp.column.remark": "备注",
  "pages.config.rtp.column.operator": "操作人",
  "pages.config.rtp.column.createdAt": "导入时间",
  "pages.config.rtp.column.updatedAt": "最后导入时间",
  "pages.config.rtp.column.action.placeholder": "预留",
  "pages.config.rtp.status.enabled": "启用",
  "pages.config.rtp.status.disabled": "停用",
  "pages.config.rtp.action.batchEnable": "批量启用",
  "pages.config.rtp.action.batchDisable": "批量停用",
  "pages.config.rtp.action.export": "导出配置",
  "pages.config.rtp.action.import": "导入配置",
  "pages.config.rtp.action.addVersion": "新增版本",
  "pages.config.rtp.action.versionManagement": "版本管理",
  "pages.config.rtp.versionHistory.title": "版本管理 - {configName} - {name}",
  "pages.config.rtp.versionHistory.empty": "暂无版本历史数据",
  "pages.config.rtp.versionHistory.column.configVersion": "版本号",
  "pages.config.rtp.versionHistory.column.fileName": "文件名",
  "pages.config.rtp.versionHistory.download": "下载",
  "pages.config.rtp.versionHistory.column.remark": "备注",
  "pages.config.rtp.versionHistory.column.rtp": "综合RTP",
  "pages.config.rtp.versionHistory.column.importTime": "导入时间",
  "pages.config.rtp.versionHistory.column.operator": "操作人",
  "pages.config.rtp.versionHistory.column.status": "状态",
  "pages.config.rtp.versionHistory.status.enabled": "已启用",
  "pages.config.rtp.versionHistory.status.pendingReview": "待审核",
  "pages.config.rtp.versionHistory.status.disabled": "未启用",
  "pages.config.rtp.versionHistory.enable.confirm.title": "确认启用版本",
  "pages.config.rtp.versionHistory.enable.confirm.content":
    "您即将生效方案版本 {configVersion}，发布后，当前方案线上正在运行的老版本将被自动停用并退回未发布状态。该操作将直接影响线上游戏配置，请确认是否继续执行？",
  "pages.config.rtp.versionHistory.revoke.confirm.title": "确认撤销",
  "pages.config.rtp.versionHistory.revoke.confirm.content":
    "撤销后，启用申请将在审核中心撤回。（审批人无法看到该条申请）",
  "pages.config.rtp.versionHistory.configContent.title": "配置内容",
  "pages.config.rtp.action.revoke": "撤销",
  "pages.config.rtp.action.edit": "编辑",
  "pages.config.rtp.action.enable": "启用",
  "pages.config.rtp.action.remark": "备注",
  "pages.config.rtp.action.review": "提交审核",
  "pages.config.rtp.action.runCheck": "跑单验证",
  "pages.config.rtp.action.runCheck.running": "正在进行跑单模拟",
  "pages.config.rtp.action.runCheck.error": "跑单验证失败",
  "pages.config.rtp.action.runCheck.completed": "跑单验证完成",
  "pages.config.rtp.action.pending": "功能待后续扩展",
  "pages.config.rtp.check.title": "RTP 检测 - {name}",
  "pages.config.rtp.export.filename": "RTP配置_",
  "pages.config.rtp.modal.title.create": "新增版本",
  "pages.config.rtp.modal.title.edit": "编辑 RTP 配置",
  "pages.config.rtp.modal.tip":
    "请上传准确的 YAML/JSON 配置文件，并确保跑单验证通过后再保存。",
  "pages.config.rtp.modal.section.upload": "上传模板",
  "pages.config.rtp.modal.section.runCheck": "跑单验证",
  "pages.config.rtp.modal.action.saveDraft": "保存",
  "pages.config.rtp.modal.action.saveAndPublish": "保存并启用",
  "pages.config.rtp.modal.form.game": "应用游戏",
  "pages.config.rtp.modal.form.game.placeholder": "请选择应用游戏",
  "pages.config.rtp.modal.form.game.required": "请选择应用游戏",
  "pages.config.rtp.modal.form.game.editLocked": "更新时不允许修改归属游戏",
  "pages.config.rtp.modal.form.name": "方案名称",
  "pages.config.rtp.modal.form.name.placeholder": "请输入方案名称",
  "pages.config.rtp.modal.form.name.required": "请输入方案名称",
  "pages.config.rtp.modal.form.config": "配置文件",
  "pages.config.rtp.modal.form.config.placeholder": "请选择配置文件",
  "pages.config.rtp.modal.form.config.required": "请上传配置文件",
  "pages.config.rtp.modal.form.config.current": "当前配置文件：{fileName}",
  "pages.config.rtp.modal.form.config.extra":
    "仅支持 .json、.yaml、.yml 格式文件",
  "pages.config.rtp.modal.form.configVersion": "版本号",
  "pages.config.rtp.modal.form.configVersion.placeholder": "请输入版本号",
  "pages.config.rtp.modal.form.configVersion.required": "请输入版本号",
  "pages.config.rtp.modal.form.configVersion.existing": "已有版本: {versions}",
  "pages.config.rtp.modal.form.configVersion.duplicate":
    "版本号与已有版本重复，请重新输入",
  "pages.config.rtp.modal.form.remark": "备注",
  "pages.config.rtp.modal.form.remark.placeholder": "请输入备注",
  "pages.config.rtp.modal.form.rtp": "综合RTP",
  "pages.config.rtp.modal.form.rtp.required": "请先完成跑单验证或填写综合RTP",
  "pages.config.rtp.modal.form.otherParams": "附加参数",
  "pages.config.rtp.modal.form.otherParams.placeholder": "请输入附加参数",
  "pages.config.rtp.modal.form.runResult": "跑单结果",
  "pages.config.rtp.modal.form.runResult.placeholder":
    "跑单输出将自动回填到这里，也可手动补充说明",
  "pages.config.rtp.modal.runCheck.title": "跑单验证终端",
  "pages.config.rtp.modal.runCheck.gameBin.label": "当前执行跑单程序：",
  "pages.config.rtp.modal.runCheck.gameBin.loading": "正在加载跑单程序...",
  "pages.config.rtp.modal.runCheck.gameBin.empty": "当前未识别到有效的跑单程序",
  "pages.config.rtp.modal.runCheck.gameBin.required":
    "当前未识别到有效的跑单程序",
  "pages.config.rtp.modal.runCheck.tab.base": "基础模式",
  "pages.config.rtp.modal.runCheck.result.required":
    "请先完成跑单验证并生成跑单结果",
  "pages.config.rtp.modal.runCheck.metrics.missing":
    "基础模式跑单结果缺少必要指标：{fields}",
  "pages.config.rtp.action.runResult": "跑单验证",
  "pages.config.rtp.preview.title": "验证结果快照预览",
  "pages.config.rtp.preview.snapshot.label": "提交审批时的跑单核心数据指标：",
  "pages.config.rtp.preview.snapshot.title": "历史跑单快照",
  "pages.config.rtp.preview.snapshot.empty": "当前暂无历史跑单结果快照",
  "pages.config.rtp.preview.snapshot.tip":
    "注：上方结果为提交审批时的跑单快照，仅用于回看历史结果，不代表当前配置文件的实时验证结果。",
  "pages.config.rtp.preview.rerun.section": "配置复测（重新跑单）",
  "pages.config.rtp.preview.rerun.title": "重新跑单结果",
  "pages.config.rtp.preview.rerun.tip":
    "注意：以下为当前配置重新发起的最新跑单结果，若配置或程序已调整，结果可能与历史快照存在差异。",
  "pages.config.rtp.preview.rerun.disabled":
    "当前记录缺少有效的配置文件路径或跑单程序路径，暂时无法重新跑单。",
  "pages.config.rtp.preview.action.rerun": "重新执行跑单",
  "pages.config.rtp.preview.action.rerun.completed": "重新跑单完成，可再次执行",
  "pages.config.rtp.preview.action.close": "关闭",
  "pages.config.rtp.preview.gameBin.label": "当前执行跑单程序：",
  "pages.config.rtp.preview.gameBin.empty": "当前未识别到有效的跑单程序",
  "pages.config.rtp.remark.title": "RTP配置-备注",
  "pages.config.rtp.remark.form.placeholder": "请填写备注，选填",
  "pages.config.rtp.remark.form.max": "备注最多输入 500 个字符",
  "pages.config.rtp.remark.message.success": "备注保存成功",
  "pages.config.rtp.remark.message.failed": "备注保存失败",
  "pages.config.rtp.remark.message.idMissing": "RTP 配置 ID 不存在",
  "pages.config.rtp.modal.upload.message.success": "配置文件上传成功",
  "pages.config.rtp.modal.upload.message.failed": "配置文件上传失败",
  "pages.config.rtp.modal.upload.message.fileNameMismatch":
    "文件名必须为 {expected}，当前文件为 {actual}",
  "pages.config.rtp.modal.upload.message.invalidResponse":
    "上传结果缺少文件地址，请稍后重试",
  "pages.config.rtp.message.listFailed": "获取 RTP 配置列表失败",
  "pages.config.rtp.message.createSuccess": "RTP 配置导入成功",
  "pages.config.rtp.message.createFailed": "RTP 配置导入失败",
  "pages.config.rtp.message.nameUpdateSuccess": "方案名称修改成功",
  "pages.config.rtp.message.nameUpdateFailed": "方案名称修改失败",
  "pages.config.rtp.message.saveDraftSuccess": "保存成功",
  "pages.config.rtp.message.saveAndPublishSuccess": "保存并启用成功",
  "pages.config.rtp.message.saveAndEnableSuccess": "已提交启用申请",
  "pages.config.rtp.message.updateSuccess": "RTP 配置更新成功",
  "pages.config.rtp.message.updateFailed": "RTP 配置更新失败",
  "pages.config.rtp.message.reviewSuccess": "提交审核成功",
  "pages.config.rtp.message.reviewFailed": "提交审核失败",
  "pages.config.rtp.message.enableSuccess": "启用成功",
  "pages.config.rtp.message.enableFailed": "启用失败",
  "pages.config.rtp.message.revokeSuccess": "撤销成功",
  "pages.config.rtp.message.revokeFailed": "撤销失败",
  "pages.config.rtp.message.disableSuccess": "配置已停用",
  "pages.config.rtp.message.selectAtLeastOne": "请至少选择一条 RTP 配置",
  "pages.config.rtp.message.statusUpdateSuccess": "{status}成功",
  "pages.config.rtp.message.statusUpdateFailed": "{status}失败",
  "pages.config.rtp.message.statusIdMissing": "RTP 配置 ID 不存在",
  "pages.config.rtp.confirm.enable.title": "确认启用此配置？",
  "pages.config.rtp.confirm.enable.content":
    "启用后，该RTP档位将立刻投入线上运行，直接影响实际玩家策略。请确认当前时间点符合运营预期。",
  "pages.config.rtp.confirm.review.title": "确认提交发布审核？",
  "pages.config.rtp.confirm.review.content":
    "提交审核后，该配置将进入“审核中”状态，在此期间您将无法再次修改此配置。",
  "pages.config.rtp.selection.selected": "已选 {count} 项",
  "pages.config.rtp.selection.clear": "取消选择",
  "pages.config.rtp.card.count": "{count} 个配置",
  "pages.config.rtp.card.unknownGame": "未命名游戏",
  "pages.config.rtp.card.reviewedCount": "共 {count} 个已审核配置",
  "pages.config.rtp.card.currentOnline": "当前线上使用:",
  "pages.config.rtp.card.importGame": "导入此游戏配置",
  "pages.config.rtp.empty": "暂无 RTP 配置数据",

  "pages.config.bet.filter.createdAt": "创建时间",
  "pages.config.bet.filter.keywords": "ID/名称",
  "pages.config.bet.filter.keywords.placeholder": "请输入 ID 或档位策略名称",
  "pages.config.bet.filter.reviewStatus": "审核状态",
  "pages.config.bet.column.name": "档位策略名称",
  "pages.config.bet.column.currencys": "已配币种",
  "pages.config.bet.column.sort": "档位排序",
  "pages.config.bet.column.createdAt": "创建时间",
  "pages.config.bet.column.levelCount": "档位值数量",
  "pages.config.bet.column.minLevel": "最低档位值",
  "pages.config.bet.column.maxLevel": "最高档位值",
  "pages.config.bet.column.usedMerchantCount": "使用商户数",
  "pages.config.bet.column.usedGameCount": "使用游戏数",
  "pages.config.bet.column.reviewStatus": "审核状态",
  "pages.config.bet.column.status": "启用/停用",
  "pages.config.bet.reviewStatus.pendingRelease": "待发布",
  "pages.config.bet.reviewStatus.underReview": "审核中",
  "pages.config.bet.reviewStatus.published": "已发布",
  "pages.config.bet.reviewStatus.rejected": "已拒绝",
  "pages.config.bet.status.enabled": "启用",
  "pages.config.bet.status.disabled": "停用",
  "pages.config.bet.action.batchEnable": "批量启用",
  "pages.config.bet.action.batchDisable": "批量停用",
  "pages.config.bet.action.add": "添加档位",
  "pages.config.bet.action.detail": "详情",
  "pages.config.bet.action.edit": "编辑",
  "pages.config.bet.action.copy": "复制",
  "pages.config.bet.action.delete": "删除",
  "pages.config.bet.action.publish": "发布",
  "pages.config.bet.drawer.title.create": "添加档位",
  "pages.config.bet.drawer.title.detail": "档位详情",
  "pages.config.bet.drawer.title.edit": "编辑档位",
  "pages.config.bet.drawer.action.saveDraft": "保存草稿",
  "pages.config.bet.drawer.action.saveAndPublish": "保存并发布",
  "pages.config.bet.drawer.section.currency": "已配置币种",
  "pages.config.bet.drawer.section.level": "档位值明细配置",
  "pages.config.bet.drawer.form.name": "档位名称",
  "pages.config.bet.drawer.form.name.placeholder": "请输入档位名称",
  "pages.config.bet.drawer.form.name.required": "请输入档位名称",
  "pages.config.bet.drawer.form.sort": "档位排序",
  "pages.config.bet.drawer.form.sort.placeholder": "请输入档位排序",
  "pages.config.bet.drawer.form.sort.required": "请输入档位排序",
  "pages.config.bet.drawer.form.status": "是否启用",
  "pages.config.bet.drawer.currency.add": "添加新币种",
  "pages.config.bet.drawer.currency.empty": "请先添加币种",
  "pages.config.bet.drawer.currency.search": "搜索币种",
  "pages.config.bet.drawer.currency.usdRequired": "USD 币种为必配项，不能删除",
  "pages.config.bet.drawer.table.currency": "币种",
  "pages.config.bet.drawer.table.levelColumn": "档位{index}",
  "pages.config.bet.drawer.level.add": "添加档位项",
  "pages.config.bet.drawer.level.column.level": "档位值",
  "pages.config.bet.drawer.level.column.sort": "档位排序",
  "pages.config.bet.drawer.level.column.default": "默认档位",
  "pages.config.bet.drawer.level.input.level": "输入金额",
  "pages.config.bet.drawer.level.input.sort": "排序",
  "pages.config.bet.drawer.level.required":
    "{currency} 币种下请完整填写档位值和排序",
  "pages.config.bet.drawer.level.greaterThanZero": "档位值必须大于0",
  "pages.config.bet.drawer.level.atLeastOne":
    "至少需要填写一个币种下的一个档位值",
  "pages.config.bet.drawer.message.saveDraftSuccess": "档位草稿保存成功",
  "pages.config.bet.drawer.message.createSuccess": "档位创建成功",
  "pages.config.bet.drawer.message.updateSuccess": "档位更新成功",
  "pages.config.bet.drawer.message.createFailed": "档位创建失败",
  "pages.config.bet.drawer.message.updateFailed": "档位更新失败",
  "pages.config.bet.message.listFailed": "获取 Bet 档位配置列表失败",
  "pages.config.bet.message.selectAtLeastOne":
    "请至少选择一条已发布的 Bet 档位配置",
  "pages.config.bet.message.statusUpdateSuccess": "{status}成功",
  "pages.config.bet.message.statusUpdateFailed": "{status}失败",
  "pages.config.bet.message.statusIdMissing": "Bet 档位配置 ID 不存在",
  "pages.config.bet.message.publishSuccess": "配置已提交审核",
  "pages.config.bet.message.publishFailed": "提交审核失败",
  "pages.config.bet.confirm.publish.title": "确认提交发布审核？",
  "pages.config.bet.confirm.publish.content":
    "提交审核后，该配置将进入“审核中”状态，在此期间您将无法再次修改/更新此配置。",
  "pages.config.bet.detail.empty": "暂无当前生效档位明细",
  "pages.config.bet.selection.selected": "已选 {count} 项",
  "pages.config.bet.selection.clear": "取消选择",
  "pages.config.bet.empty": "暂无 Bet 档位配置数据",

  "pages.safe.warn.filter.createdAt": "创建时间",
  "pages.safe.warn.filter.riskType": "监控模型",
  "pages.safe.warn.filter.riskType.placeholder": "请选择监控模型",
  "pages.safe.warn.column.createdAt": "创建时间",
  "pages.safe.warn.column.monitorName": "监控名称",
  "pages.safe.warn.column.riskType": "监控模型",
  "pages.safe.warn.column.monitorRange": "监控范围",
  "pages.safe.warn.column.conditionThreshold": "触发条件&阈值",
  "pages.safe.warn.column.severity": "预警程度",
  "pages.safe.warn.column.status": "状态",
  "pages.safe.warn.riskType.rtpReport": "RTP报表监控模型",
  "pages.safe.warn.riskType.singleAmount": "单笔金额监控模型",
  "pages.safe.warn.riskType.behaviorFrequency": "行为频率监控模型",
  "pages.safe.warn.riskType.singleGameLoss": "单游戏亏损监控模型",
  "pages.safe.warn.riskType.singleUserAmount": "单用户金额监控模型",
  "pages.safe.warn.condition.yellow": "黄色预警：{value}",
  "pages.safe.warn.condition.red": "红色预警：{value}",
  "pages.safe.warn.condition.layer": "第 {index} 层：{value}",
  "pages.safe.warn.condition.frequency.seconds": "{count} 秒",
  "pages.safe.warn.condition.frequency.betCount": "{count} 笔",
  "pages.safe.warn.severity.yellow": "黄色预警",
  "pages.safe.warn.severity.red": "红色预警",
  "pages.safe.warn.severity.blueLayer": "蓝色风险分层 {index}",
  "pages.safe.warn.status.enabled": "启用",
  "pages.safe.warn.status.disabled": "停用",
  "pages.safe.warn.action.add": "添加风控",
  "pages.safe.warn.action.batchEnable": "批量启用",
  "pages.safe.warn.action.batchDisable": "批量停用",
  "pages.safe.warn.action.edit": "编辑",
  "pages.safe.warn.action.copy": "复制",
  "pages.safe.warn.action.detail": "详情",
  "pages.safe.warn.action.status": "状态切换",
  "pages.safe.warn.drawer.title.create": "添加风控",
  "pages.safe.warn.drawer.title.edit": "编辑风控",
  "pages.safe.warn.drawer.form.name": "监控名称",
  "pages.safe.warn.drawer.form.name.placeholder": "请输入监控名称",
  "pages.safe.warn.drawer.form.riskType": "监控模型",
  "pages.safe.warn.drawer.form.riskType.placeholder": "请选择监控模型",
  "pages.safe.warn.drawer.form.thresholdYellow": "黄色预警阈值",
  "pages.safe.warn.drawer.form.thresholdYellow.placeholder":
    "请输入黄色预警阈值",
  "pages.safe.warn.drawer.form.thresholdRed": "红色预警阈值",
  "pages.safe.warn.drawer.form.thresholdRed.placeholder": "请输入红色预警阈值",
  "pages.safe.warn.drawer.form.frequencySeconds": "多少秒内",
  "pages.safe.warn.drawer.form.frequencySeconds.placeholder": "请输入秒数",
  "pages.safe.warn.drawer.form.frequencyBetCount": "下注次数大于等于",
  "pages.safe.warn.drawer.form.frequencyBetCount.placeholder": "请输入下注次数",
  "pages.safe.warn.drawer.form.layeredThreshold": "第 {index} 层阈值",
  "pages.safe.warn.drawer.form.layeredThreshold.placeholder": "请输入阈值",
  "pages.safe.warn.drawer.form.amountRulePrefix": "大于等于",
  "pages.safe.warn.drawer.form.frequencyConnector": "秒内，下注次数大于等于",
  "pages.safe.warn.drawer.form.layeredThresholdText": "阶梯阈值",
  "pages.safe.warn.drawer.form.layeredThresholdText.placeholder":
    "请输入阶梯阈值，支持一行一个阈值或使用英文逗号分隔",
  "pages.safe.warn.drawer.form.layeredThresholdText.extra":
    "提交时会自动序列化为英文逗号分隔字符串，例如：1000,2000,3000",
  "pages.safe.warn.drawer.section.threshold": "阈值配置",
  "pages.safe.warn.drawer.section.rtpThreshold": "RTP 阈值配置",
  "pages.safe.warn.drawer.section.amountThreshold": "金额阈值配置",
  "pages.safe.warn.drawer.section.frequencyRule": "行为频率规则",
  "pages.safe.warn.drawer.section.yellow": "黄色预警规则",
  "pages.safe.warn.drawer.section.red": "红色预警规则",
  "pages.safe.warn.drawer.section.layeredThreshold": "分层阈值配置",
  "pages.safe.warn.unit.percent": "%",
  "pages.safe.warn.unit.dollar": "$",
  "pages.safe.warn.unit.times": "次",
  "pages.safe.warn.drawer.action.addLayer": "新增一层阈值",
  "pages.safe.warn.drawer.action.removeLayer": "删除当前层",
  "pages.safe.warn.drawer.validation.nameRequired": "请输入监控名称",
  "pages.safe.warn.drawer.validation.riskTypeRequired": "请选择监控模型",
  "pages.safe.warn.drawer.validation.thresholdYellowRequired":
    "请输入黄色预警阈值",
  "pages.safe.warn.drawer.validation.thresholdRedRequired":
    "请输入红色预警阈值",
  "pages.safe.warn.drawer.validation.frequencyYellowSecondsRequired":
    "请输入黄色预警的秒数",
  "pages.safe.warn.drawer.validation.frequencyYellowBetCountRequired":
    "请输入黄色预警的下注次数",
  "pages.safe.warn.drawer.validation.frequencyRedSecondsRequired":
    "请输入红色预警的秒数",
  "pages.safe.warn.drawer.validation.frequencyRedBetCountRequired":
    "请输入红色预警的下注次数",
  "pages.safe.warn.drawer.validation.layeredThresholdsRequired":
    "请输入至少一个阶梯阈值",
  "pages.safe.warn.drawer.validation.layeredThresholdRequired":
    "请完整填写阈值",
  "pages.safe.warn.drawer.validation.layeredThresholdFormatInvalid":
    "阶梯阈值仅支持正整数，多个值请使用换行或英文逗号分隔",
  "pages.safe.warn.message.listFailed": "获取风控预警列表失败",
  "pages.safe.warn.message.selectAtLeastOne": "请至少选择一条风控配置",
  "pages.safe.warn.message.statusIdMissing": "风控配置 ID 不存在",
  "pages.safe.warn.message.statusUpdateSuccess": "{status}成功",
  "pages.safe.warn.message.statusUpdateFailed": "{status}失败",
  "pages.safe.warn.message.saveIdMissing": "风控配置 ID 不存在，无法保存编辑",
  "pages.safe.warn.message.createSuccess": "风控配置新增成功",
  "pages.safe.warn.message.createFailed": "风控配置新增失败",
  "pages.safe.warn.message.updateSuccess": "风控配置更新成功",
  "pages.safe.warn.message.updateFailed": "风控配置更新失败",
  "pages.safe.warn.message.placeholder":
    "{action}功能暂未开放，本次仅保留占位展示",
  "pages.safe.warn.selection.selected": "已选 {count} 项",
  "pages.safe.warn.selection.clear": "取消选择",
  "pages.safe.warn.empty": "暂无风控预警配置数据",

  "pages.safe.logs.list.title": "预警日志",
  "pages.safe.logs.filter.createdAt": "触发时间",
  "pages.safe.logs.filter.riskType": "告警类型",
  "pages.safe.logs.filter.riskType.placeholder": "请选择告警类型",
  "pages.safe.logs.column.alertName": "告警类型",
  "pages.safe.logs.column.merchantName": "商户",
  "pages.safe.logs.column.gameName": "游戏",
  "pages.safe.logs.column.roleId": "用户ID",
  "pages.safe.logs.column.ip": "用户IP",
  "pages.safe.logs.column.content": "异常数据",
  "pages.safe.logs.column.alertLevel": "预警程度",
  "pages.safe.logs.column.createdAt": "触发时间",
  "pages.safe.logs.alertLevel.yellow": "黄色预警",
  "pages.safe.logs.alertLevel.red": "红色预警",
  "pages.safe.logs.action.detail": "详情",
  "pages.safe.logs.action.remark": "备注",
  "pages.safe.logs.remark.title": "预警日志-备注",
  "pages.safe.logs.remark.form.placeholder": "请填写备注，选填",
  "pages.safe.logs.remark.form.max": "备注最多输入 500 个字符",
  "pages.safe.logs.remark.message.idMissing": "预警日志 ID 不存在",
  "pages.safe.logs.remark.message.versionMissing": "预警日志版本号不存在",
  "pages.safe.logs.remark.message.success": "备注保存成功",
  "pages.safe.logs.remark.message.failed": "备注保存失败",
  "pages.safe.logs.message.listFailed": "获取预警日志列表失败",
  "pages.safe.logs.message.detailPlaceholder":
    "详情功能暂未开放，本次仅保留占位入口",
  "pages.safe.logs.empty": "暂无预警日志数据",

  "pages.safe.lossAnalysis.filter.merchant": "商户",
  "pages.safe.lossAnalysis.filter.game": "游戏",
  "pages.safe.lossAnalysis.overview.amountNote":
    "列表中展示的金额，均已换算成美元",
  "pages.safe.lossAnalysis.overview.totalLossAmount": "总亏损",
  "pages.safe.lossAnalysis.overview.totalLossAmount.tooltip":
    "总亏损 = 总返奖金额 - 总下注金额",
  "pages.safe.lossAnalysis.overview.totalLossRate": "整体亏损率",
  "pages.safe.lossAnalysis.overview.totalLossRate.tooltip":
    "整体亏损率 = (总返奖金额 - 总下注金额) / 总下注",
  "pages.safe.lossAnalysis.overview.lossOrderCount": "亏损订单数",
  "pages.safe.lossAnalysis.overview.compare": "环比 {label}",
  "pages.safe.lossAnalysis.overview.today": "今日",
  "pages.safe.lossAnalysis.overview.previousCycle": "上一周期",
  "pages.safe.lossAnalysis.tab.game": "游戏亏损排行",
  "pages.safe.lossAnalysis.tab.merchant": "商户亏损排行",
  "pages.safe.lossAnalysis.tab.player": "高风险玩家排行",
  "pages.safe.lossAnalysis.table.title": "亏损排行",
  "pages.safe.lossAnalysis.table.column.gameId": "游戏ID",
  "pages.safe.lossAnalysis.table.column.gameName": "游戏名称",
  "pages.safe.lossAnalysis.table.column.merchantId": "商户ID",
  "pages.safe.lossAnalysis.table.column.merchantName": "商户名称",
  "pages.safe.lossAnalysis.table.column.playerId": "玩家ID",
  "pages.safe.lossAnalysis.table.column.netLossAmount": "净亏损",
  "pages.safe.lossAnalysis.table.column.lossRate": "亏损率",
  "pages.safe.lossAnalysis.table.column.lossOrderCount": "亏损订单数",
  "pages.safe.lossAnalysis.table.column.userCount": "用户数",
  "pages.safe.lossAnalysis.table.column.maxSingleLossAmount":
    "单笔最大亏损金额",
  "pages.safe.lossAnalysis.table.column.maxSingleLossAmount.tooltip":
    "在当前筛选条件下，平台亏损金额最大的一笔订单",
  "pages.safe.lossAnalysis.table.column.betAmount": "投注总额",
  "pages.safe.lossAnalysis.table.column.scoreAmount": "返奖总额",
  "pages.safe.lossAnalysis.table.column.action": "操作",
  "pages.safe.lossAnalysis.action.detail": "查看明细",
  "pages.safe.lossAnalysis.action.export": "导出",
  "pages.safe.lossAnalysis.export.filename.game": "游戏亏损排行_",
  "pages.safe.lossAnalysis.export.filename.merchant": "商户亏损排行_",
  "pages.safe.lossAnalysis.export.filename.player": "高风险玩家排行_",
  "pages.safe.lossAnalysis.message.overviewFailed": "获取亏损分析总览失败",
  "pages.safe.lossAnalysis.message.gameRankFailed": "获取游戏亏损排行失败",
  "pages.safe.lossAnalysis.message.merchantRankFailed": "获取商户亏损排行失败",
  "pages.safe.lossAnalysis.message.playerRankFailed": "获取高风险玩家排行失败",
  "pages.safe.lossAnalysis.message.exportFailed": "导出失败",
  "pages.safe.lossAnalysis.message.placeholder":
    "{action}功能暂未开放，本次仅保留占位入口",
  "pages.safe.lossAnalysis.empty": "暂无亏损排行数据",
  "pages.safe.lossAnalysis.detail.title.description":
    "每一笔亏损的下注记录均记录在内，保留了原币种",
  "pages.safe.lossAnalysis.detail.title.game":
    "游戏 {gameName}（ID: {gameId}）",
  "pages.safe.lossAnalysis.detail.title.merchant":
    "商户 {operatorName}（ID: {operatorId}）",
  "pages.safe.lossAnalysis.detail.title.player": "玩家 {roleId}",
  "pages.safe.lossAnalysis.detail.summary.totalBetAmount": "投注总额",
  "pages.safe.lossAnalysis.detail.summary.totalScoreAmount": "返奖金额",
  "pages.safe.lossAnalysis.detail.summary.totalLossAmount": "总亏损",
  "pages.safe.lossAnalysis.detail.summary.totalLossAmountDescription":
    "所有亏损金额的总和",
  "pages.safe.lossAnalysis.detail.column.lossAmount": "亏损金额",
  "pages.safe.lossAnalysis.detail.message.listFailed": "获取亏损明细失败",
  "pages.safe.lossAnalysis.detail.empty": "暂无亏损明细数据",

  // 审核中心 - 我发起的
  "pages.reviewCenter.my.list.title": "我发起的",
  "pages.reviewCenter.my.filter.createdAt": "提交时间",
  "pages.reviewCenter.my.filter.status": "审核状态",
  "pages.reviewCenter.my.filter.status.placeholder": "请选择审核状态",
  "pages.reviewCenter.my.column.id": "工单",
  "pages.reviewCenter.my.column.applyType": "操作类型",
  "pages.reviewCenter.my.column.applicant": "申请人",
  "pages.reviewCenter.my.column.associatedObject": "关联对象",
  "pages.reviewCenter.my.column.status": "状态",
  "pages.reviewCenter.my.column.handlerName": "处理人",
  "pages.reviewCenter.my.column.createdAt": "提交时间",
  "pages.reviewCenter.my.status.pending": "待审核",
  "pages.reviewCenter.my.status.approved": "已通过",
  "pages.reviewCenter.my.status.rejected": "已拒绝",
  "pages.reviewCenter.my.action.detail": "详情",
  "pages.reviewCenter.my.action.detail.placeholder":
    "详情功能暂未开放，本次仅保留占位入口",
  "pages.reviewCenter.my.message.listFailed": "获取审核列表失败",
  "pages.reviewCenter.my.value.unknownApplyType": "未知审核类型",
  "pages.reviewCenter.my.empty": "暂无审核数据",

  // 审核中心 - 待我审批
  "pages.reviewCenter.pending.list.title": "待我审批",
  "pages.reviewCenter.pending.filter.all": "全部",
  "pages.reviewCenter.pending.filter.createdAt": "提交时间",
  "pages.reviewCenter.pending.filter.applicant": "申请人",
  "pages.reviewCenter.pending.filter.applicant.placeholder": "请选择申请人",
  "pages.reviewCenter.pending.filter.applyType": "申请类型",
  "pages.reviewCenter.pending.filter.applyType.placeholder": "请选择申请类型",
  "pages.reviewCenter.pending.filter.status": "审核状态",
  "pages.reviewCenter.pending.filter.status.placeholder": "请选择审核状态",
  "pages.reviewCenter.pending.column.id": "工单",
  "pages.reviewCenter.pending.column.applicant": "申请人",
  "pages.reviewCenter.pending.column.adminId": "申请人",
  "pages.reviewCenter.pending.column.adminName": "申请人姓名",
  "pages.reviewCenter.pending.column.applyType": "申请类型",
  "pages.reviewCenter.pending.column.associatedObject": "关联对象",
  "pages.reviewCenter.pending.column.status": "状态",
  "pages.reviewCenter.pending.column.handlerName": "处理人",
  "pages.reviewCenter.pending.column.createdAt": "提交时间",
  "pages.reviewCenter.pending.message.listFailed": "获取待审批列表失败",
  "pages.reviewCenter.pending.message.reviewActionPlaceholder":
    "当前版本暂未接入审核通过/拒绝接口",
  "pages.reviewCenter.pending.message.approveMissingId":
    "缺少工单ID，无法提交审核",
  "pages.reviewCenter.pending.message.approveSuccess": "审核通过成功",
  "pages.reviewCenter.pending.message.approveFailed": "审核通过失败",
  "pages.reviewCenter.pending.message.rejectMissingId":
    "缺少工单ID，无法提交拒绝",
  "pages.reviewCenter.pending.message.rejectSuccess": "拒绝成功",
  "pages.reviewCenter.pending.message.rejectFailed": "拒绝失败",
  "pages.reviewCenter.pending.message.reviewCommentsRequired": "请填写审核意见",
  "pages.reviewCenter.pending.value.unknownApplicant": "未知申请人",
  "pages.reviewCenter.pending.value.unknownApplyType": "未知申请类型",
  "pages.reviewCenter.pending.empty": "暂无待审批数据",
  "pages.reviewCenter.pending.approve.title": "通过申请",
  "pages.reviewCenter.pending.approve.alert.title": "确认通过申请",
  "pages.reviewCenter.pending.approve.alert.description":
    "您正在处理单号 {id} 的 {applyType} 请求。",
  "pages.reviewCenter.pending.reject.alert.description":
    "您正在处理单号 {id} 的 {applyType} 请求。",
  "pages.reviewCenter.pending.approve.form.reviewComments": "审核意见",
  "pages.reviewCenter.pending.approve.form.reviewComments.placeholder":
    "请填写通过原因，选填",
  "pages.reviewCenter.pending.approve.form.reviewComments.help":
    "审核意见为选填，提交时将透传 reviewComments。",
  "pages.reviewCenter.modal.title.detail": "审核详情",
  "pages.reviewCenter.modal.action.close": "关闭",
  "pages.reviewCenter.modal.action.cancel": "取消",
  "pages.reviewCenter.modal.action.reject": "拒绝",
  "pages.reviewCenter.modal.action.approve": "通过",
  "pages.reviewCenter.modal.reviewComments": "审核意见",
  "pages.reviewCenter.modal.reviewComments.placeholder": "请填写审核意见，必填",
  "pages.reviewCenter.modal.feedback.title": "审核反馈",
  "pages.reviewCenter.modal.feedback.operator": "处理人：",
  "pages.reviewCenter.modal.feedback.operatedAt": "处理时间：",
  "pages.reviewCenter.rtp.meta.id": "工单",
  "pages.reviewCenter.rtp.meta.applyType": "操作类型",
  "pages.reviewCenter.rtp.meta.applicant": "申请人",
  "pages.reviewCenter.rtp.meta.applicantName": "申请人姓名",
  "pages.reviewCenter.rtp.meta.associatedObject": "关联对象",
  "pages.reviewCenter.rtp.meta.createdAt": "提交时间",
  "pages.reviewCenter.rtp.meta.status": "状态",
  "pages.reviewCenter.whitelist.name": "用户白名单",
  "pages.reviewCenter.whitelist.operation.enable": "启用白名单",
  "pages.reviewCenter.whitelist.operation.disable": "停用白名单",
  "pages.reviewCenter.whitelist.operation.create": "创建白名单",
  "pages.reviewCenter.whitelist.listOperation.enable": "启用白名单",
  "pages.reviewCenter.whitelist.listOperation.disable": "停用白名单",
  "pages.reviewCenter.whitelist.listOperation.create": "创建白名单",
  "pages.reviewCenter.whitelist.field.operation": "操作",
  "pages.reviewCenter.whitelist.field.ids": "白名单记录ID",
  "pages.reviewCenter.whitelist.field.roleIds": "用户ID",
  "pages.reviewCenter.whitelist.field.appid": "应用商户",
  "pages.reviewCenter.whitelist.field.useScene": "应用场景",
  "pages.reviewCenter.whitelist.field.remark": "备注",
  "pages.reviewCenter.rtp.compare.title": "配置对比",
  "pages.reviewCenter.rtp.compare.before": "变更前",
  "pages.reviewCenter.rtp.compare.after": "变更后",
  "pages.reviewCenter.rtp.compare.empty": "暂无对比数据",
  "pages.reviewCenter.activity.field.activityType": "活动类型",
  "pages.reviewCenter.activity.field.submitConfig": "提交配置",
  "pages.reviewCenter.activity.field.plannedEndTime": "原定结束时间",
  "pages.reviewCenter.activity.offShelf.sectionTitle": "变更内容及数据",
  "pages.reviewCenter.activity.offShelf.sectionDesc":
    "因活动策略调整，申请提前下架该运营活动。",
  "pages.reviewCenter.activity.offShelf.compareTitle":
    "下架运营活动 - 变更前后对比",
  "pages.reviewCenter.activity.offShelf.status.onShelfRunning":
    "运行中（已上架）",
  "pages.reviewCenter.activity.offShelf.status.forceOffShelf":
    "强制结束（下架）",
  "pages.reviewCenter.activity.offShelf.status.offShelfDone": "已下架",
  "pages.reviewCenter.rtp.field.name": "名称",
  "pages.reviewCenter.rtp.field.gameId": "游戏ID",
  "pages.reviewCenter.rtp.field.configName": "配置文件",
  "pages.reviewCenter.rtp.field.configVersion": "配置版本",
  "pages.reviewCenter.rtp.field.configPath": "配置地址",
  "pages.reviewCenter.rtp.field.gameBinPath": "跑单程序",
  "pages.reviewCenter.rtp.field.gameDependencyZipPath": "依赖包地址",
  "pages.reviewCenter.rtp.field.otherParams": "附加参数",
  "pages.reviewCenter.rtp.field.rtp": "RTP",
  "pages.reviewCenter.rtp.field.runResult": "跑单结果",
  "pages.reviewCenter.rtp.runResult.snapshot": "历史结果",
  "pages.reviewCenter.rtp.runResult.snapshotEmpty": "暂无历史跑单结果",
  "pages.reviewCenter.rtp.runResult.current": "当前跑单结果",
  "pages.reviewCenter.rtp.runResult.currentEmpty":
    "点击上方跑单验证后，在此展示当前跑单结果",
  "pages.reviewCenter.rtp.runCheck.disabled":
    "当前缺少配置地址或跑单程序，无法进行跑单验证",
  "pages.reviewCenter.bet.level.default": "默认",
  "pages.reviewCenter.bet.compare.emptyCurrencyLevels": "暂无币种档位配置",
  "pages.reviewCenter.gameBet.meta.operatorName": "应用商户",
  "pages.reviewCenter.gameBet.meta.appid": "AppID",
  "pages.reviewCenter.gameBet.meta.gameName": "游戏名称",
  "pages.reviewCenter.gameBet.compare.title": "变更内容及数据",
  "pages.reviewCenter.gameBet.compare.summaryLabel": "变更说明",
  "pages.reviewCenter.gameBet.compare.summary":
    "将商户游戏档位模板由 {before} 更换为 {after}。",
  "pages.reviewCenter.gameBet.field.betLevelName": "档位模板变更",
  "pages.reviewCenter.gameRtp.compare.title": "变更内容及数据",
  "pages.reviewCenter.gameRtp.compare.summaryLabel": "变更说明",
  "pages.reviewCenter.gameRtp.compare.summary":
    "调整游戏 RTP 各概率档位的权重配置。",
  "pages.reviewCenter.gameRtp.compare.loading": "正在加载 RTP 档位信息",
  "pages.reviewCenter.gameRtp.field.tierWithValue": "{value}档位",
  "pages.reviewCenter.gameRtp.field.tierFallback": "配置ID {id}",
  "pages.reviewCenter.gameRtp.field.tier.high": "高档",
  "pages.reviewCenter.gameRtp.field.tier.medium": "中档",
  "pages.reviewCenter.gameRtp.field.tier.low": "低档",
  "pages.reviewCenter.gameRtp.field.rtpMathVersion": "版本号",
  "pages.reviewCenter.gameRtp.field.overallRtp": "综合RTP",
  "pages.reviewCenter.newPlayer.compare.title": "变更内容及数据",
  "pages.reviewCenter.newPlayer.compare.summaryLabel": "变更说明",
  "pages.reviewCenter.newPlayer.compare.summary":
    "设置新手保护期的奖池积累与强制退出条件。",
  "pages.reviewCenter.risk.compare.title": "变更内容及数据",
  "pages.reviewCenter.risk.compare.summaryLabel": "变更说明",
  "pages.reviewCenter.risk.compare.summary":
    "统一收紧所有小游戏及全局的最大估付与单笔风控金额。",
  "pages.reviewCenter.compensateFreeSpin.field.timeRange": "活动时间",
  "pages.reviewCenter.compensateFreeSpin.field.totalEndTime":
    "活动抽奖结束时间",

  // 游戏跑单程序管理
  "pages.gameVerification.list.title": "跑单程序列表",
  "pages.gameVerification.action.add": "添加跑单程序",
  "pages.gameVerification.action.update": "更新",
  "pages.gameVerification.action.history": "历史",

  "pages.gameVerification.filter.searchGame": "搜索游戏",
  "pages.gameVerification.filter.searchGame.placeholder": "名称/ID",

  "pages.gameVerification.column.game": "归属游戏",
  "pages.gameVerification.column.gameVersion": "当前生效版本",
  "pages.gameVerification.column.fileName": "程序文件",
  "pages.gameVerification.column.updatedAt": "最后更新时间",
  "pages.gameVerification.column.nickName": "操作人",
  "pages.gameVerification.column.action": "操作",

  "pages.gameVerification.drawer.add.title": "上传跑单程序",
  "pages.gameVerification.drawer.update.title": "更新跑单程序",
  "pages.gameVerification.drawer.gameId": "归属游戏",
  "pages.gameVerification.drawer.gameId.required": "请选择归属游戏",
  "pages.gameVerification.drawer.gameVersion": "版本号",
  "pages.gameVerification.drawer.gameVersion.required": "请输入版本号",
  "pages.gameVerification.drawer.gameVersion.placeholder": "例如v3.4.3",
  "pages.gameVerification.drawer.gameVersion.selectGameFirst": "请先选择游戏",
  "pages.gameVerification.drawer.binPath": "程序文件",
  "pages.gameVerification.drawer.binPath.required": "请上传程序文件",
  "pages.gameVerification.drawer.dependencyZipPath": "依赖包",
  "pages.gameVerification.drawer.dependencyZipPath.desc":
    "部分游戏跑单需要上传相关依赖包，若有需要联系相关开发人员提供，依赖包包含跑单程序运目录的所有依赖文件/文件夹打包成zip上传即可",
  "pages.gameVerification.upload.placeholder": "请添加文件",
  "pages.gameVerification.drawer.updateDesc": "更新说明",
  "pages.gameVerification.drawer.add.submit": "确认上传",
  "pages.gameVerification.drawer.update.submit": "确认更新",
  "pages.gameVerification.drawer.add.success": "添加成功",
  "pages.gameVerification.drawer.update.success": "更新成功",

  "pages.gameVerification.history.title": "跑单程序版本历史 - {gameName}",
  "pages.gameVerification.history.version": "版本号",
  "pages.gameVerification.history.updateDesc": "版本说明",
  "pages.gameVerification.history.updatedAt": "更新时间",
  "pages.gameVerification.history.nickName": "操作人",
  "pages.gameVerification.history.action": "操作",
  "pages.gameVerification.history.download": "下载跑单程序",
  "pages.gameVerification.history.downloadDependency": "下载依赖包",
  "pages.gameVerification.history.latest": "最新",

  // 活动管理
  "pages.business.manage.tab.merchantFreeSpin": "累计Freespin",
  "pages.business.manage.tab.sevenFreeSpin": "7日FreeSpin",
  "pages.business.manage.filter.createdAt": "创建时间",
  "pages.business.manage.filter.keywords": "搜索活动",
  "pages.business.manage.filter.keywords.placeholder": "ID/名称",
  "pages.business.manage.filter.activityTime": "活动时间",
  "pages.business.manage.filter.approvalStatus": "审核状态",
  "pages.business.manage.filter.activityStatus": "活动状态",
  "pages.business.manage.column.id": "活动ID",
  "pages.business.manage.column.name": "活动名称",
  "pages.business.manage.column.game": "关联游戏",
  "pages.business.manage.column.appids": "应用商户",
  "pages.business.manage.column.activityStatus": "活动状态",
  "pages.business.manage.column.createdAt": "创建时间",
  "pages.business.manage.column.getTime": "领取时间",
  "pages.business.manage.column.useTime": "使用时间",
  "pages.business.manage.column.startTime": "开始时间",
  "pages.business.manage.column.endTime": "结束时间",
  "pages.business.manage.column.totalEndTime": "活动抽奖结束时间",
  "pages.business.manage.column.activityTime": "活动时间",
  "pages.business.manage.column.giftConfig": "赠送配置",
  "pages.business.manage.column.times": "次数",
  "pages.business.manage.column.level": "档位",
  "pages.business.manage.column.betMin": "下注门槛",
  "pages.business.manage.column.prizePool": "奖池金额",
  "pages.business.manage.column.betAmount": "下注门槛",
  "pages.business.manage.column.totalBonus": "奖池金额",
  "pages.business.manage.column.freeSpinCount": "赠送次数",
  "pages.business.manage.column.freeSpinBet": "投注挡位值",
  "pages.business.manage.column.approvalStatus": "审核状态",
  "pages.business.manage.column.dayConfig": "D{day}赠送配置",
  "pages.business.manage.action.copy": "复制",
  "pages.business.manage.action.detail": "详情",
  "pages.business.manage.action.delete": "删除",
  "pages.business.manage.action.edit": "编辑",
  "pages.business.manage.action.shelf": "上架/下架",
  "pages.business.manage.action.up": "上架",
  "pages.business.manage.action.publish": "发布",
  "pages.business.manage.action.down": "下架",
  "pages.business.manage.action.analysis": "数据分析",
  "pages.business.manage.action.add": "添加活动",
  "pages.business.manage.action.addDay": "新增天数",
  "pages.business.manage.analysis.title": "数据分析 - {name}",
  "pages.business.manage.analysis.subtitle": "活动ID：{id} | 活动时间：{time}",
  "pages.business.manage.analysis.action.search": "查询",
  "pages.business.manage.analysis.empty": "暂无分析数据",
  "pages.business.manage.analysis.dayTag": "第{day}天",
  "pages.business.manage.analysis.chart.title": "每日奖池消耗与用户参与走势",
  "pages.business.manage.analysis.chart.date": "日期",
  "pages.business.manage.analysis.chart.description":
    "展示每日消耗的奖金总额（折线图）与当天独立参与/旋转玩家数（柱状图）",
  "pages.business.manage.analysis.card.poolConsumed": "奖池消耗进度",
  "pages.business.manage.analysis.card.poolProgressLabel": "消耗进度",
  "pages.business.manage.analysis.card.poolConsumedFooter": "速度: {amount}",
  "pages.business.manage.analysis.card.poolConsumedEta": "消耗完毕",
  "pages.business.manage.analysis.card.poolOverBudgetWarning":
    "警告: 已超预算 {rate}",
  "pages.business.manage.analysis.card.poolOverBudgetAction": "兜底资金承接",
  "pages.business.manage.analysis.card.participants": "达标与参与人数",
  "pages.business.manage.analysis.card.participantsUv": "达标与参与人数（UV）",
  "pages.business.manage.analysis.card.participantsActivation":
    "渗透率 {activationRate}",
  "pages.business.manage.analysis.card.qualifiedUsersLabel": "门槛合格旋转玩家",
  "pages.business.manage.analysis.card.participantsDesc":
    "门槛达标人数 {qualifiedUsers}，激活率 {activationRate}",
  "pages.business.manage.analysis.card.freeSpinPv": "奖励旋转总次数",
  "pages.business.manage.analysis.card.freeSpinPvTotal": "免费旋转总次数（PV）",
  "pages.business.manage.analysis.card.freeSpinPvUnit": "次",
  "pages.business.manage.analysis.card.averageSpinsLabel": "人均旋转次数",
  "pages.business.manage.analysis.card.averageSpinsDesc":
    "人均领取次数 {averageSpins}",
  "pages.business.manage.analysis.card.merchantNet": "商户活动净收益",
  "pages.business.manage.analysis.card.merchantNetDesc":
    "触发前投注减返奖再减 FreeSpin 派彩后的收益",
  "pages.business.manage.analysis.card.freeSpinPayout": "FreeSpin 实际派彩",
  "pages.business.manage.analysis.card.freeSpinPayoutFs":
    "FREESPIN 实际派奖（FS PAYOUT）",
  "pages.business.manage.analysis.card.freeSpinPayoutDesc":
    "玩家通过 FS 奖励获取并完成的奖金总额",
  "pages.business.manage.analysis.card.betThresholdDesc":
    "奖池消耗阈值 {betThreshold}",
  "pages.business.manage.analysis.card.userStructure": "参与玩家结构",
  "pages.business.manage.analysis.card.userStructureMix":
    "参与玩家结构（新/老）",
  "pages.business.manage.analysis.card.newRateLabel": "新客: {count}（{rate}）",
  "pages.business.manage.analysis.card.oldRateLabel": "老客: {count}（{rate}）",
  "pages.business.manage.analysis.card.userStructureDesc":
    "新客 {newRate}，老客 {oldRate}",
  "pages.business.manage.analysis.section.dailyTrend": "每日数据趋势",
  "pages.business.manage.analysis.section.funnel": "设计消耗与转化漏斗",
  "pages.business.manage.analysis.section.funnelDescription":
    "商户优享各环节管控效率",
  "pages.business.manage.analysis.section.details": "核心指标明细",
  "pages.business.manage.analysis.reportList.title": "活动数据对账清单",
  "pages.business.manage.analysis.reportList.description":
    "当前视角：按日历日期明细统计。商户单级活动直接展示大盘及转化对账数据。",
  "pages.business.manage.analysis.reportList.total": "共 {total} 条",
  "pages.business.manage.analysis.reportList.date": "统计日期",
  "pages.business.manage.analysis.reportList.totalBetUsers":
    "总下注人数（大盘）",
  "pages.business.manage.analysis.reportList.dailyPayout": "当日消耗奖池金额",
  "pages.business.manage.analysis.reportList.cumulativePayout":
    "累计消耗奖池金额",
  "pages.business.manage.analysis.reportList.qualifiedUsers": "触发人数",
  "pages.business.manage.analysis.reportList.triggerRate": "触发率",
  "pages.business.manage.analysis.reportList.participantUsers": "SPIN人数",
  "pages.business.manage.analysis.reportList.activityConversionRate":
    "活动转化率",
  "pages.business.manage.analysis.reportList.freeSpinCount": "FREESPIN总次数",
  "pages.business.manage.analysis.table.date": "日期",
  "pages.business.manage.analysis.table.dayNo": "活动天数",
  "pages.business.manage.analysis.table.totalBetUsers": "付费下注人数",
  "pages.business.manage.analysis.table.qualifiedUsers": "达标人数",
  "pages.business.manage.analysis.table.participantUsers":
    "每日独立参与人数 (人)",
  "pages.business.manage.analysis.table.freeSpinCount": "FreeSpin 次数",
  "pages.business.manage.analysis.table.dailyPayout": "每日奖池消耗额 ($)",
  "pages.business.manage.analysis.table.cumulativePayout": "累计派彩",
  "pages.business.manage.analysis.table.triggerRate": "触发率",
  "pages.business.manage.analysis.table.activityConversionRate": "活动转化率",
  "pages.business.manage.analysis.detail.totalBetUsers": "活动期付费下注人数",
  "pages.business.manage.analysis.detail.qualifiedUsers": "满足门槛人数",
  "pages.business.manage.analysis.detail.participantUsers": "实际参与人数",
  "pages.business.manage.analysis.detail.claimRate": "领取转化率",
  "pages.business.manage.analysis.detail.usageRate": "使用转化率",
  "pages.business.manage.analysis.detail.poolProgress": "奖池消耗率",
  "pages.business.manage.analysis.funnel.qualifiedUsers": "满足门槛用户",
  "pages.business.manage.analysis.funnel.claimedUsers": "领取用户",
  "pages.business.manage.analysis.funnel.participantUsers":
    "参与 FreeSpin 用户",
  "pages.business.manage.analysis.funnel.usedUsers": "产生 FreeSpin 订单用户",
  "pages.business.manage.analysis.funnel.stage1": "第一阶段：触发门槛并激活",
  "pages.business.manage.analysis.funnel.stage2":
    "第二阶段：实际参与 FreeSpin 玩家数",
  "pages.business.manage.analysis.funnel.stage3":
    "第三阶段：产生二次投注转化玩家数",
  "pages.business.manage.analysis.funnel.baseTag": "基准",
  "pages.business.manage.analysis.insight.highActivation":
    "活动参与转化较高，当前机制对目标用户具备较强吸引力。",
  "pages.business.manage.analysis.insight.highPoolUsage":
    "奖池消耗已经较高，建议同步关注预算消耗与后续派奖节奏。",
  "pages.business.manage.analysis.insight.default":
    "可结合每日趋势与漏斗转化，继续观察活动触发和使用效率。",
  "pages.business.manage.analysis.unit.users": "人",
  "pages.business.manage.analysis.unit.newUsers": "新客",
  "pages.business.manage.sevenAnalysis.section.stages":
    "D1 ~ D7 各子池燃烧对照组",
  "pages.business.manage.sevenAnalysis.section.stagesDescription":
    "展示各阶段预算消耗、门槛与奖励配置。",
  "pages.business.manage.sevenAnalysis.section.stagesOverBudget":
    "关于子池已触发爆池防护",
  "pages.business.manage.sevenAnalysis.stage.day": "D{day}阶段",
  "pages.business.manage.sevenAnalysis.stage.threshold": "门槛",
  "pages.business.manage.sevenAnalysis.stage.reward": "奖",
  "pages.business.manage.sevenAnalysis.chart.title":
    "D1 ~ D7 连续晋级触发与消耗趋势",
  "pages.business.manage.sevenAnalysis.chart.description":
    "展示各阶段奖池消耗额与实际参与人数的变化趋势。",
  "pages.business.manage.sevenAnalysis.chart.dailyPayout": "阶段奖金消耗额 ($)",
  "pages.business.manage.sevenAnalysis.chart.participantUsers":
    "阶段触达人数 (人)",
  "pages.business.manage.sevenAnalysis.chart.leftAxisTitle": "阶梯奖金消耗($)",
  "pages.business.manage.sevenAnalysis.chart.rightAxisTitle":
    "阶梯达标人数 (人)",
  "pages.business.manage.sevenAnalysis.card.d7RetentionRate": "D7 通关留存率",
  "pages.business.manage.sevenAnalysis.card.d7RetentionDesc":
    "D1 达标: {d1}人 | D7 达标: {d7}人",
  "pages.business.manage.sevenAnalysis.card.averageActiveDays":
    "人均连续活跃达标天数",
  "pages.business.manage.sevenAnalysis.card.averageActiveDaysDesc":
    "体现参与用户跨阶段连续达标的粘性深度",
  "pages.business.manage.sevenAnalysis.section.retention":
    "时序：递进式留存衰减 (D1 ~ D7)",
  "pages.business.manage.sevenAnalysis.section.retentionDescription":
    "展示玩家成功获得并达到后续每天门槛人数的时序衰减结构",
  "pages.business.manage.sevenAnalysis.retention.dayQualified":
    "D{day} 达标资格人数",
  "pages.business.manage.sevenAnalysis.retention.insight":
    "当前 D6 为 {d6} 人、D7 为 {d7} 人，建议结合末段衰减判断最后两天奖励是否仍具承接力。",
  "pages.business.manage.sevenAnalysis.section.conversion":
    "行为：用户转化漏斗",
  "pages.business.manage.sevenAnalysis.section.conversionDescription":
    "展示达标、领取与实际消耗链路的转化效率",
  "pages.business.manage.sevenAnalysis.funnel.achieved":
    "第一阶段：触达活动门槛 (Achieved)",
  "pages.business.manage.sevenAnalysis.funnel.claimed":
    "第二阶段：成功领取 FreeSpin (Get)",
  "pages.business.manage.sevenAnalysis.funnel.used":
    "第三阶段：实际消耗 FreeSpin (Used)",
  "pages.business.manage.sevenAnalysis.funnel.claimRateLabel":
    "领取率 (Claim Rate)",
  "pages.business.manage.sevenAnalysis.funnel.usageRateLabel":
    "使用率 (Usage Rate)",
  "pages.business.manage.sevenAnalysis.funnel.selector.overall": "整体活动累计",
  "pages.business.manage.sevenAnalysis.funnel.selector.day": "D{day} 阶段",
  "pages.business.manage.sevenAnalysis.insight.lowRetention":
    "趋势警示：D7 留存仅 {rate}，建议重点复核后半程门槛与预算配置。",
  "pages.business.manage.sevenAnalysis.insight.highConsumption":
    "趋势洞察：当前总奖池已消耗 {rate}，建议同步关注后续阶段派奖节奏。",
  "pages.business.manage.sevenAnalysis.insight.healthyRetention":
    "趋势表现：当前 D7 留存为 {rate}，整体阶段承接相对平稳。",
  "pages.business.manage.sevenAnalysis.conversionAdvice":
    "运营提效建议：当前领取转化率良好 ({claimRate})，使用率极高 ({usageRate})。建议对到期未领的用户发起提示。",
  "pages.business.manage.sevenAnalysis.unit.days": "天",
  "pages.business.manage.sevenAnalysis.matrix.title":
    "活动数据对账清单（D1-D7 每日交叉矩阵）",
  "pages.business.manage.sevenAnalysis.matrix.description":
    "配合后端埋点，直观呈现各阶关卡与自然日期的多维流水透视对账。",
  "pages.business.manage.sevenAnalysis.matrix.hint":
    "此网格横轴展示阶梯关卡 D1-D7，纵轴为自然日历日期。当前每个单元格包含 5 维明细数据（当日消耗、累计消耗、触发人数、Spin人数、Spin次数）。由于玩家跨天注册与通关进度不同，本矩阵能够精准还原每天里各个关卡的瞬间燃烧账目。",
  "pages.business.manage.sevenAnalysis.matrix.colDailyPayout": "当日消耗",
  "pages.business.manage.sevenAnalysis.matrix.colCumulativePayout": "累计消耗",
  "pages.business.manage.sevenAnalysis.matrix.colQualifiedUsers": "触发人数",
  "pages.business.manage.sevenAnalysis.matrix.colParticipantUsers": "Spin人数",
  "pages.business.manage.sevenAnalysis.matrix.colFreeSpinCount": "Spin次数",
  "pages.business.manage.sevenAnalysis.matrix.calendarDate": "日历日期",
  "pages.business.manage.sevenAnalysis.matrix.emptyCell": "—",
  "pages.business.manage.sevenAnalysis.tooltip.poolConsumed":
    "活动期间所有玩家已领取的免费旋转价值金额总和",
  "pages.business.manage.sevenAnalysis.tooltip.participantsUv":
    "渗透率=活动期间达到门槛金额且实际进行了免费旋转的玩家数/达到门槛金额的转化比例",
  "pages.business.manage.sevenAnalysis.tooltip.freeSpinPv":
    "活动期间所有玩家累计消耗的FreeSpin 总次数即人均旋转次数",
  "pages.business.manage.sevenAnalysis.tooltip.userStructure":
    "参与活动的玩家中，新用户(在活动期间，在平台完成首次下注的玩家)与老用户(活动开始前就已经完成下注)的占比分布",
  "pages.business.manage.sevenAnalysis.tooltip.d7Retention":
    "从首日（D1）达到门槛金额玩家中，一路坚持并成功达到最后一天（D7）门槛金额的玩家比例。",
  "pages.business.manage.sevenAnalysis.tooltip.averageActiveDays":
    "参与活动的玩家在 D1~D7 阶梯 FreeSpin 活动中平均连续达到门槛的天数",
  "pages.business.manage.sevenAnalysis.tooltip.freeSpinPayout":
    "玩家使用赠送的FreeSpin 进行spin时，总返奖金额",
  "pages.business.manage.sevenAnalysis.tooltip.merchantNet":
    "活动带来的GGR(下注金额-返奖金额)扣除免费旋转返奖后的商户最终纯利润。活动净收益=(下注金额-返奖金额)-(免费旋转返奖金额)",
  "pages.business.manage.sevenAnalysis.card.poolConsumed": "7日总奖池消耗累计",
  "pages.business.manage.drawer.title.add": "新增累计Freespin",
  "pages.business.manage.drawer.title.edit": "编辑累计Freespin",
  "pages.business.manage.seven.drawer.title.add": "新增7日FreeSpin",
  "pages.business.manage.seven.drawer.title.edit": "编辑7日FreeSpin",
  "pages.business.manage.drawer.placeholder.name": "请输入活动名称",
  "pages.business.manage.drawer.placeholder.game": "请选择游戏",
  "pages.business.manage.drawer.placeholder.appids": "请选择商户",
  "pages.business.manage.drawer.activityTime": "活动时间",
  "pages.business.manage.drawer.totalEndTime": "活动抽奖结束时间",
  "pages.business.manage.drawer.beijingTimeDesc": "当前使用时间为北京时间",
  "pages.business.manage.drawer.saveDraft": "保存",
  "pages.business.manage.drawer.saveAndPublish": "保存并发布",
  "pages.business.manage.drawer.tooltip.betAmount":
    "参与FreeSpin活动需要投入的累计门槛金额",
  "pages.business.manage.drawer.tooltip.freeSpinCount":
    "FreeSpin活动赠送的免费投注次数",
  "pages.business.manage.drawer.tooltip.freeSpinBet": "免费投注的挡位值",
  "pages.business.manage.drawer.message.missingId": "活动ID缺失，无法提交编辑",
  "pages.business.manage.drawer.message.numberRequired": "请输入数值，不能为空",
  "pages.business.manage.drawer.message.activityEndAfterStart":
    "活动结束时间必须大于等于活动开始时间",
  "pages.business.manage.drawer.message.getEndAfterGetStart":
    "领取结束时间必须大于领取开始时间",
  "pages.business.manage.drawer.message.useStartAfterGetStart":
    "使用开始时间必须大于领取开始时间",
  "pages.business.manage.drawer.message.useEndAfterGetStart":
    "使用结束时间必须大于领取开始时间",
  "pages.business.manage.modal.delete.title": "确认删除活动？",
  "pages.business.manage.modal.delete.content":
    "删除后，活动数据无法恢复，请谨慎操作！",
  "pages.business.manage.modal.up.title": "提交发布活动申请",
  "pages.business.manage.modal.up.content":
    "发布活动前需要审核人审核通过后，才能正式发布。确认提交发布申请？",
  "pages.business.manage.modal.down.title": "提交下架活动申请",
  "pages.business.manage.modal.down.content":
    "下架活动前需要审核人审核通过后，才能完成下架。确认提交下架申请？",
  "pages.business.manage.modal.publish.content": "确认发布该活动吗？",
  "pages.business.manage.message.deleteBlockedReviewing":
    "该活动处于审核中状态，无法删除",
  "pages.business.manage.message.deleteBlockedEnabled":
    "该活动已启用，无法删除",
  "pages.business.manage.message.editBlockedReviewing":
    "该活动处于审核中，无法编辑",
  "pages.business.manage.message.editBlockedOnShelf": "该活动已上架，无法编辑",
  "pages.business.manage.message.editBlockedExpired": "该活动已过期，无法编辑",
  "pages.business.manage.message.deleteBlockedExpired":
    "该活动已过期，无法删除",
  "pages.business.manage.message.downBlockedReviewing":
    "该活动处于审核中，无法下架",
  "pages.business.manage.message.deleteSuccess": "删除成功",
  "pages.business.manage.message.upSubmitSuccess": "提交发布申请成功",
  "pages.business.manage.message.downSubmitSuccess": "提交下架申请成功",
  "pages.business.manage.message.publishSuccess": "发布成功",

  // 活动管理 - 审核状态
  "pages.business.manage.approvalStatus.pendingSubmit": "待提交",
  "pages.business.manage.approvalStatus.onShelfReview": "上架审核中",
  "pages.business.manage.approvalStatus.onShelfRejected": "上架被驳回",
  "pages.business.manage.approvalStatus.onShelf": "已发布",
  "pages.business.manage.approvalStatus.offShelfReview": "下架审核中",
  "pages.business.manage.approvalStatus.offShelfRejected": "下架被驳回",
  "pages.business.manage.approvalStatus.offShelf": "已下架",

  // 7日 FreeSpin - 审核状态
  "pages.business.manage.seven.approvalStatus.pendingSubmit": "待提交",
  "pages.business.manage.seven.approvalStatus.onShelfReview": "上架审核中",
  "pages.business.manage.seven.approvalStatus.onShelfRejected": "上架被驳回",
  "pages.business.manage.seven.approvalStatus.onShelf": "已上架",
  "pages.business.manage.seven.approvalStatus.offShelfReview": "下架审核中",
  "pages.business.manage.seven.approvalStatus.offShelfRejected": "下架被驳回",
  "pages.business.manage.seven.approvalStatus.offShelf": "已下架",
  "pages.business.manage.seven.filter.approvalStatus.pendingPublish": "待发布",
  "pages.business.manage.seven.filter.approvalStatus.underReview": "审核中",
  "pages.business.manage.seven.filter.approvalStatus.published": "已发布",
  "pages.business.manage.seven.filter.approvalStatus.rejected": "已拒绝",

  // 活动管理 - 统一审核状态（列表 + 筛选）
  "pages.business.manage.activityApprovalStatus.pendingPublish": "待发布",
  "pages.business.manage.activityApprovalStatus.underReview": "审核中",
  "pages.business.manage.activityApprovalStatus.published": "已发布",
  "pages.business.manage.activityApprovalStatus.rejected": "已拒绝",

  // 活动管理 - 活动状态
  "pages.business.manage.activityStatus.pendingStart": "待开始",
  "pages.business.manage.activityStatus.inProgress": "进行中",
  "pages.business.manage.activityStatus.expired": "已过期",
  "pages.business.manage.activityStatus.offShelf": "已下架",

  // 赠送记录
  "pages.business.giftspin.column.userId": "用户ID",
  "pages.business.giftspin.column.merchantName": "商户名称",
  "pages.business.giftspin.column.activityName": "活动名称",
  "pages.business.giftspin.column.game": "关联游戏",
  "pages.business.giftspin.column.spinCount": "赠送次数",
  "pages.business.giftspin.column.betLevel": "挡位值",
  "pages.business.giftspin.column.costEstimate": "成本估算",
  "pages.business.giftspin.column.remark": "备注",
  "pages.business.giftspin.column.approvalStatus": "审核状态",
  "pages.business.giftspin.column.executeStatus": "执行状态",
  "pages.business.giftspin.column.id": "记录ID",
  "pages.business.giftspin.column.operator": "申请人",
  "pages.business.giftspin.column.operateTime": "操作时间",
  "pages.business.giftspin.column.createdAt": "创建时间",
  "pages.business.giftspin.column.activityTime": "活动时间",
  "pages.business.giftspin.column.startTime": "活动开始时间",
  "pages.business.giftspin.column.endTime": "活动结束时间",
  "pages.business.giftspin.column.totalEndTime": "抽奖结束时间",
  "pages.business.giftspin.filter.time": "时间范围",
  "pages.business.giftspin.filter.keywords": "用户ID",
  "pages.business.giftspin.filter.keywords.placeholder": "请输入用户ID",
  "pages.business.giftspin.filter.merchant": "商户筛选",
  "pages.business.giftspin.filter.game": "游戏筛选",
  "pages.business.giftspin.filter.status": "审核状态",
  "pages.business.giftspin.action.create": "赠送FreeSpin",
  "pages.business.giftspin.action.confirmGrant": "确认赠送",
  "pages.business.giftspin.action.detail": "详情",
  "pages.business.giftspin.drawer.create.title": "赠送FreeSpin次数",
  "pages.business.giftspin.drawer.detail.title": "赠送记录详情",
  "pages.business.giftspin.detail.applicant": "申请人",
  "pages.business.giftspin.form.game": "关联游戏",
  "pages.business.giftspin.form.game.placeholder": "请选择游戏",
  "pages.business.giftspin.form.merchant": "应用商户",
  "pages.business.giftspin.form.merchant.placeholder": "请选择商户",
  "pages.business.giftspin.form.activityTime": "活动开始时间",
  "pages.business.giftspin.form.totalEndTime": "活动抽奖结束时间",
  "pages.business.giftspin.form.totalBonus": "奖池金额",
  "pages.business.giftspin.form.freeSpinCount": "赠送次数",
  "pages.business.giftspin.form.freeSpinCount.suffix": "次",
  "pages.business.giftspin.form.freeSpinBet": "投注挡位值",
  "pages.business.giftspin.form.roleIds": "用户ID",
  "pages.business.giftspin.form.roleIds.placeholder":
    "请输入用户ID，支持同时赠送多个用户，用英文逗号分隔",
  "pages.business.giftspin.form.roleIds.required": "请输入用户ID",
  "pages.business.giftspin.form.roleIds.max": "最多支持输入1000个用户ID",
  "pages.business.giftspin.form.remark": "备注",
  "pages.business.giftspin.form.remark.placeholder": "选填...",
  "pages.business.giftspin.form.message.numberRequired": "请输入数值",
  "pages.business.giftspin.message.grantSuccess": "赠送成功",
  "pages.business.giftspin.message.submitReviewSuccess": "提交审核成功",
  "pages.business.giftspin.approvalStatus.pendingPublish": "待发布",
  "pages.business.giftspin.approvalStatus.underReview": "审核中",
  "pages.business.giftspin.approvalStatus.published": "已发布",
  "pages.business.giftspin.approvalStatus.rejected": "已拒绝",
  "pages.business.giftspin.executeStatus.unexecuted": "未执行",
  "pages.business.giftspin.executeStatus.executed": "已执行",

  // 用户白名单
  "pages.business.whitelist.column.merchantId": "商户ID",
  "pages.business.whitelist.column.merchantName": "商户名称",
  "pages.business.whitelist.column.agent1": "一级代理",
  "pages.business.whitelist.column.agent2": "二级代理",
  "pages.business.whitelist.column.userId": "用户ID",
  "pages.business.whitelist.column.validTime": "有效时间",
  "pages.business.whitelist.column.useScene": "使用场景",
  "pages.business.whitelist.column.status": "状态",
  "pages.business.whitelist.column.operation": "操作",
  "pages.business.whitelist.filter.merchant": "选择商户",
  "pages.business.whitelist.filter.merchantPlaceholder": "请选择商户",
  "pages.business.whitelist.filter.userId": "用户ID",
  "pages.business.whitelist.filter.userIdPlaceholder": "请输入用户ID",
  "pages.business.whitelist.filter.status": "状态",
  "pages.business.whitelist.filter.statusPlaceholder": "请选择状态",
  "pages.business.whitelist.filter.enabled": "启用",
  "pages.business.whitelist.filter.disabled": "停用",
  "pages.business.whitelist.action.edit": "编辑",
  "pages.business.whitelist.action.enable": "启用",
  "pages.business.whitelist.action.disable": "停用",
  "pages.business.whitelist.action.add": "添加白名单",
  "pages.business.whitelist.action.export": "导出",
  "pages.business.whitelist.action.batchEdit": "批量编辑",
  "pages.business.whitelist.action.batchEnable": "批量启用",
  "pages.business.whitelist.action.batchDisable": "批量停用",
  "pages.business.whitelist.action.saveAndEnable": "保存并启用",
  "pages.business.whitelist.export.filename": "用户白名单_",
  "pages.business.whitelist.selection.selected": "已选{count}项",
  "pages.business.whitelist.drawer.create.title": "添加白名单",
  "pages.business.whitelist.drawer.edit.title": "编辑白名单",
  "pages.business.whitelist.drawer.batchEdit.title": "批量编辑白名单",
  "pages.business.whitelist.form.merchant": "应用商户",
  "pages.business.whitelist.form.merchantPlaceholder": "请选择商户",
  "pages.business.whitelist.form.effectiveTime": "生效时间",
  "pages.business.whitelist.form.timezoneHint":
    "配置时区为北京时间，请注意跟随运营地区所在时间",
  "pages.business.whitelist.form.useScene": "使用场景",
  "pages.business.whitelist.form.userId": "用户ID",
  "pages.business.whitelist.form.userIdPlaceholder":
    "请输入用户ID，支持同时输入多个用户，用英文逗号分隔",
  "pages.business.whitelist.form.userIdRequired": "请输入用户ID",
  "pages.business.whitelist.form.selectedRecords": "选择记录",
  "pages.business.whitelist.form.selectedRecordsValue": "记录 IDs：{ids}",
  "pages.business.whitelist.form.remark": "备注",
  "pages.business.whitelist.form.remarkPlaceholder": "选填",
  "pages.business.whitelist.message.missingIds": "未找到要编辑的白名单记录",
  "pages.business.whitelist.message.saveSuccess": "保存成功",
  "pages.business.whitelist.message.disableSuccess": "停用成功",
  "pages.business.whitelist.message.enableSuccess": "启用成功",
  "pages.business.whitelist.status.disableTitle": "确认停用白名单用户",
  "pages.business.whitelist.status.enableTitle": "确认启用白名单用户",
  "pages.business.whitelist.status.singleDisableDescription":
    "你正在停用商户{merchant}下用户{userId}的白名单。",
  "pages.business.whitelist.status.singleEnableDescription":
    "你正在启用商户{merchant}下用户{userId}的白名单。",
  "pages.business.whitelist.status.batchDisableDescription":
    "你正在停用已选{count}个白名单用户（用户ID：{userIds}）。",
  "pages.business.whitelist.status.batchEnableDescription":
    "你正在启用已选{count}个白名单用户（用户ID：{userIds}）。",
  "pages.business.whitelist.status.disableNotice":
    "停用后该用户后续下注将立刻恢复为常规 RTP 环境，且订单恢复常规统计。",
  "pages.business.whitelist.status.enableNotice":
    "启用后该用户后续下注将立刻切换至白名单专属RTP环境，且订单不计入常规统计。",
  "pages.business.whitelist.status.disableReason": "停用原因",
  "pages.business.whitelist.status.enableReason": "启用原因",
  "pages.business.whitelist.status.reasonRequired": "请输入操作原因",
  "pages.business.whitelist.status.reasonPlaceholder": "请填写操作原因，必填",
  "pages.business.whitelist.status.notEffective": "未生效",
  "pages.business.whitelist.status.effective": "生效中",
  "pages.business.whitelist.status.expired": "已到期",
  "pages.business.whitelist.status.disabled": "已停用",
  "pages.business.whitelist.useScene.live": "主播直播",
  "pages.business.whitelist.useScene.channel": "渠道推广",
  "pages.business.whitelist.useScene.internal": "内部演示",
  "pages.business.whitelist.useScene.other": "其他",
  "pages.business.whitelist.empty": "暂无白名单数据",
  "pages.business.whitelist.message.operationPending": "待补充业务操作接口契约",

  "pages.business.whitelistRecord.column.betId": "下注ID",
  "pages.business.whitelistRecord.column.merchantName": "商户名称",
  "pages.business.whitelistRecord.column.merchantId": "商户ID",
  "pages.business.whitelistRecord.column.parentOperator": "直属上级",
  "pages.business.whitelistRecord.column.operatorPath": "归属路径",
  "pages.business.whitelistRecord.column.userId": "用户ID",
  "pages.business.whitelistRecord.column.gameId": "游戏ID",
  "pages.business.whitelistRecord.column.gameName": "游戏名称",
  "pages.business.whitelistRecord.column.currency": "币种",
  "pages.business.whitelistRecord.column.betAmount": "下注金额",
  "pages.business.whitelistRecord.column.scoreAmount": "返奖金额（用户侧）",
  "pages.business.whitelistRecord.column.winAmount": "盈亏金额（平台侧）",
  "pages.business.whitelistRecord.column.surplusCoin": "钱包余额",
  "pages.business.whitelistRecord.column.freespinType": "Freespin类型",
  "pages.business.whitelistRecord.column.freespinAmount": "Freespin金额",
  "pages.business.whitelistRecord.column.gameMode": "游戏模式",
  "pages.business.whitelistRecord.column.cascadeType": "级联模式",
  "pages.business.whitelistRecord.cascadeType.none": "-",
  "pages.business.whitelistRecord.cascadeType.normalOrder": "订单级联",
  "pages.business.whitelistRecord.cascadeType.miniGame": "小游戏",
  "pages.business.whitelistRecord.column.betTime": "下注时间",
  "pages.business.whitelistRecord.column.settlementTime": "结算时间",
  "pages.business.whitelistRecord.column.ip": "下注IP",
  "pages.business.whitelistRecord.column.action": "操作",
  "pages.business.whitelistRecord.filter.timeRange": "下注时间",
  "pages.business.whitelistRecord.filter.betId": "下注ID",
  "pages.business.whitelistRecord.filter.betIdPlaceholder": "请输入ID",
  "pages.business.whitelistRecord.filter.userId": "用户ID",
  "pages.business.whitelistRecord.filter.userIdPlaceholder": "请输入用户ID",
  "pages.business.whitelistRecord.filter.game": "游戏",
  "pages.business.whitelistRecord.filter.currency": "币种",
  "pages.business.whitelistRecord.filter.merchant": "选择商户",
  "pages.business.whitelistRecord.filter.betAmount": "下注金额",
  "pages.business.whitelistRecord.filter.betAmountMinPlaceholder": "最低下注",
  "pages.business.whitelistRecord.filter.betAmountMaxPlaceholder": "最高下注",
  "pages.business.whitelistRecord.filter.freespinType": "Freespin类型",
  "pages.business.whitelistRecord.filter.freespinType.merchant": "累计",
  "pages.business.whitelistRecord.filter.freespinType.platform": "平台",
  "pages.business.whitelistRecord.filter.freespinType.sevenDay": "七日",
  "pages.business.whitelistRecord.filter.gameMode": "游戏模式",
  "pages.business.whitelistRecord.type.merchantFreespin": "累计",
  "pages.business.whitelistRecord.type.platformFreespin": "平台",
  "pages.business.whitelistRecord.type.sevenDayFreespin": "七日",
  "pages.business.whitelistRecord.overview.title": "数据总览",
  "pages.business.whitelistRecord.overview.tooltip.totalBetAmount":
    "总下注金额：在当前筛选条件下，白名单用户的累计下注金额",
  "pages.business.whitelistRecord.overview.tooltip.totalScoreAmount":
    "总返奖金额：在当前筛选条件下，白名单所有用户的累计返奖金额。（注：总返奖金额不含活动彩金）",
  "pages.business.whitelistRecord.overview.tooltip.totalWinAmount":
    "总盈亏（平台侧）：在当前筛选条件下，平台侧的累计盈亏金额。",
  "pages.business.whitelistRecord.overview.tooltip.totalWinAmountFormula":
    "总盈亏=总下注金额-【总返奖金额+累计FreeSpin】",
  "pages.business.whitelistRecord.overview.tooltip.platformFreespinAmount":
    "平台Freespin金额：在当前筛选条件下，商户侧提供Freespin，白名单用户的Freespin金额",
  "pages.business.whitelistRecord.overview.tooltip.merchantFreespinAmount":
    "累计FreeSpin金额：在当前筛选条件下，游戏渠道侧提供Freespin，白名单的Freespin金额",
  "pages.business.whitelistRecord.overview.totalBetAmount": "总下注金额",
  "pages.business.whitelistRecord.overview.totalScoreAmount": "总返奖金额",
  "pages.business.whitelistRecord.overview.totalWinAmount": "总盈亏（平台侧）",
  "pages.business.whitelistRecord.overview.platformFreespinAmount":
    "平台Freespin金额",
  "pages.business.whitelistRecord.overview.merchantFreespinAmount":
    "累计freeSpin金额",
  "pages.business.whitelistRecord.action.export": "导出",
  "pages.business.whitelistRecord.action.replay": "回放",
  "pages.business.whitelistRecord.export.filename": "白名单下注记录_",
  "pages.business.whitelistRecord.message.exportFailed": "导出失败",
  "pages.business.whitelistRecord.sortTip":
    "*金额相关的排序，均在操作完成后进行排序",
  "pages.business.whitelistRecord.pagination.total": "共 {total} 条数据",
  "pages.business.whitelistRecord.empty": "暂无白名单下注记录",
  "pages.reviewCenter.gameHall.name": "游戏大厅配置",
  "pages.reviewCenter.gameHall.title": "游戏大厅配置详情",
  "pages.reviewCenter.gameHall.section.switches": "大厅开关",
  "pages.reviewCenter.gameHall.section.activities": "活动配置",
  "pages.reviewCenter.gameHall.section.games": "游戏配置",
  "pages.reviewCenter.gameHall.field.item": "配置项",
  "pages.reviewCenter.gameHall.field.hallSwitch": "大厅总开关",
  "pages.reviewCenter.gameHall.field.activitySwitch": "活动展示开关",
  "pages.reviewCenter.gameHall.field.gameSwitch": "游戏展示开关",
  "pages.reviewCenter.gameHall.field.activityId": "活动 ID",
  "pages.reviewCenter.gameHall.field.activityType": "活动类型",
  "pages.reviewCenter.gameHall.field.gameId": "游戏 ID",
  "pages.reviewCenter.gameHall.field.badge": "角标",
  "pages.reviewCenter.gameHall.field.weight": "权重",
  "pages.reviewCenter.gameHall.field.visible": "展示",
  "pages.reviewCenter.gameHall.value.enabled": "开启",
  "pages.reviewCenter.gameHall.value.disabled": "关闭",
  "pages.reviewCenter.gameHall.empty": "暂无配置数据",
};
